import { useState, useEffect, useContext, useRef } from 'react'
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Menu from '../../components/DashboardAdmin/Menu';
import AuthContext from '../../Context/auth';
import axios from 'axios';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Loader from '../../components/Global/Loader';
import LangContext from '../../Context/lang';
import LoadData from '../../components/Global/LoadData';
import BankContext from '../../Context/bank';

import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import downloadjs from "downloadjs";


import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

const UpdateVendeur = ({ Step, setStep, StepTitel, setFormdata, dar, Local }) => {

    const { bankActive, GetTaksitPrice } = useContext(BankContext);


    function PrintPDF() {

        var datapdf = [];
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
            foo: {
              bold: `${window.location.origin}/fonts/ARIALBD 1.ttf`,
              normal: `${window.location.origin}/fonts/ARIAL.ttf`
            }
          };

        const title = [
            // {
            //    margin: [ 5, 2, 10, 20 ],
            // //    snow: 'https://www.alsalamalgeria.com/themes/simpless/images/logo.png'
            // },
            // {
            //     // is supported loading images via url from reference by name in images
            //     Image: 'https://www.alsalamalgeria.com/themes/simpless/images/logo.png'
            //   },

            {
                // alignment: 'justify',
                // columnGap: 20,
                columns: [
                    {
                        margin: [0, 10, 0, 17],
                        text: [
                            { text: 'Incubateur / accélérateur IAMAL \n', fontSize: 9, bold: true },
                            { text: `Mob : 0661 80 63 58 \n`, fontSize: 8, bold: true },
                            { text: `E-mail : contact@iamal.dz \n`, fontSize: 8, bold: true },
                            { text: `Siège : 02, Lotissement des Jeunes Aveugles Draria, Alger \n`, fontSize: 8, bold: true },
                            { text: 'R.C : 16/00 - 1019525 B 23 \n', fontSize: 8, bold: true },
                            { text: `NIF : 2316101952574 \n`, fontSize: 8, bold: true },
                            { text: `Site marchand : www.iamal.dz \n`, fontSize: 8, bold: true },

                        ]
                    },
                    {
                        width: '20%',
                        margin: [0, 18, 18, 4],
                        // If no width/height/fit is used, then dimensions from the svg element is used.
                        svg: `
                        <svg xmlns="http://www.w3.org/2000/svg" width="271.733" height="94.661" viewBox="0 0 271.733 94.661">
    <g id="Groupe_136" data-name="Groupe 136" transform="translate(557 -159.89)">
    <path id="Tracé_9339" data-name="Tracé 9339" d="M-516.566,159.89c.2.155.455.088.682.14a3.679,3.679,0,0,1,2.874,3.134,8.009,8.009,0,0,1,.149,1.668q.025,9.818.045,19.636c0,2.306.034,4.614-.007,6.919-.056,3.1-.034,6.2-.078,9.306a5.734,5.734,0,0,0,.172,1.56,1.836,1.836,0,0,0,1.512,1.4,8.63,8.63,0,0,0,2.384.056c1.119-.066,2.238-.063,3.357-.066,2.63-.006,5.261.018,7.892.028.611,0,.559.023.557-.543-.008-3.357-.026-6.715-.022-10.072,0-2.255,0-4.511.064-6.764a22.152,22.152,0,0,1,1-6.557,10.374,10.374,0,0,1,3.975-5.447,10.12,10.12,0,0,1,4.539-1.671,51.1,51.1,0,0,1,5.378-.343c.372-.006.744-.041,1.117-.045a64.385,64.385,0,0,1,6.908.293,20.983,20.983,0,0,1,3.018.433,10.036,10.036,0,0,1,7.739,7.663,13.987,13.987,0,0,1,.435,3.318c.132,5.594.083,11.189.067,16.784a6.48,6.48,0,0,0,.109,1.666,1.632,1.632,0,0,0,1.321,1.257,3.786,3.786,0,0,0,.959.1c4.648-.146,9.3-.07,13.947-.087.545,0,1.08-.1,1.621-.144.219-.018.343-.114.312-.358a2.8,2.8,0,0,1,0-.356c0-5.037-.011-10.074.006-15.111a41.959,41.959,0,0,1,.18-4.721,13.621,13.621,0,0,1,1.663-5.4,9.943,9.943,0,0,1,5.729-4.456,18,18,0,0,1,4.285-.815c2.523-.192,5.052-.2,7.578-.155,1.967.038,3.935.044,5.9.094a14.71,14.71,0,0,1,7.221,2.179,14.848,14.848,0,0,1,3.045,2.2,3.389,3.389,0,0,1,.871,3.818,6.6,6.6,0,0,1-1.651,2.593,3.511,3.511,0,0,1-3.816.776,4.76,4.76,0,0,1-.957-.469,16.766,16.766,0,0,0-7.069-2.387,37.809,37.809,0,0,0-7.007-.021c-1.1.077-2.2.115-3.3.229a5.708,5.708,0,0,0-.994.2,3.385,3.385,0,0,0-2.429,2.444,8.159,8.159,0,0,0-.3,2.312q-.012,6.029,0,12.057a9.284,9.284,0,0,0,.237,2.065,3.986,3.986,0,0,0,3.347,3.2,9.791,9.791,0,0,0,1.969.206c3.971.014,7.943.043,11.914.028,1.85-.007,3.7.009,5.549.014a7.5,7.5,0,0,1,2.01.271,3.43,3.43,0,0,1,2.683,2.92,6.6,6.6,0,0,1-.063,2.625,3.708,3.708,0,0,1-2.682,2.795,10.606,10.606,0,0,1-2.97.339c-2.443.071-4.887.073-7.329.038q-6.644-.093-13.287-.032c-10.828.084-21.656.012-32.484.034a15.47,15.47,0,0,1-2.331-.167,2.755,2.755,0,0,1-2.637-2.684,24.713,24.713,0,0,1-.122-3.552c.027-1.645,0-3.29.041-4.934.073-2.966.055-5.933.109-8.9.032-1.763.031-3.526.024-5.288a15.193,15.193,0,0,0-.236-2.678,3.614,3.614,0,0,0-3.118-3.114,20.8,20.8,0,0,0-3.948-.326,43.725,43.725,0,0,0-5.028.238,6.57,6.57,0,0,0-1.534.347,3.528,3.528,0,0,0-2.382,2.8,16.074,16.074,0,0,0-.2,2.936c-.03,1.559-.079,3.118-.08,4.677,0,1.576.044,3.152.073,4.728.016.847.007,1.694.1,2.54a6.175,6.175,0,0,0,.366,1.578,4.092,4.092,0,0,0,3.025,2.544,8.131,8.131,0,0,0,1.607.237c1.491.078,2.985.042,4.476.087a5.081,5.081,0,0,1,1.636.341,2.966,2.966,0,0,1,1.9,1.985A6.974,6.974,0,0,1-475,210.32a3.148,3.148,0,0,1-2.206,2.074,9.28,9.28,0,0,1-2.161.279c-.034,0-.068,0-.1,0q-6.518.01-13.035.018-9.726,0-19.451-.018c-.64,0-.631,0-.809.611-.3,1.042-.484,2.112-.75,3.162a11.286,11.286,0,0,1-3.706,6.113,10.624,10.624,0,0,1-5.853,2.363c-1,.1-2,.08-3,.115-3.833.134-7.668.1-11.5.1-1.7,0-3.395.006-5.09-.064-1.372-.057-2.747,0-4.115-.154a10.525,10.525,0,0,1-8.895-6.374,13.4,13.4,0,0,1-1.117-5.589c0-.22-.01-.44-.015-.659-.092-1.955-.162-3.91-.14-5.868a1,1,0,0,0-.049-.546v-2.544a.618.618,0,0,0,.051-.394c-.034-2.739.081-5.478.051-8.217.015-2.115,1.1-3.315,3.294-3.6a8.167,8.167,0,0,1,2.435.036,3.315,3.315,0,0,1,2.99,3.462c.2,4.559.019,9.118.108,13.677a28.54,28.54,0,0,0,.217,3.8c.388,2.523,1.531,3.649,4.067,4a21.646,21.646,0,0,0,2.89.2c4,.022,8.009.033,12.013-.005a15.656,15.656,0,0,0,3.688-.349,3.784,3.784,0,0,0,3.039-3.291,16.939,16.939,0,0,0,.242-2.782q0-22.43,0-44.859a9.843,9.843,0,0,1,.205-2.019,3.545,3.545,0,0,1,3.736-3.057c.132,0,.272.036.395-.051Z" fill="#5f53a3"/>
    <path id="Tracé_9340" data-name="Tracé 9340" d="M176.186,159.89c.2.148.425.072.637.09a5.47,5.47,0,0,1,2.007.506,3.021,3.021,0,0,1,1.538,1.747,8.179,8.179,0,0,1,.379,2.856q.013,14.294.006,28.588,0,6.816,0,13.633a9.236,9.236,0,0,1-.267,2.366,3.639,3.639,0,0,1-3.61,2.936,6.843,6.843,0,0,1-1.823-.1,3.742,3.742,0,0,1-2.87-2.468,7.959,7.959,0,0,1-.413-2.9q0-8.113,0-16.227,0-10.555,0-21.11c0-.744.082-.607-.621-.776a8.735,8.735,0,0,1-2.15-.761,3.4,3.4,0,0,1-1.867-2.949,8.283,8.283,0,0,1,.158-2.324,3.547,3.547,0,0,1,3.08-2.9,11.125,11.125,0,0,1,1.926-.13c.179,0,.375.069.536-.075Z" transform="translate(-570.432)" fill="#5f53a3"/>
    <path id="Tracé_9341" data-name="Tracé 9341" d="M690.825,326.759c-.084.053-.08.141-.09.224a2.2,2.2,0,0,1-1.848,2.072,4.185,4.185,0,0,1-1.769,0,2.472,2.472,0,0,1-1.992-2.231,10.911,10.911,0,0,1-.094-1.367q.006-11.037,0-22.073c0-.136,0-.271,0-.407-.006-.4,0-.413-.39-.5a5.662,5.662,0,0,1-1.439-.49,2.054,2.054,0,0,1-1.146-1.8,4.789,4.789,0,0,1,.113-1.464,2.139,2.139,0,0,1,1.538-1.608,5.478,5.478,0,0,1,1.61-.191q1.323-.008,2.647,0a5.7,5.7,0,0,1,1.01.1,2.022,2.022,0,0,1,1.762,1.882.18.18,0,0,0,.085.171Z" transform="translate(-976.091 -107.948)" fill="#34b494"/>
    <path id="Tracé_9342" data-name="Tracé 9342" d="M326.023,159.986a.4.4,0,0,0,0-.1h7.842a.347.347,0,0,0,0,.1.84.84,0,0,1-.669.167q-3.255.008-6.509,0A.833.833,0,0,1,326.023,159.986Z" transform="translate(-695.623)" fill="#c2e8de"/>
    <path id="Tracé_9343" data-name="Tracé 9343" d="M289.41,160.342c.759,0,1.518,0,2.278,0l5.569,0a14.883,14.883,0,0,1,3.6.6,5.777,5.777,0,0,1,3.8,3.42,8.846,8.846,0,0,1,.543,2.059,20.766,20.766,0,0,1,.191,2.939c0,4.986.013,9.972.012,14.958q0,22.667-.014,45.335c0,5.427.01,10.854-.007,16.281a12.259,12.259,0,0,1-.838,4.674,6.23,6.23,0,0,1-4.219,3.818,11.425,11.425,0,0,1-6.864-.1,6.9,6.9,0,0,1-4.55-4.9,13.677,13.677,0,0,1-.514-3.967q0-10.685,0-21.37,0-23.278,0-46.556c0-.823.1-.63-.644-.792a22.168,22.168,0,0,1-3.9-1.14,9.659,9.659,0,0,1-1.353-.7,5.893,5.893,0,0,1-2.841-4.423,12.736,12.736,0,0,1,.311-4.89,6.244,6.244,0,0,1,4.755-4.732,16.718,16.718,0,0,1,3.975-.5Z" transform="translate(-659.01 -0.356)" fill="#34b494"/>
    <path id="Tracé_9344" data-name="Tracé 9344" d="M437.628,237.256q0,14.653,0,29.306a10.9,10.9,0,0,1-.495,3.457,5.029,5.029,0,0,1-4.171,3.57,9.6,9.6,0,0,1-3.787-.044,5.446,5.446,0,0,1-4.34-4.226,9.78,9.78,0,0,1-.326-2.513c0-.051,0-.1,0-.153q-.008-16.993-.014-33.986,0-9.259.014-18.519c0-.591,0-.586-.572-.707a14.942,14.942,0,0,1-3.249-1,4.753,4.753,0,0,1-2.858-3.413,7.2,7.2,0,0,1-.145-1.718,10.313,10.313,0,0,1,.4-2.757,4.715,4.715,0,0,1,3.088-3.2,8.812,8.812,0,0,1,2.74-.5c2.1-.058,4.206-.135,6.31-.082a14.59,14.59,0,0,1,3.48.37,4.662,4.662,0,0,1,3.164,2.351,6.742,6.742,0,0,1,.679,2.588c.066.861.091,1.725.09,2.59Q437.624,222.959,437.628,237.256Z" transform="translate(-767.826 -32.185)" fill="#34b494"/>
    <path id="Tracé_9345" data-name="Tracé 9345" d="M531.36,272.8q0-10.328,0-20.655c0-.237-.026-.475-.014-.711.013-.254-.1-.359-.34-.408-.448-.091-.893-.2-1.334-.317a7.3,7.3,0,0,1-1.785-.727,3.627,3.627,0,0,1-1.894-3.01,8.434,8.434,0,0,1,.2-2.725,3.865,3.865,0,0,1,3.065-2.985,8.321,8.321,0,0,1,1.659-.233c1.882-.075,3.764-.113,5.646-.046a7.491,7.491,0,0,1,2.971.593,3.46,3.46,0,0,1,1.861,2.112,7.144,7.144,0,0,1,.334,2.2c.095,4.747.062,9.5.031,14.243-.02,2.984-.054,5.969-.024,8.953.079,7.885.014,15.769.032,23.654a10.674,10.674,0,0,1-.272,2.671,4.093,4.093,0,0,1-3.772,3.317,7.716,7.716,0,0,1-2.979-.169,4.274,4.274,0,0,1-3.048-3,8.8,8.8,0,0,1-.335-2.712Q531.359,282.819,531.36,272.8Z" transform="translate(-853.128 -63.852)" fill="#34b494"/>
    <path id="Tracé_9346" data-name="Tracé 9346" d="M-141.954,490.11c0-3.205,0-6.41,0-9.615a12.308,12.308,0,0,1,.084-1.775,2.388,2.388,0,0,1,2.4-2.248,12.315,12.315,0,0,1,1.776-.1c1.426.012,2.852-.018,4.276.028,2.374.077,4.749.084,7.124.094a13.656,13.656,0,0,0,3.619.159c2.817,0,5.634-.024,8.45.028a8.835,8.835,0,0,1,3.558.751,6.807,6.807,0,0,1,3.956,5.036,10.181,10.181,0,0,1,.206,1.713c.14,3.115.213,6.231.258,9.348.033,2.322.025,4.644.049,6.966a5.223,5.223,0,0,1-.082,1.062,2.5,2.5,0,0,1-2.09,2.145,4.4,4.4,0,0,1-1.721,0,2.5,2.5,0,0,1-2.108-2.3,11.428,11.428,0,0,1-.094-1.419q0-6.715,0-13.431a7.273,7.273,0,0,0-.2-1.914,2.6,2.6,0,0,0-1.849-1.92,4.9,4.9,0,0,0-1.3-.227c-1.085-.033-2.171-.072-3.256-.013-.068,0-.136,0-.2.009a1.839,1.839,0,0,0-1.952,1.964c-.047.523-.073,1.049-.073,1.574q-.009,6.461,0,12.922c0,.661-.018,1.322-.025,1.983a3.349,3.349,0,0,1-.257,1.237,2.6,2.6,0,0,1-2.522,1.646,3.8,3.8,0,0,1-1.5-.233,2.5,2.5,0,0,1-1.636-2.411c-.049-.709-.039-1.423-.048-2.135-.023-1.847-.048-3.7-.06-5.543-.013-2.086,0-4.171-.023-6.257a11.88,11.88,0,0,0-.169-2.428,2.674,2.674,0,0,0-2.006-2.142,8.647,8.647,0,0,0-1.658-.237,20.753,20.753,0,0,0-2.893-.149c-.1.005-.2.006-.3.019a1.716,1.716,0,0,0-1.707,1.639,14.927,14.927,0,0,0-.158,2.584c-.014,4.6-.006,9.191-.008,13.787a5.6,5.6,0,0,1-.141,1.462,2.463,2.463,0,0,1-2.114,1.937,4.2,4.2,0,0,1-1.718-.053,2.208,2.208,0,0,1-1.644-1.512,4.455,4.455,0,0,1-.227-1.45q0-1.068,0-2.137V490.11Z" transform="translate(-326.962 -249.319)" fill="#5f53a3"/>
    <path id="Tracé_9347" data-name="Tracé 9347" d="M625.584,294.335q0,9.053,0,18.106a7.89,7.89,0,0,1-.19,1.815,3.137,3.137,0,0,1-2.649,2.6,5.89,5.89,0,0,1-2.522-.055,3.309,3.309,0,0,1-2.461-2.4,5.8,5.8,0,0,1-.225-1.706q-.007-14.011-.022-28.021,0-2.06,0-4.12c0-.5,0-.511-.5-.62a9.819,9.819,0,0,1-1.607-.475,2.984,2.984,0,0,1-2.057-2.863,6.484,6.484,0,0,1,.221-2.061,2.9,2.9,0,0,1,1.882-1.986,4.439,4.439,0,0,1,1.288-.282,43.547,43.547,0,0,1,5.589-.008,4.5,4.5,0,0,1,1.426.351,2.906,2.906,0,0,1,1.734,2.505,10.746,10.746,0,0,1,.1,1.52Q625.58,285.486,625.584,294.335Z" transform="translate(-921.969 -88.454)" fill="#34b494"/>
    <path id="Tracé_9348" data-name="Tracé 9348" d="M188.707,454.4q0-6.714,0-13.428a7.838,7.838,0,0,1,.223-2.116,5.942,5.942,0,0,1,.209-.625,1.967,1.967,0,0,1,1.706-1.267,5.821,5.821,0,0,1,1.874.047,2.307,2.307,0,0,1,2,2.126,6.138,6.138,0,0,1,.05.71c.063,2.576.046,5.152.046,7.729,0,4.154.02,8.308-.009,12.462-.013,1.915-.034,3.83-.036,5.745,0,.506,0,.507.48.667a8.221,8.221,0,0,1,1.534.671,2.3,2.3,0,0,1,1.174,2.4c-.065.677-.272,1.325-.389,1.992a1.093,1.093,0,0,1-.612.712,3.279,3.279,0,0,1-1.51.4c-.931.043-1.86.148-2.793.125a9.094,9.094,0,0,1-1.765-.2,2.352,2.352,0,0,1-1.851-1.758,9.07,9.07,0,0,1-.3-2.057c-.032-.558-.033-1.118-.034-1.677Q188.7,460.733,188.707,454.4Z" transform="translate(-587.448 -218.229)" fill="#5f53a3"/>
    <path id="Tracé_9349" data-name="Tracé 9349" d="M-339.043,490.467q0,3.763,0,7.526c0,1.068-.006,2.135-.028,3.2a3.148,3.148,0,0,1-.842,2.276,1.958,1.958,0,0,1-.573.416,3.49,3.49,0,0,1-2.958.043,2.545,2.545,0,0,1-1.44-2.242,10.191,10.191,0,0,1-.043-1.117c0-1.373.025-2.747-.008-4.12-.046-1.864-.064-3.729-.029-5.592.035-1.848.027-3.7.033-5.542,0-.355-.022-.711-.046-1.066a1.582,1.582,0,0,0-1.173-1.5,2.183,2.183,0,0,0-.394-.1,2.008,2.008,0,0,1-1.673-2.476,4.967,4.967,0,0,1,1.093-2.376,1.7,1.7,0,0,1,.978-.591,14.511,14.511,0,0,1,3.743-.251c.322.01.642.042.964.059a2.313,2.313,0,0,1,2.359,2.309c.014.186.013.373.013.559q0,5.29,0,10.579Z" transform="translate(-164.445 -249.766)" fill="#5f53a3"/>
    <path id="Tracé_9350" data-name="Tracé 9350" d="M-330.34,439.982a2.777,2.777,0,0,1-2.862,2.905,2.989,2.989,0,0,1-2.968-2.98,2.954,2.954,0,0,1,3-2.838A2.724,2.724,0,0,1-330.34,439.982Z" transform="translate(-173.964 -218.355)" fill="#5f53a3"/>
    <path id="Tracé_9351" data-name="Tracé 9351" d="M-254.3,490.859q0-4.781,0-9.563a11.486,11.486,0,0,0-.107-1.774,2.173,2.173,0,0,0-2.265-2.036c-1.2-.036-2.407-.068-3.611-.068-2.409,0-4.818-.041-7.227.045-1.034.037-2.069.007-3.1.123a7.5,7.5,0,0,0-3.508,1.25,6.414,6.414,0,0,0-2.772,5.081q-.248,3.372-.3,6.754c-.044,3.119-.021,6.239-.024,9.359,0,.78.009,1.56.015,2.34a1.893,1.893,0,0,0,1.183,1.906,4.135,4.135,0,0,0,3.315-.025,1.948,1.948,0,0,0,1.184-1.658,13.074,13.074,0,0,0,.089-1.318c.028-1.288.034-2.576.062-3.864.022-1.024.418-1.4,1.439-1.409h.356l7.179.015c.339,0,.68-.022,1.017.007a.961.961,0,0,1,.96.989c.018.287,0,.576,0,.865-.016,1.271-.031,2.544.024,3.814a2.72,2.72,0,0,0,2.172,2.818,4.652,4.652,0,0,0,.655.083,2.626,2.626,0,0,0,3.075-2.1,9.576,9.576,0,0,0,.189-2.324Q-254.3,495.514-254.3,490.859Zm-6.111-2.154a3.1,3.1,0,0,1-.023.457.878.878,0,0,1-.852.854,8.949,8.949,0,0,1-2.133.049c-1-.072-2,.036-3,.023a13.03,13.03,0,0,1-2.082-.063,2.485,2.485,0,0,0-.761.022,6.031,6.031,0,0,1-.759.064,1.166,1.166,0,0,1-1.3-.972,5.554,5.554,0,0,1-.174-2.117,5.136,5.136,0,0,1,.7-2.261,2.393,2.393,0,0,1,1.912-1.172,53.841,53.841,0,0,1,5.794-.208c.526,0,1.052,0,1.579,0a1.035,1.035,0,0,1,1.1,1.1c0,.729,0,1.458,0,2.187C-260.413,487.349-260.412,488.027-260.414,488.705Z" transform="translate(-220.403 -250.133)" fill="#5f53a3"/>
    <path id="Tracé_9352" data-name="Tracé 9352" d="M76.14,490.872q0-5.011,0-10.022c0-.356,0-.713-.022-1.068a2.168,2.168,0,0,0-2.357-2.3c-1.017-.039-2.035-.044-3.051-.053-3.155-.03-6.311-.033-9.466.069a9.286,9.286,0,0,0-3.57.687,6.224,6.224,0,0,0-3.94,5.16c-.293,2.491-.325,5-.4,7.509-.038,1.237-.034,2.475-.039,3.712q-.015,3.764-.018,7.528c0,.084.014.169.022.253a2.339,2.339,0,0,0,1.718,2.106,4.462,4.462,0,0,0,1.412.129,2.578,2.578,0,0,0,2.762-2.483,24.338,24.338,0,0,0,.084-3.755,5.821,5.821,0,0,1,.02-1.42.993.993,0,0,1,.946-.9,4.017,4.017,0,0,1,.508-.019q3.945,0,7.891,0a4.777,4.777,0,0,1,.508.017,1.114,1.114,0,0,1,1.121,1.041,2.7,2.7,0,0,1,.035.658c-.065,1.288.012,2.576.006,3.864a3.925,3.925,0,0,0,.214,1.3,2.307,2.307,0,0,0,1.744,1.611,4.439,4.439,0,0,0,1.869.021,2.274,2.274,0,0,0,1.882-1.9,6.851,6.851,0,0,0,.123-1.517Q76.139,495.985,76.14,490.872ZM70.3,488.3a5.153,5.153,0,0,1-.056.707c-.11.72-.331.927-1.038,1.023a10.045,10.045,0,0,1-2.031.036c-1.138-.077-2.268.035-3.4.042a5.156,5.156,0,0,1-1.112-.075,3.06,3.06,0,0,0-1.164.022,4.706,4.706,0,0,1-.962.063,1.152,1.152,0,0,1-1.219-1,4.587,4.587,0,0,1-.08-1.364,10.318,10.318,0,0,1,.279-2.262,2.659,2.659,0,0,1,2.433-2.116,13.251,13.251,0,0,1,1.826-.094c1.645-.008,3.289,0,4.934,0,.153,0,.306,0,.458.011a1.042,1.042,0,0,1,1.087,1.1c.03.71.007,1.423.007,2.134H70.3C70.3,487.116,70.309,487.708,70.3,488.3Z" transform="translate(-480.758 -250.132)" fill="#5f53a3"/>
    </g>
    </svg>
    
                      `,
                        width: 100,
                    }
                ]
            },

        ]


        function Rodape(currentPage, pageCount) {
            return [
                {
                    text: 'Page ' + currentPage + ' of ' + pageCount,
                    alignment: 'right',
                    fontSize: 9,
                    bold: true,
                    margin: [10, 0, 10, 10],


                }
            ]

        }

        function randomIntFromInterval(min, max) { // min and max included 
            return Math.floor(Math.random() * (max - min + 1) + min)
        }

        const rndInt = randomIntFromInterval(1, 600)

        const docDefinition = {
            info: {
                title: 'Echéancier ',
            },
            defaultStyle: {
                font: 'foo'
               },
            pageSize: "A4",
            // header : [title],
            pageMargins: [15, 10, 15, 20],
            content: [
                title,
                {
                    margin: [0, 40, 0, 10],
                    text: `Bordereau d'envoi N°${id}/${new Date().getFullYear()}`, fontSize: 12, bold: true,
                    style: 'header',
                    alignment: 'center'
                },

                {
                    columns: [
                        { width: '*', text: '' },
                        {
                            margin: [0, 0, 0, 40],
                            width: 'auto',
                            table: {
                                body: [

                                    [{ text: `Al Salam Bank Ramassage dossiers IAMAL`, fontSize: 12, bold: true, alignment: 'center', margin: [10, 10, 10, 10], }],


                                ],
                                alignment: "center"
                            },
                        },
                        { width: '*', text: '' },
                    ]
                },

                // {
                //     margin: [0, 0, 0, 40],
                //     border: [true, true, true, true],
                //     text: `Al Salam Bank Ramassage dossiers IAMAL`, fontSize: 12, bold: true,
                //     style: 'header',
                //     alignment: 'center'
                // },
                {
                    alignment: 'right',
                    margin: [0, 10, 0, 50],
                    text: [
                        // { text: `Numéro de transaction : ${''} \n`, fontSize: 12, bold: true },
                        { text: `Date : ${new Date().toLocaleDateString('en-gb', { day: 'numeric', year: 'numeric', month: 'short', })} ${'  '} \n`, fontSize: 10, bold: true },
                        // {text: `Value Date : ${new Date(DateValue).toLocaleDateString('en-gb', { day: 'numeric' , year: 'numeric', month: 'long',  })} ${'  '} Maturity Date : ${new Date(FINMATDATE).toLocaleDateString('en-gb', { day: 'numeric' , year: 'numeric', month: 'long',  })} \n`, fontSize: 8, bold: true},
                        // {text: `Pft Rate :${interestRate} ${'%   '} Type : 21068 ${Category} \n`, fontSize: 8, bold: true},
                        // {text: 'Status : CUR O/D Status : \n', fontSize: 8, bold: true},
                        // {text: `Current Outstanding : ${Math.abs(AmountEncours)?.toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DZD \n`, fontSize: 8, bold: true},
                        // {text: `Total Profit Amount : ${TotalProfit} \n`, fontSize: 8, bold: true},

                    ]
                },

                {
                    margin: [0, 0, 0, 15],
                    text: `Veuillez Trouver en Piéces jointes les Dossiers de ramassage Iamal ci-aprés:`, fontSize: 11, bold: true,
                    style: 'header',
                    alignment: 'left'
                },


                {
                    // alignment: 'justify',
                    // columnGap: 20,
                    margin: [0, 0, 0, 20],
                    columns: [
                        {
                            text: `Dossier ramassage IAMAL N°${IdDemande} de ${Civilite}`, fontSize: 9, bold: false,
                            style: 'header',
                            alignment: 'left',
                            width: 'auto',

                        },
                        {
                            margin: [4, 0, 0, 0],
                            text: [
                                { text: Nom +"  "+Prenom, fontSize: 9, bold: true },
                            ],
                            width: 'auto',
                            alignment: 'left',
                        },
    
                    ]
                },

                // {
                //     margin: [0, 0, 0, 20],
                //     text: `Dossier ramassage IAMAL N°${id} de ${Civilite} ${Nom} ${Prenom}`, fontSize: 9, bold: false,
                //     style: 'header',
                //     alignment: 'left'
                // },
                {
                    margin: [0, 0, 0, 10],
                    text: `Demande de Financement Iamal (Micro Financement) \n 
                    Autorisation de consultation de la centrale des risques \n
                    Demande d’Ouverture de Compte \n
                    Fiche FACTA\n
                    Engagement de provision en compte \n
                    Rapport d'entretien psychotechnique\n
                    BMC Business plan\n
                    Spécimen de signature\n
                    Facture proforma`,
                    fontSize: 9, bold: false,
                    style: 'header',
                    alignment: 'left'
                },
                // {
                //     margin: [0, 40, 0, 10],
                //     text: `Pour Iamal`, fontSize: 9, bold: true,
                //     style: 'header',
                //     alignment: 'left'
                // },
            ],



            footer:
            {
                // alignment: 'justify',
                // columnGap: 20,
                margin: [10, 0, 4, 0],
                columns: [
                    {
                        // margin: [0, 10, 0, 17],
                        text: [
                            { text: `Pour Iamal`, fontSize: 10, bold: true },
                        ],
                        width: '*',
                        alignment: 'left',
                    },
                    {

                        text: [
                            { text: `Pour Al Salam bank`, fontSize: 10, bold: true },
                        ],
                        width: '*',
                        alignment: 'right',
                    },

                ]
            },

        }


        pdfMake.createPdf(docDefinition).download(`Bordereau d'envoi Ramassage ${Nom} ${Prenom}`)
    }

    function PrintPDFLivraison() {

        var datapdf = [];
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
            foo: {
              bold: `${window.location.origin}/fonts/ARIALBD 1.ttf`,
              normal: `${window.location.origin}/fonts/ARIAL.ttf`
            }
          };

        const title = [
            // {
            //    margin: [ 5, 2, 10, 20 ],
            // //    snow: 'https://www.alsalamalgeria.com/themes/simpless/images/logo.png'
            // },
            // {
            //     // is supported loading images via url from reference by name in images
            //     Image: 'https://www.alsalamalgeria.com/themes/simpless/images/logo.png'
            //   },

            {
                // alignment: 'justify',
                // columnGap: 20,
                columns: [
                    {
                        margin: [0, 10, 0, 17],
                        text: [
                            { text: 'Incubateur / accélérateur IAMAL \n', fontSize: 9, bold: true },
                            { text: `Mob : 0661 80 63 58 \n`, fontSize: 8, bold: true },
                            { text: `E-mail : contact@iamal.dz \n`, fontSize: 8, bold: true },
                            { text: `Siège : 02, Lotissement des Jeunes Aveugles Draria, Alger \n`, fontSize: 8, bold: true },
                            { text: 'R.C : 16/00 - 1019525 B 23 \n', fontSize: 8, bold: true },
                            { text: `NIF : 2316101952574 \n`, fontSize: 8, bold: true },
                            { text: `Site marchand : www.iamal.dz \n`, fontSize: 8, bold: true },

                        ]
                    },
                    {
                        width: '20%',
                        margin: [0, 18, 18, 4],
                        // If no width/height/fit is used, then dimensions from the svg element is used.
                        svg: `
                        <svg xmlns="http://www.w3.org/2000/svg" width="271.733" height="94.661" viewBox="0 0 271.733 94.661">
    <g id="Groupe_136" data-name="Groupe 136" transform="translate(557 -159.89)">
    <path id="Tracé_9339" data-name="Tracé 9339" d="M-516.566,159.89c.2.155.455.088.682.14a3.679,3.679,0,0,1,2.874,3.134,8.009,8.009,0,0,1,.149,1.668q.025,9.818.045,19.636c0,2.306.034,4.614-.007,6.919-.056,3.1-.034,6.2-.078,9.306a5.734,5.734,0,0,0,.172,1.56,1.836,1.836,0,0,0,1.512,1.4,8.63,8.63,0,0,0,2.384.056c1.119-.066,2.238-.063,3.357-.066,2.63-.006,5.261.018,7.892.028.611,0,.559.023.557-.543-.008-3.357-.026-6.715-.022-10.072,0-2.255,0-4.511.064-6.764a22.152,22.152,0,0,1,1-6.557,10.374,10.374,0,0,1,3.975-5.447,10.12,10.12,0,0,1,4.539-1.671,51.1,51.1,0,0,1,5.378-.343c.372-.006.744-.041,1.117-.045a64.385,64.385,0,0,1,6.908.293,20.983,20.983,0,0,1,3.018.433,10.036,10.036,0,0,1,7.739,7.663,13.987,13.987,0,0,1,.435,3.318c.132,5.594.083,11.189.067,16.784a6.48,6.48,0,0,0,.109,1.666,1.632,1.632,0,0,0,1.321,1.257,3.786,3.786,0,0,0,.959.1c4.648-.146,9.3-.07,13.947-.087.545,0,1.08-.1,1.621-.144.219-.018.343-.114.312-.358a2.8,2.8,0,0,1,0-.356c0-5.037-.011-10.074.006-15.111a41.959,41.959,0,0,1,.18-4.721,13.621,13.621,0,0,1,1.663-5.4,9.943,9.943,0,0,1,5.729-4.456,18,18,0,0,1,4.285-.815c2.523-.192,5.052-.2,7.578-.155,1.967.038,3.935.044,5.9.094a14.71,14.71,0,0,1,7.221,2.179,14.848,14.848,0,0,1,3.045,2.2,3.389,3.389,0,0,1,.871,3.818,6.6,6.6,0,0,1-1.651,2.593,3.511,3.511,0,0,1-3.816.776,4.76,4.76,0,0,1-.957-.469,16.766,16.766,0,0,0-7.069-2.387,37.809,37.809,0,0,0-7.007-.021c-1.1.077-2.2.115-3.3.229a5.708,5.708,0,0,0-.994.2,3.385,3.385,0,0,0-2.429,2.444,8.159,8.159,0,0,0-.3,2.312q-.012,6.029,0,12.057a9.284,9.284,0,0,0,.237,2.065,3.986,3.986,0,0,0,3.347,3.2,9.791,9.791,0,0,0,1.969.206c3.971.014,7.943.043,11.914.028,1.85-.007,3.7.009,5.549.014a7.5,7.5,0,0,1,2.01.271,3.43,3.43,0,0,1,2.683,2.92,6.6,6.6,0,0,1-.063,2.625,3.708,3.708,0,0,1-2.682,2.795,10.606,10.606,0,0,1-2.97.339c-2.443.071-4.887.073-7.329.038q-6.644-.093-13.287-.032c-10.828.084-21.656.012-32.484.034a15.47,15.47,0,0,1-2.331-.167,2.755,2.755,0,0,1-2.637-2.684,24.713,24.713,0,0,1-.122-3.552c.027-1.645,0-3.29.041-4.934.073-2.966.055-5.933.109-8.9.032-1.763.031-3.526.024-5.288a15.193,15.193,0,0,0-.236-2.678,3.614,3.614,0,0,0-3.118-3.114,20.8,20.8,0,0,0-3.948-.326,43.725,43.725,0,0,0-5.028.238,6.57,6.57,0,0,0-1.534.347,3.528,3.528,0,0,0-2.382,2.8,16.074,16.074,0,0,0-.2,2.936c-.03,1.559-.079,3.118-.08,4.677,0,1.576.044,3.152.073,4.728.016.847.007,1.694.1,2.54a6.175,6.175,0,0,0,.366,1.578,4.092,4.092,0,0,0,3.025,2.544,8.131,8.131,0,0,0,1.607.237c1.491.078,2.985.042,4.476.087a5.081,5.081,0,0,1,1.636.341,2.966,2.966,0,0,1,1.9,1.985A6.974,6.974,0,0,1-475,210.32a3.148,3.148,0,0,1-2.206,2.074,9.28,9.28,0,0,1-2.161.279c-.034,0-.068,0-.1,0q-6.518.01-13.035.018-9.726,0-19.451-.018c-.64,0-.631,0-.809.611-.3,1.042-.484,2.112-.75,3.162a11.286,11.286,0,0,1-3.706,6.113,10.624,10.624,0,0,1-5.853,2.363c-1,.1-2,.08-3,.115-3.833.134-7.668.1-11.5.1-1.7,0-3.395.006-5.09-.064-1.372-.057-2.747,0-4.115-.154a10.525,10.525,0,0,1-8.895-6.374,13.4,13.4,0,0,1-1.117-5.589c0-.22-.01-.44-.015-.659-.092-1.955-.162-3.91-.14-5.868a1,1,0,0,0-.049-.546v-2.544a.618.618,0,0,0,.051-.394c-.034-2.739.081-5.478.051-8.217.015-2.115,1.1-3.315,3.294-3.6a8.167,8.167,0,0,1,2.435.036,3.315,3.315,0,0,1,2.99,3.462c.2,4.559.019,9.118.108,13.677a28.54,28.54,0,0,0,.217,3.8c.388,2.523,1.531,3.649,4.067,4a21.646,21.646,0,0,0,2.89.2c4,.022,8.009.033,12.013-.005a15.656,15.656,0,0,0,3.688-.349,3.784,3.784,0,0,0,3.039-3.291,16.939,16.939,0,0,0,.242-2.782q0-22.43,0-44.859a9.843,9.843,0,0,1,.205-2.019,3.545,3.545,0,0,1,3.736-3.057c.132,0,.272.036.395-.051Z" fill="#5f53a3"/>
    <path id="Tracé_9340" data-name="Tracé 9340" d="M176.186,159.89c.2.148.425.072.637.09a5.47,5.47,0,0,1,2.007.506,3.021,3.021,0,0,1,1.538,1.747,8.179,8.179,0,0,1,.379,2.856q.013,14.294.006,28.588,0,6.816,0,13.633a9.236,9.236,0,0,1-.267,2.366,3.639,3.639,0,0,1-3.61,2.936,6.843,6.843,0,0,1-1.823-.1,3.742,3.742,0,0,1-2.87-2.468,7.959,7.959,0,0,1-.413-2.9q0-8.113,0-16.227,0-10.555,0-21.11c0-.744.082-.607-.621-.776a8.735,8.735,0,0,1-2.15-.761,3.4,3.4,0,0,1-1.867-2.949,8.283,8.283,0,0,1,.158-2.324,3.547,3.547,0,0,1,3.08-2.9,11.125,11.125,0,0,1,1.926-.13c.179,0,.375.069.536-.075Z" transform="translate(-570.432)" fill="#5f53a3"/>
    <path id="Tracé_9341" data-name="Tracé 9341" d="M690.825,326.759c-.084.053-.08.141-.09.224a2.2,2.2,0,0,1-1.848,2.072,4.185,4.185,0,0,1-1.769,0,2.472,2.472,0,0,1-1.992-2.231,10.911,10.911,0,0,1-.094-1.367q.006-11.037,0-22.073c0-.136,0-.271,0-.407-.006-.4,0-.413-.39-.5a5.662,5.662,0,0,1-1.439-.49,2.054,2.054,0,0,1-1.146-1.8,4.789,4.789,0,0,1,.113-1.464,2.139,2.139,0,0,1,1.538-1.608,5.478,5.478,0,0,1,1.61-.191q1.323-.008,2.647,0a5.7,5.7,0,0,1,1.01.1,2.022,2.022,0,0,1,1.762,1.882.18.18,0,0,0,.085.171Z" transform="translate(-976.091 -107.948)" fill="#34b494"/>
    <path id="Tracé_9342" data-name="Tracé 9342" d="M326.023,159.986a.4.4,0,0,0,0-.1h7.842a.347.347,0,0,0,0,.1.84.84,0,0,1-.669.167q-3.255.008-6.509,0A.833.833,0,0,1,326.023,159.986Z" transform="translate(-695.623)" fill="#c2e8de"/>
    <path id="Tracé_9343" data-name="Tracé 9343" d="M289.41,160.342c.759,0,1.518,0,2.278,0l5.569,0a14.883,14.883,0,0,1,3.6.6,5.777,5.777,0,0,1,3.8,3.42,8.846,8.846,0,0,1,.543,2.059,20.766,20.766,0,0,1,.191,2.939c0,4.986.013,9.972.012,14.958q0,22.667-.014,45.335c0,5.427.01,10.854-.007,16.281a12.259,12.259,0,0,1-.838,4.674,6.23,6.23,0,0,1-4.219,3.818,11.425,11.425,0,0,1-6.864-.1,6.9,6.9,0,0,1-4.55-4.9,13.677,13.677,0,0,1-.514-3.967q0-10.685,0-21.37,0-23.278,0-46.556c0-.823.1-.63-.644-.792a22.168,22.168,0,0,1-3.9-1.14,9.659,9.659,0,0,1-1.353-.7,5.893,5.893,0,0,1-2.841-4.423,12.736,12.736,0,0,1,.311-4.89,6.244,6.244,0,0,1,4.755-4.732,16.718,16.718,0,0,1,3.975-.5Z" transform="translate(-659.01 -0.356)" fill="#34b494"/>
    <path id="Tracé_9344" data-name="Tracé 9344" d="M437.628,237.256q0,14.653,0,29.306a10.9,10.9,0,0,1-.495,3.457,5.029,5.029,0,0,1-4.171,3.57,9.6,9.6,0,0,1-3.787-.044,5.446,5.446,0,0,1-4.34-4.226,9.78,9.78,0,0,1-.326-2.513c0-.051,0-.1,0-.153q-.008-16.993-.014-33.986,0-9.259.014-18.519c0-.591,0-.586-.572-.707a14.942,14.942,0,0,1-3.249-1,4.753,4.753,0,0,1-2.858-3.413,7.2,7.2,0,0,1-.145-1.718,10.313,10.313,0,0,1,.4-2.757,4.715,4.715,0,0,1,3.088-3.2,8.812,8.812,0,0,1,2.74-.5c2.1-.058,4.206-.135,6.31-.082a14.59,14.59,0,0,1,3.48.37,4.662,4.662,0,0,1,3.164,2.351,6.742,6.742,0,0,1,.679,2.588c.066.861.091,1.725.09,2.59Q437.624,222.959,437.628,237.256Z" transform="translate(-767.826 -32.185)" fill="#34b494"/>
    <path id="Tracé_9345" data-name="Tracé 9345" d="M531.36,272.8q0-10.328,0-20.655c0-.237-.026-.475-.014-.711.013-.254-.1-.359-.34-.408-.448-.091-.893-.2-1.334-.317a7.3,7.3,0,0,1-1.785-.727,3.627,3.627,0,0,1-1.894-3.01,8.434,8.434,0,0,1,.2-2.725,3.865,3.865,0,0,1,3.065-2.985,8.321,8.321,0,0,1,1.659-.233c1.882-.075,3.764-.113,5.646-.046a7.491,7.491,0,0,1,2.971.593,3.46,3.46,0,0,1,1.861,2.112,7.144,7.144,0,0,1,.334,2.2c.095,4.747.062,9.5.031,14.243-.02,2.984-.054,5.969-.024,8.953.079,7.885.014,15.769.032,23.654a10.674,10.674,0,0,1-.272,2.671,4.093,4.093,0,0,1-3.772,3.317,7.716,7.716,0,0,1-2.979-.169,4.274,4.274,0,0,1-3.048-3,8.8,8.8,0,0,1-.335-2.712Q531.359,282.819,531.36,272.8Z" transform="translate(-853.128 -63.852)" fill="#34b494"/>
    <path id="Tracé_9346" data-name="Tracé 9346" d="M-141.954,490.11c0-3.205,0-6.41,0-9.615a12.308,12.308,0,0,1,.084-1.775,2.388,2.388,0,0,1,2.4-2.248,12.315,12.315,0,0,1,1.776-.1c1.426.012,2.852-.018,4.276.028,2.374.077,4.749.084,7.124.094a13.656,13.656,0,0,0,3.619.159c2.817,0,5.634-.024,8.45.028a8.835,8.835,0,0,1,3.558.751,6.807,6.807,0,0,1,3.956,5.036,10.181,10.181,0,0,1,.206,1.713c.14,3.115.213,6.231.258,9.348.033,2.322.025,4.644.049,6.966a5.223,5.223,0,0,1-.082,1.062,2.5,2.5,0,0,1-2.09,2.145,4.4,4.4,0,0,1-1.721,0,2.5,2.5,0,0,1-2.108-2.3,11.428,11.428,0,0,1-.094-1.419q0-6.715,0-13.431a7.273,7.273,0,0,0-.2-1.914,2.6,2.6,0,0,0-1.849-1.92,4.9,4.9,0,0,0-1.3-.227c-1.085-.033-2.171-.072-3.256-.013-.068,0-.136,0-.2.009a1.839,1.839,0,0,0-1.952,1.964c-.047.523-.073,1.049-.073,1.574q-.009,6.461,0,12.922c0,.661-.018,1.322-.025,1.983a3.349,3.349,0,0,1-.257,1.237,2.6,2.6,0,0,1-2.522,1.646,3.8,3.8,0,0,1-1.5-.233,2.5,2.5,0,0,1-1.636-2.411c-.049-.709-.039-1.423-.048-2.135-.023-1.847-.048-3.7-.06-5.543-.013-2.086,0-4.171-.023-6.257a11.88,11.88,0,0,0-.169-2.428,2.674,2.674,0,0,0-2.006-2.142,8.647,8.647,0,0,0-1.658-.237,20.753,20.753,0,0,0-2.893-.149c-.1.005-.2.006-.3.019a1.716,1.716,0,0,0-1.707,1.639,14.927,14.927,0,0,0-.158,2.584c-.014,4.6-.006,9.191-.008,13.787a5.6,5.6,0,0,1-.141,1.462,2.463,2.463,0,0,1-2.114,1.937,4.2,4.2,0,0,1-1.718-.053,2.208,2.208,0,0,1-1.644-1.512,4.455,4.455,0,0,1-.227-1.45q0-1.068,0-2.137V490.11Z" transform="translate(-326.962 -249.319)" fill="#5f53a3"/>
    <path id="Tracé_9347" data-name="Tracé 9347" d="M625.584,294.335q0,9.053,0,18.106a7.89,7.89,0,0,1-.19,1.815,3.137,3.137,0,0,1-2.649,2.6,5.89,5.89,0,0,1-2.522-.055,3.309,3.309,0,0,1-2.461-2.4,5.8,5.8,0,0,1-.225-1.706q-.007-14.011-.022-28.021,0-2.06,0-4.12c0-.5,0-.511-.5-.62a9.819,9.819,0,0,1-1.607-.475,2.984,2.984,0,0,1-2.057-2.863,6.484,6.484,0,0,1,.221-2.061,2.9,2.9,0,0,1,1.882-1.986,4.439,4.439,0,0,1,1.288-.282,43.547,43.547,0,0,1,5.589-.008,4.5,4.5,0,0,1,1.426.351,2.906,2.906,0,0,1,1.734,2.505,10.746,10.746,0,0,1,.1,1.52Q625.58,285.486,625.584,294.335Z" transform="translate(-921.969 -88.454)" fill="#34b494"/>
    <path id="Tracé_9348" data-name="Tracé 9348" d="M188.707,454.4q0-6.714,0-13.428a7.838,7.838,0,0,1,.223-2.116,5.942,5.942,0,0,1,.209-.625,1.967,1.967,0,0,1,1.706-1.267,5.821,5.821,0,0,1,1.874.047,2.307,2.307,0,0,1,2,2.126,6.138,6.138,0,0,1,.05.71c.063,2.576.046,5.152.046,7.729,0,4.154.02,8.308-.009,12.462-.013,1.915-.034,3.83-.036,5.745,0,.506,0,.507.48.667a8.221,8.221,0,0,1,1.534.671,2.3,2.3,0,0,1,1.174,2.4c-.065.677-.272,1.325-.389,1.992a1.093,1.093,0,0,1-.612.712,3.279,3.279,0,0,1-1.51.4c-.931.043-1.86.148-2.793.125a9.094,9.094,0,0,1-1.765-.2,2.352,2.352,0,0,1-1.851-1.758,9.07,9.07,0,0,1-.3-2.057c-.032-.558-.033-1.118-.034-1.677Q188.7,460.733,188.707,454.4Z" transform="translate(-587.448 -218.229)" fill="#5f53a3"/>
    <path id="Tracé_9349" data-name="Tracé 9349" d="M-339.043,490.467q0,3.763,0,7.526c0,1.068-.006,2.135-.028,3.2a3.148,3.148,0,0,1-.842,2.276,1.958,1.958,0,0,1-.573.416,3.49,3.49,0,0,1-2.958.043,2.545,2.545,0,0,1-1.44-2.242,10.191,10.191,0,0,1-.043-1.117c0-1.373.025-2.747-.008-4.12-.046-1.864-.064-3.729-.029-5.592.035-1.848.027-3.7.033-5.542,0-.355-.022-.711-.046-1.066a1.582,1.582,0,0,0-1.173-1.5,2.183,2.183,0,0,0-.394-.1,2.008,2.008,0,0,1-1.673-2.476,4.967,4.967,0,0,1,1.093-2.376,1.7,1.7,0,0,1,.978-.591,14.511,14.511,0,0,1,3.743-.251c.322.01.642.042.964.059a2.313,2.313,0,0,1,2.359,2.309c.014.186.013.373.013.559q0,5.29,0,10.579Z" transform="translate(-164.445 -249.766)" fill="#5f53a3"/>
    <path id="Tracé_9350" data-name="Tracé 9350" d="M-330.34,439.982a2.777,2.777,0,0,1-2.862,2.905,2.989,2.989,0,0,1-2.968-2.98,2.954,2.954,0,0,1,3-2.838A2.724,2.724,0,0,1-330.34,439.982Z" transform="translate(-173.964 -218.355)" fill="#5f53a3"/>
    <path id="Tracé_9351" data-name="Tracé 9351" d="M-254.3,490.859q0-4.781,0-9.563a11.486,11.486,0,0,0-.107-1.774,2.173,2.173,0,0,0-2.265-2.036c-1.2-.036-2.407-.068-3.611-.068-2.409,0-4.818-.041-7.227.045-1.034.037-2.069.007-3.1.123a7.5,7.5,0,0,0-3.508,1.25,6.414,6.414,0,0,0-2.772,5.081q-.248,3.372-.3,6.754c-.044,3.119-.021,6.239-.024,9.359,0,.78.009,1.56.015,2.34a1.893,1.893,0,0,0,1.183,1.906,4.135,4.135,0,0,0,3.315-.025,1.948,1.948,0,0,0,1.184-1.658,13.074,13.074,0,0,0,.089-1.318c.028-1.288.034-2.576.062-3.864.022-1.024.418-1.4,1.439-1.409h.356l7.179.015c.339,0,.68-.022,1.017.007a.961.961,0,0,1,.96.989c.018.287,0,.576,0,.865-.016,1.271-.031,2.544.024,3.814a2.72,2.72,0,0,0,2.172,2.818,4.652,4.652,0,0,0,.655.083,2.626,2.626,0,0,0,3.075-2.1,9.576,9.576,0,0,0,.189-2.324Q-254.3,495.514-254.3,490.859Zm-6.111-2.154a3.1,3.1,0,0,1-.023.457.878.878,0,0,1-.852.854,8.949,8.949,0,0,1-2.133.049c-1-.072-2,.036-3,.023a13.03,13.03,0,0,1-2.082-.063,2.485,2.485,0,0,0-.761.022,6.031,6.031,0,0,1-.759.064,1.166,1.166,0,0,1-1.3-.972,5.554,5.554,0,0,1-.174-2.117,5.136,5.136,0,0,1,.7-2.261,2.393,2.393,0,0,1,1.912-1.172,53.841,53.841,0,0,1,5.794-.208c.526,0,1.052,0,1.579,0a1.035,1.035,0,0,1,1.1,1.1c0,.729,0,1.458,0,2.187C-260.413,487.349-260.412,488.027-260.414,488.705Z" transform="translate(-220.403 -250.133)" fill="#5f53a3"/>
    <path id="Tracé_9352" data-name="Tracé 9352" d="M76.14,490.872q0-5.011,0-10.022c0-.356,0-.713-.022-1.068a2.168,2.168,0,0,0-2.357-2.3c-1.017-.039-2.035-.044-3.051-.053-3.155-.03-6.311-.033-9.466.069a9.286,9.286,0,0,0-3.57.687,6.224,6.224,0,0,0-3.94,5.16c-.293,2.491-.325,5-.4,7.509-.038,1.237-.034,2.475-.039,3.712q-.015,3.764-.018,7.528c0,.084.014.169.022.253a2.339,2.339,0,0,0,1.718,2.106,4.462,4.462,0,0,0,1.412.129,2.578,2.578,0,0,0,2.762-2.483,24.338,24.338,0,0,0,.084-3.755,5.821,5.821,0,0,1,.02-1.42.993.993,0,0,1,.946-.9,4.017,4.017,0,0,1,.508-.019q3.945,0,7.891,0a4.777,4.777,0,0,1,.508.017,1.114,1.114,0,0,1,1.121,1.041,2.7,2.7,0,0,1,.035.658c-.065,1.288.012,2.576.006,3.864a3.925,3.925,0,0,0,.214,1.3,2.307,2.307,0,0,0,1.744,1.611,4.439,4.439,0,0,0,1.869.021,2.274,2.274,0,0,0,1.882-1.9,6.851,6.851,0,0,0,.123-1.517Q76.139,495.985,76.14,490.872ZM70.3,488.3a5.153,5.153,0,0,1-.056.707c-.11.72-.331.927-1.038,1.023a10.045,10.045,0,0,1-2.031.036c-1.138-.077-2.268.035-3.4.042a5.156,5.156,0,0,1-1.112-.075,3.06,3.06,0,0,0-1.164.022,4.706,4.706,0,0,1-.962.063,1.152,1.152,0,0,1-1.219-1,4.587,4.587,0,0,1-.08-1.364,10.318,10.318,0,0,1,.279-2.262,2.659,2.659,0,0,1,2.433-2.116,13.251,13.251,0,0,1,1.826-.094c1.645-.008,3.289,0,4.934,0,.153,0,.306,0,.458.011a1.042,1.042,0,0,1,1.087,1.1c.03.71.007,1.423.007,2.134H70.3C70.3,487.116,70.309,487.708,70.3,488.3Z" transform="translate(-480.758 -250.132)" fill="#5f53a3"/>
    </g>
    </svg>
    
                      `,
                        width: 100,
                    }
                ]
            },

        ]


        function Rodape(currentPage, pageCount) {
            return [
                {
                    text: 'Page ' + currentPage + ' of ' + pageCount,
                    alignment: 'right',
                    fontSize: 9,
                    bold: true,
                    margin: [10, 0, 10, 10],


                }
            ]

        }

        function randomIntFromInterval(min, max) { // min and max included 
            return Math.floor(Math.random() * (max - min + 1) + min)
        }

        const rndInt = randomIntFromInterval(1, 600)

        const docDefinition = {
            info: {
                title: 'Echéancier ',
            },
            defaultStyle: {
                font: 'foo'
               },
            pageSize: "A4",
            // header : [title],
            pageMargins: [15, 10, 15, 20],
            content: [
                title,
                {
                    margin: [0, 40, 0, 10],
                    text: `Bordereau d'envoi N°${id}/${new Date().getFullYear()}`, fontSize: 12, bold: true,
                    style: 'header',
                    alignment: 'center'
                },

                {
                    columns: [
                        { width: '*', text: '' },
                        {
                            margin: [0, 0, 0, 40],
                            width: 'auto',
                            table: {
                                body: [

                                    [{ text: `Al Salam Bank Livraison dossiers IAMAL`, fontSize: 12, bold: true, alignment: 'center', margin: [10, 10, 10, 10], }],


                                ],
                                alignment: "center"
                            },
                        },
                        { width: '*', text: '' },
                    ]
                },

                // {
                //     margin: [0, 0, 0, 40],
                //     border: [true, true, true, true],
                //     text: `Al Salam Bank Ramassage dossiers IAMAL`, fontSize: 12, bold: true,
                //     style: 'header',
                //     alignment: 'center'
                // },
                {
                    alignment: 'right',
                    margin: [0, 10, 0, 50],
                    text: [
                        // { text: `Numéro de transaction : ${''} \n`, fontSize: 12, bold: true },
                        { text: `Date : ${new Date().toLocaleDateString('en-gb', { day: 'numeric', year: 'numeric', month: 'short', })} ${'  '} \n`, fontSize: 10, bold: true },
                        // {text: `Value Date : ${new Date(DateValue).toLocaleDateString('en-gb', { day: 'numeric' , year: 'numeric', month: 'long',  })} ${'  '} Maturity Date : ${new Date(FINMATDATE).toLocaleDateString('en-gb', { day: 'numeric' , year: 'numeric', month: 'long',  })} \n`, fontSize: 8, bold: true},
                        // {text: `Pft Rate :${interestRate} ${'%   '} Type : 21068 ${Category} \n`, fontSize: 8, bold: true},
                        // {text: 'Status : CUR O/D Status : \n', fontSize: 8, bold: true},
                        // {text: `Current Outstanding : ${Math.abs(AmountEncours)?.toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DZD \n`, fontSize: 8, bold: true},
                        // {text: `Total Profit Amount : ${TotalProfit} \n`, fontSize: 8, bold: true},

                    ]
                },

                {
                    margin: [0, 0, 0, 15],
                    text: `Veuillez Trouver en Piéces jointes les Dossiers de Garanties Iamal ci-aprés:`, fontSize: 11, bold: true,
                    style: 'header',
                    alignment: 'left'
                },

                // {
                //     margin: [0, 0, 0, 20],
                //     text: `Dossiers Garanties IAMAL N°${id} de ${Civilite} ${Nom} ${Prenom}`, fontSize: 9, bold: false,
                //     style: 'header',
                //     alignment: 'left'
                // },


                {
                    // alignment: 'justify',
                    // columnGap: 20,
                    margin: [0, 0, 0, 20],
                    columns: [
                        {
                            text: `Dossiers Garanties IAMAL N°${IdDemande} de ${Civilite}`, fontSize: 9, bold: false,
                            style: 'header',
                            alignment: 'left',
                            width: 'auto',

                        },
                        {
                            margin: [4, 0, 0, 0],
                            text: [
                                { text: Nom +"  "+Prenom, fontSize: 9, bold: true },
                            ],
                            width: 'auto',
                            alignment: 'left',
                        },
    
                    ]
                },
                {
                    margin: [0, 0, 0, 10],
                    text: `Billet a ordre \n 
                  `,
                    fontSize: 9, bold: false,
                    style: 'header',
                    alignment: 'left'
                },
                // {
                //     margin: [0, 40, 0, 10],
                //     text: `Pour Iamal`, fontSize: 9, bold: true,
                //     style: 'header',
                //     alignment: 'left'
                // },
            ],



            footer:
            {
                // alignment: 'justify',
                // columnGap: 20,
                margin: [10, 0, 4, 0],
                columns: [
                    {
                        // margin: [0, 10, 0, 17],
                        text: [
                            { text: `Pour Iamal`, fontSize: 10, bold: true },
                        ],
                        width: '*',
                        alignment: 'left',
                    },
                    {

                        text: [
                            { text: `Pour Al Salam bank`, fontSize: 10, bold: true },
                        ],
                        width: '*',
                        alignment: 'right',
                    },

                ]
            },

        }


        pdfMake.createPdf(docDefinition).download(`Bordereau d'envoi Garanties ${Nom} ${Prenom}`)
    }

    async function ANNEXE03() {


        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/ANNEXE 03 تصريح بالالتزام.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page





        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 264,
                y: (height / 2) + 79,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (NIN) {

            firstPage.drawText(`${NIN}`, {
                x: 260,
                y: (height / 2) + 60,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }














        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `ANNEXE 03 تصريح بالالتزام ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function Rapport() {


        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/Rapport d'entretien.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page

        firstPage.drawText(`${new Date().toLocaleDateString('fr')}`, {
            x: 437,
            y: (height / 2) + 198,
            size: 10,
            font: helveticaFont,
            // color: rgb(0.95, 0.1, 0.1),
        })



        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 325,
                y: (height / 2) + 115,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Civilite) {

            firstPage.drawText(`${Civilite}`, {
                x: 300,
                y: (height / 2) + 115,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }





        if (IdDemande) {

            firstPage.drawText(`${IdDemande}`, {
                x: 322,
                y: (height / 2) + 90,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (CreatedAt) {

            firstPage.drawText(`${new Date(CreatedAt)?.toLocaleDateString('fr')}`, {
                x: 313,
                y: (height / 2) + 9,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }



        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 280,
                y: (height / 2) + -12,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }




        if (IdDemande) {

            firstPage.drawText(`${IdDemande}`, {
                x: 171,
                y: (height / 2) + -31,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (activité) {

            let TitleProject = ProjectsList?.find(o => o.id == activité);



            if (TitleProject && TitleProject?.title) {
                firstPage.drawText(`${TitleProject?.title}`, {
                    x: 347,
                    y: (height / 2) + -91,
                    size: 9,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })
            }

            // if (TitleProject && TitleProject?.cat_name) {

            //     var catNameFr = '';
            //     if (TitleProject?.cat_name =="المشاريع المتنقلة") {
            //         catNameFr = "Mobile"
            //     }else if(TitleProject?.cat_name =="المشاريع الثابتة"){
            //         catNameFr = "Fixe"

            //     }else if (TitleProject?.cat_name == "المشاريع الخاصة بذوي الهمم") {
            //         catNameFr = "Handicapé"
            //     }
            //     ThirdPage.drawText(` / ${catNameFr}`, {
            //         x: 213,
            //         y: (height / 2) + 228,
            //         size: 8,
            //         font: helveticaFont,

            //         // color: rgb(0.95, 0.1, 0.1),
            //     })
            // } 


        }









        // if (DatededElivrence) {

        //     firstPage.drawText(`${new Date(DatededElivrence).toLocaleDateString('fr')}`, {
        //         x: 290,
        //         y: (height / 2) + 129,
        //         size: 14,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }


        // if (Wilayadedélivrence) {

        //     firstPage.drawText(`${Wilayadedélivrence}`, {
        //         x: 80,
        //         y: (height / 2) + 129,
        //         size: 12,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }



        // if (Adresse) {

        //     firstPage.drawText(`${Adresse}`, {
        //         x: 58,
        //         y: (height / 2) + 69,
        //         size: 10,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }





        // firstPage.drawText(`${new Date().toLocaleDateString('fr')}`, {
        //     x: 393,
        //     y: (height / 2) + -165,
        //     size: 12,
        //     font: helveticaFont,
        //     // color: rgb(0.95, 0.1, 0.1),
        // })

        // if (Wilaya) {


        //     firstPage.drawText(`${Wilaya}`, {
        //         x: 210,
        //         y: (height / 2) + -165,
        //         size: 12,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }









        // if (sourcesderevenus && (sourcesderevenus == 'oui' || sourcesderevenus == 'non')) {

        //     firstPage.drawText(`/`, {
        //         x: 221,
        //         y: (height / 2) + 36,
        //         size: 12,
        //         font: helveticaFont,

        //         // color: rgb(0.95, 0.1, 0.1),
        //     })
        // }





        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `Rapport d'entretien ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function BMCFemmeaufoyergateaux() {


        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/BMC Femme au foyer gateaux et plats traditionnels.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page

        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 630,
                y: (height / 2) + 260,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `BMC Femme au foyer gateaux et plats traditionnels ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function BMCFemme() {


        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/BMC Femme au foyer couturière.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page

        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 630,
                y: (height / 2) + 260,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `BMC Femme au foyer couturière ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function BMCCafeteria() {


        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/BMC Cafeteria.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page

        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 630,
                y: (height / 2) + 260,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `BMC Cafeteria ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function BMCVegetablesandfruits() {


        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/BMC خضر وفواكه.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page

        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 630,
                y: (height / 2) + 260,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `BMC خضر وفواكه ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function BMCFastFood() {


        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/BMC FAST FOOD.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page

        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 630,
                y: (height / 2) + 260,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `BMC FAST FOOD ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function createPdf4() {


        const pdfFileOriginale = `/demande_financement.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })


        const urlFontAR = `/fonts/Fairuz-Bold.ttf`;
        const fontBytesAR = await fetch(urlFontAR).then((res) => res.arrayBuffer())
        // Register the `fontkit` instance
        // pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFontAR = await pdfDoc.embedFont(fontBytesAR, { subset: true })

        

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]
        const SecondPage = pages[1]
        const ThirdPage = pages[2]



        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page




        if (IdDemande) {

            firstPage.drawText(`${IdDemande}`, {
                x: 130,
                y: (height / 2) + 233,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }

        if (CreatedAt) {

            firstPage.drawText(`${new Date(CreatedAt).toLocaleString('fr')}`, {
                x: 206,
                y: (height / 2) + 233,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (DemandeType == '1' || DemandeType == '0') {

            if (DemandeType == '0') {
                firstPage.drawText(`/`, {
                    x: 194,
                    y: (height / 2) + 206,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })
            } else if (DemandeType == '1') {

                firstPage.drawText(`/`, {
                    x: 377,
                    y: (height / 2) + 206,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })

            }


        }








        if (Civilite && (Civilite == 'M' || Civilite == 'Mme' || Civilite == 'Mle')) {

            firstPage.drawText(`${Civilite}`, {
                x: 181,
                y: (height / 2) + 148,
                size: 12,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })

        }

        if (Nom) {

            firstPage.drawText(`${Nom}`, {
                x: 181,
                y: (height / 2) + 121,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Prenom) {

            firstPage.drawText(`${Prenom}`, {
                x: 181,
                y: (height / 2) + 93,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Datedenaissance) {

            firstPage.drawText(`${new Date(Datedenaissance).toLocaleDateString('fr')}`, {
                x: 181,
                y: (height / 2) + 65,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }




        if (Wilayadenaissance) {

            firstPage.drawText(`${Wilayadenaissance}`, {
                x: 181,
                y: (height / 2) + 37,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Communedenaissance) {

            firstPage.drawText(`${Communedenaissance}`, {
                x: 181,
                y: (height / 2) + 9,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Situationfamiliale) {

            firstPage.drawText(`${Situationfamiliale}`, {
                x: 181,
                y: (height / 2) + -19,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (onlyNumbers(Children)) {

            firstPage.drawText(`${Children}`, {
                x: 181,
                y: (height / 2) + -48,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (onlyNumbers(Personnes)) {

            firstPage.drawText(`${Personnes}`, {
                x: 181,
                y: (height / 2) + -76,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (Wilaya) {


            firstPage.drawText(`${Wilaya}`, {
                x: 181,
                y: (height / 2) + -190,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Daira) {


            firstPage.drawText(`${Daira}`, {
                x: 181,
                y: (height / 2) + -218,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (CodePostal) {


            firstPage.drawText(`${CodePostal}`, {
                x: 181,
                y: (height / 2) + -246,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Adresse) {

            firstPage.drawText(`${Adresse}`, {
                x: 181,
                y: (height / 2) + -274,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Mobile) {

            firstPage.drawText(`${Mobile}`, {
                x: 181,
                y: (height / 2) + -302,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }

        if (Mail) {

            firstPage.drawText(`${Mail}`, {
                x: 181,
                y: (height / 2) + -330,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Numerodecartenational) {

            SecondPage.drawText(`${Numerodecartenational}`, {
                x: 181,
                y: (height / 2) + 394,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (DatededElivrence) {

            SecondPage.drawText(`${new Date(DatededElivrence).toLocaleDateString('fr')}`, {
                x: 181,
                y: (height / 2) + 366,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Wilayadedélivrence) {

            SecondPage.drawText(`${Wilayadedélivrence}`, {
                x: 181,
                y: (height / 2) + 338,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (NIN) {

            SecondPage.drawText(`${NIN}`, {
                x: 181,
                y: (height / 2) + 310,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Secteurdactivité) {

            let secteur =
            {
                "p": 'Public',
                'v': 'Privé ',
                'r': 'Retraité ',
                'f': 'freelance',
                'c': 'sans emploi'
            };
            SecondPage.drawText(`${secteur[Secteurdactivité]}`, {
                x: 181,
                y: (height / 2) + 226,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (Secteurdactivité == "p" || Secteurdactivité == "v") {


            if (Périodedessai == 'oui' || Périodedessai == "non") {

                SecondPage.drawText(`${Périodedessai}`, {
                    x: 181,
                    y: (height / 2) + 170,
                    size: 9,
                    font: helveticaFont,
                    // color: rgb(0.95, 0.1, 0.1),
                })

            }


            if (Ancienneté) {

                SecondPage.drawText(`${new Date(Ancienneté).toLocaleDateString('fr')}`, {
                    x: 181,
                    y: (height / 2) + 142,
                    size: 9,
                    font: helveticaFont,
                    // color: rgb(0.95, 0.1, 0.1),
                })

            }




            if (Nomdelemployeur) {

                SecondPage.drawText(`${Nomdelemployeur}`, {
                    x: 181,
                    y: (height / 2) + 114,
                    size: 9,
                    font: helveticaFont,
                    // color: rgb(0.95, 0.1, 0.1),
                })

            }



            if (Wilayadelemployeur) {

                SecondPage.drawText(`${Wilayadelemployeur}`, {
                    x: 181,
                    y: (height / 2) + 86,
                    size: 9,
                    font: helveticaFont,
                    // color: rgb(0.95, 0.1, 0.1),
                })

            }




            if (Adressedelemployeur) {

                SecondPage.drawText(`${Adressedelemployeur}`, {
                    x: 181,
                    y: (height / 2) + 58,
                    size: 9,
                    font: helveticaFont,
                    // color: rgb(0.95, 0.1, 0.1),
                })

            }


        }



        if (Profession) {

            SecondPage.drawText(`${Profession}`, {
                x: 181,
                y: (height / 2) + 198,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }









        if (Salaire && Salaire != null && Salaire != 0 && Salaire != undefined && Salaire != '' && Salaire != 'undefined' && Salaire != 'NULL') {

            SecondPage.drawText(`${Salaire} DA`, {
                x: 181,
                y: (height / 2) + -56,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        }



        if (Compte == 'CCP') {

            SecondPage.drawText(`${CompteCCP} Clé ${CCPClé}`, {
                x: 181,
                y: (height / 2) + -84,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        } else {

            SecondPage.drawText(`non`, {
                x: 181,
                y: (height / 2) + -84,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (créditempruntimmobilier == 'oui') {

            SecondPage.drawText(`oui`, {
                x: 181,
                y: (height / 2) + -168,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        } else {


            SecondPage.drawText(`non`, {
                x: 181,
                y: (height / 2) + -168,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })



        }



        if (créditvoiture == 'oui') {

            SecondPage.drawText(`oui`, {
                x: 181,
                y: (height / 2) + -196,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        } else {


            SecondPage.drawText(`non`, {
                x: 181,
                y: (height / 2) + -196,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })



        }




        if (Autrecrédit == 'oui') {

            SecondPage.drawText(`oui`, {
                x: 181,
                y: (height / 2) + -224,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        } else {


            SecondPage.drawText(`non`, {
                x: 181,
                y: (height / 2) + -224,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })



        }



        if (Compteépargne == 'oui') {

            SecondPage.drawText(`oui`, {
                x: 181,
                y: (height / 2) + -340,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        } else {


            SecondPage.drawText(`non`, {
                x: 181,
                y: (height / 2) + -340,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })



        }




        if (Compteépargne == 'oui') {

            ThirdPage.drawText(`${CompteépargneText} DA`, {
                x: 181,
                y: (height / 2) + 394,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        }



        if (immeublesoumeubles) {

            ThirdPage.drawText(`${immeublesoumeubles} DA`, {
                x: 181,
                y: (height / 2) + 366,
                size: 8,
                font: helveticaFont,
            })
        }




        if (TypeOfPerson == "0" || TypeOfPerson == "1" || TypeOfPerson == "2" || TypeOfPerson == "3" || TypeOfPerson == "4") {

            let TypeOfPersonList = ['Personne Physique', "Personne Morale", "Artisan", "Commercant ambulant", 'Start-up'];
            ThirdPage.drawText(`${TypeOfPersonList[TypeOfPerson]}`, {
                x: 181,
                y: (height / 2) + 277,
                size: 8,
                font: helveticaFont,
            })
        }



        if (dateIsValid(new Date(Datedébutdactivité))) {

            ThirdPage.drawText(`${new Date(Datedébutdactivité).toLocaleDateString('fr')}`, {
                x: 181,
                y: (height / 2) + 249,
                size: 8,
                font: helveticaFont,
            })
        }




        if (ImmatriculationauregistreCommerce) {

            ThirdPage.drawText("NRC : \u202d" + ImmatriculationauregistreCommerce, {
                x: 181,
                y: (height / 2) + 218,
                size: 8,
                font: helveticaFont,
            })
        }



        if (dateIsValid(new Date(DateImmatriculationauregistreCommerce))) {

            ThirdPage.drawText(`${new Date(DateImmatriculationauregistreCommerce).toLocaleDateString('fr')}`, {
                x: 181,
                y: (height / 2) + 190,
                size: 8,
                font: helveticaFont,
            })
        }



        if (LieuImmatriculationauregistreCommerce) {

            ThirdPage.drawText(`${LieuImmatriculationauregistreCommerce}`, {
                x: 181,
                y: (height / 2) + 162,
                size: 8,
                font: helveticaFont,
            })
        }




        if (Adressedusiège) {

            ThirdPage.drawText(`${Adressedusiège}`, {
                x: 181,
                y: (height / 2) + 134,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (Adressedusiège && (Situationdulocal == '1' || Situationdulocal == '0' || Situationdulocal == '2')) {

            let SituationdulocalList = ['Location', "Propriété", "Non"];
            ThirdPage.drawText(`${SituationdulocalList[Situationdulocal]}`, {
                x: 181,
                y: (height / 2) + 106,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        }







        if (activité) {

            let TitleProject = ProjectsList?.find(o => o.id == activité);



            if (TitleProject && TitleProject?.title) {
                ThirdPage.drawText(`${TitleProject?.title}`, {
                    x: 34,
                    y: (height / 2) + -71,
                    size: 9,
                    font: helveticaFontAR,
                    

                    // color: rgb(0.95, 0.1, 0.1),
                })
            }

            if (TitleProject && TitleProject?.cat_name) {

                var catNameFr = '';
                if (TitleProject?.cat_name == "المشاريع المتنقلة") {
                    catNameFr = "Mobile"
                } else if (TitleProject?.cat_name == "المشاريع الثابتة") {
                    catNameFr = "Fixe"

                } else if (TitleProject?.cat_name == "المشاريع الخاصة بذوي الهمم") {
                    catNameFr = "Handicapé"
                } else if (TitleProject?.cat_name == "امرأة ماكثة بالبيت") {
                    catNameFr = "Femme au foyer"
                }
                ThirdPage.drawText(`${catNameFr}`, {
                    x: 271,
                    y: (height / 2) + -71,
                    size: 9,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })
            }


        }



        if (Time) {

            ThirdPage.drawText(`${Time} Mois`, {
                x: 372,
                y: (height / 2) + -69,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        }



        if (activité) {

            let TitleProject = ProjectsList?.find(o => o.id == activité);

            // function TTC(Price) {
            //     return Math.round((Price + (Price * 0.27 + 9000)) * 1.19) + 25000
            // }


            function TTC(Price) {
                // Type "1" === "غير ماكثة في البيت"
                if (TitleProject?.id_category != "7") {
          
                  return Math.round((Price + (Price * 0.10 + 16000)) * 1.19) + 25000;
          
                }else{
                // Type "2" === "ماكثة في البيت"
                  return Math.round((Price + (Price * 0.10 + 9000)) * 1.19);
                }
              }



            if (TitleProject && TitleProject?.price) {
                // ThirdPage.drawText(`${TitleProject?.price?.toLocaleString('en')} DA`, {
                //     x: 333,
                //     y: (height / 2) + -69,
                //     size: 8,
                //     font: helveticaFont,

                //     // color: rgb(0.95, 0.1, 0.1),
                // })

                ThirdPage.drawText(`${TTC(parseInt(TitleProject?.price))?.toLocaleString('en')} DA`, {
                    x: 441,
                    y: (height / 2) + -69,
                    size: 8,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })

                // ThirdPage.drawText(`${GetTaksitPrice(parseInt(TTC(parseInt(TitleProject?.price))), Time)['getallprice']?.toLocaleString('en')} DA`, {
                //     x: 501,
                //     y: (height / 2) + -69,
                //     size: 8,
                //     font: helveticaFont,

                //     // color: rgb(0.95, 0.1, 0.1),
                // })
            }

        }



        if (Wilaya) {


            ThirdPage.drawText(`${Wilaya}`, {
                x: 99,
                y: (height / 2) + -125,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        // ThirdPage.drawText(`${new Date().toLocaleDateString('fr')}`, {
        //     x: 233,
        //     y: (height / 2) + -125,
        //     size: 9,
        //     font: helveticaFont,
        //     // color: rgb(0.95, 0.1, 0.1),
        // })









        // if (Profession) {

        //     firstPage.drawText(`${Profession}`, {
        //         x: 103,
        //         y: (height / 2) + 146,
        //         size: 8,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })
        // }

        // if (Adressedelemployeur && Adressedelemployeur != '' && Adressedelemployeur != 0) {

        //     firstPage.drawText(`${Adressedelemployeur}`, {
        //         x: 103,
        //         y: (height / 2) + 136,
        //         size: 8,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })
        // }


        // firstPage.drawText(`Algerienne`, {
        //     x: 70,
        //     y: (height / 2) + -77,
        //     size: 9,
        //     font: helveticaFont,
        //     // color: rgb(0.95, 0.1, 0.1),
        // })




        // if (CodePostal) {

        //     firstPage.drawText(`${CodePostal}`, {
        //         x: 70,
        //         y: (height / 2) + -153,
        //         size: 9,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }




        // if (GreenCard && (GreenCard == 'oui' || GreenCard == 'non')) {

        //     if (GreenCard == 'oui') {
        //         firstPage.drawText(`/`, {
        //             x: 297,
        //             y: (height / 2) + -302,
        //             size: 12,
        //             font: helveticaFont,

        //             // color: rgb(0.95, 0.1, 0.1),
        //         })
        //     } else {

        //         firstPage.drawText(`/`, {
        //             x: 430,
        //             y: (height / 2) + -302,
        //             size: 12,
        //             font: helveticaFont,

        //             // color: rgb(0.95, 0.1, 0.1),
        //         })

        //     }

        // }



        // if (Nom && Prenom && Civilite) {

        //     firstPage.drawText(`${Civilite} ${Nom} ${Prenom}`, {
        //         x: 100,
        //         y: (height / 2) + 189,
        //         size: 15,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }


        // if (Datedenaissance) {

        //     firstPage.drawText(`${Datedenaissance}`, {
        //         x: 290,
        //         y: (height / 2) + 129,
        //         size: 15,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }


        // if (Wilayadenaissance) {

        //     firstPage.drawText(`${Wilayadenaissance}`, {
        //         x: 120,
        //         y: (height / 2) + 129,
        //         size: 15,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }



        // if (Adresse) {

        //     firstPage.drawText(`${Adresse}`, {
        //         x: 120,
        //         y: (height / 2) + 66,
        //         size: 15,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }









        // if (sourcesderevenus && (sourcesderevenus == 'oui' || sourcesderevenus == 'non')) {

        //     firstPage.drawText(`/`, {
        //         x: 221,
        //         y: (height / 2) + 36,
        //         size: 12,
        //         font: helveticaFont,

        //         // color: rgb(0.95, 0.1, 0.1),
        //     })
        // }





        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `demande_financement ${Nom} ${Prenom}.pdf`, "application/pdf");


        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function createPdf3() {


        // Embed our custom font in the document
        // const customFont = await pdfDoc.embedFont(fontBytes)

        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'


        const pdfFileOriginale = `/fiche_FATCA.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page


        if (Civilite && (Civilite == 'M' || Civilite == 'Mme' || Civilite == 'Mle')) {

            if (Civilite == 'M') {
                firstPage.drawText(`/`, {
                    x: 283,
                    y: (height / 2) + 4,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })
            } else if (Civilite == 'Mme' || Civilite == 'Mle') {

                firstPage.drawText(`/`, {
                    x: 432,
                    y: (height / 2) + 4,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })

            }


        }

        if (Nom) {

            firstPage.drawText(`${Nom}`, {
                x: 72,
                y: (height / 2) + -37,
                size: 7,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Prenom) {

            firstPage.drawText(`${Prenom}`, {
                x: 170,
                y: (height / 2) + -37,
                size: 7,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Datedenaissance) {

            firstPage.drawText(`${new Date(Datedenaissance).toLocaleDateString('fr')}`, {
                x: 289,
                y: (height / 2) + -37,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }




        if (Wilayadenaissance) {

            firstPage.drawText(`${Wilayadenaissance}`, {
                x: 400,
                y: (height / 2) + -37,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        firstPage.drawText(`Algerienne`, {
            x: 70,
            y: (height / 2) + -77,
            size: 9,
            font: helveticaFont,
            // color: rgb(0.95, 0.1, 0.1),
        })



        if (Adresse) {

            firstPage.drawText(`${Adresse}`, {
                x: 70,
                y: (height / 2) + -113,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (CodePostal) {

            firstPage.drawText(`${CodePostal}`, {
                x: 70,
                y: (height / 2) + -153,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Mobile) {

            firstPage.drawText(`${Mobile}`, {
                x: 70,
                y: (height / 2) + -230,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Mail) {

            firstPage.drawText(`${Mail}`, {
                x: 70,
                y: (height / 2) + -270,
                size: 9,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (GreenCard && (GreenCard == 'oui' || GreenCard == 'non')) {

            if (GreenCard == 'oui') {
                firstPage.drawText(`/`, {
                    x: 297,
                    y: (height / 2) + -302,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })
            } else {

                firstPage.drawText(`/`, {
                    x: 430,
                    y: (height / 2) + -302,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })

            }

        }



        // if (Nom && Prenom && Civilite) {

        //     firstPage.drawText(`${Civilite} ${Nom} ${Prenom}`, {
        //         x: 100,
        //         y: (height / 2) + 189,
        //         size: 15,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }


        // if (Datedenaissance) {

        //     firstPage.drawText(`${Datedenaissance}`, {
        //         x: 290,
        //         y: (height / 2) + 129,
        //         size: 15,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }


        // if (Wilayadenaissance) {

        //     firstPage.drawText(`${Wilayadenaissance}`, {
        //         x: 120,
        //         y: (height / 2) + 129,
        //         size: 15,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }



        // if (Adresse) {

        //     firstPage.drawText(`${Adresse}`, {
        //         x: 120,
        //         y: (height / 2) + 66,
        //         size: 15,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })

        // }









        // if (sourcesderevenus && (sourcesderevenus == 'oui' || sourcesderevenus == 'non')) {

        //     firstPage.drawText(`/`, {
        //         x: 221,
        //         y: (height / 2) + 36,
        //         size: 12,
        //         font: helveticaFont,

        //         // color: rgb(0.95, 0.1, 0.1),
        //     })
        // }





        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `FATCA ${Nom} ${Prenom}.pdf`, "application/pdf");


        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }
    async function createPdf2() {


        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/annexe.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page

        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 100,
                y: (height / 2) + 192,
                size: 12,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Civilite) {

            firstPage.drawText(`${Civilite}`, {
                x: 70,
                y: (height / 2) + 192,
                size: 12,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Datedenaissance) {

            firstPage.drawText(`${new Date(Datedenaissance).toLocaleDateString('fr')}`, {
                x: 290,
                y: (height / 2) + 129,
                size: 14,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (Communedenaissance) {

            firstPage.drawText(`${Communedenaissance}`, {
                x: 80,
                y: (height / 2) + 129,
                size: 12,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }



        if (Adresse) {

            firstPage.drawText(`${Adresse}`, {
                x: 58,
                y: (height / 2) + 69,
                size: 10,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }





        firstPage.drawText(`${new Date().toLocaleDateString('fr')}`, {
            x: 393,
            y: (height / 2) + -165,
            size: 12,
            font: helveticaFont,
            // color: rgb(0.95, 0.1, 0.1),
        })

        if (Wilaya) {


            firstPage.drawText(`${Wilaya}`, {
                x: 210,
                y: (height / 2) + -165,
                size: 12,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }









        // if (sourcesderevenus && (sourcesderevenus == 'oui' || sourcesderevenus == 'non')) {

        //     firstPage.drawText(`/`, {
        //         x: 221,
        //         y: (height / 2) + 36,
        //         size: 12,
        //         font: helveticaFont,

        //         // color: rgb(0.95, 0.1, 0.1),
        //     })
        // }





        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `CENTRALE DES RISQUES ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }

    async function createPdf() {

        const Localurl = 'http://localhost:3000/';
        const Onlinelurl = 'http://localhost:3000/'

        const pdfFileOriginale = `/demande_d_ouverture_de_compte.pdf`
        const existingPdfBytes = await fetch(pdfFileOriginale).then(res => res.arrayBuffer())
        // Create a new PDFDocument
        // const existingPdfBytes =  Pdf.arrayBuffer();
        // const pdfDocument = await PDFDocument.load(await file.arrayBuffer());
        // Load a PDFDocument from the existing PDF bytes
        const pdfDoc = await PDFDocument.load(existingPdfBytes)


        const urlFont = `/fonts/ARIALBD 1.ttf`;
        const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer())


        // Register the `fontkit` instance
        pdfDoc.registerFontkit(fontkit)
        // Embed the Helvetica font
        const helveticaFont = await pdfDoc.embedFont(fontBytes, { subset: true })

        // Get the first page of the document
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]

        // Get the width and height of the first page
        const { width, height } = firstPage.getSize()

        // Draw a string of text diagonally across the first page

        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 107,
                y: (height / 2) + 218,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }

        if (Civilite) {

            firstPage.drawText(`${Civilite}`, {
                x: 82,
                y: (height / 2) + 218,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }
        if (Nom && Prenom) {

            firstPage.drawText(`${Nom} ${Prenom}`, {
                x: 107,
                y: (height / 2) + 206,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })

        }


        if (PrenomPere) {

            firstPage.drawText(`${PrenomPere || ''} et de ${PrenomMere || ''} ${NomMere || ''}`, {
                x: 87,
                y: (height / 2) + 196,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        // if (PrenomMere && NomMere) {

        //     firstPage.drawText(`${PrenomMere} ${NomMere}`, {
        //         x: 167,
        //         y: (height / 2) + 196,
        //         size: 7,
        //         font: helveticaFont,
        //         // color: rgb(0.95, 0.1, 0.1),
        //     })
        // }

        if (Datedenaissance && Wilayadenaissance && Communedenaissance) {

            firstPage.drawText(`${new Date(Datedenaissance).toLocaleDateString('fr')} ${Wilayadenaissance} ${Communedenaissance}`, {
                x: 127,
                y: (height / 2) + 186,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (Situationfamiliale) {

            firstPage.drawText(`${Situationfamiliale}`, {
                x: 103,
                y: (height / 2) + 176,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }

        if (onlyNumbers(Children)) {

            firstPage.drawText(`${Children}`, {
                x: 103,
                y: (height / 2) + 166,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (Profession) {

            firstPage.drawText(`${Profession}`, {
                x: 103,
                y: (height / 2) + 146,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }

        if (Adressedelemployeur && Adressedelemployeur != '' && Adressedelemployeur != 0) {

            firstPage.drawText(`${Adressedelemployeur}`, {
                x: 103,
                y: (height / 2) + 136,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }



        if (Adresse) {

            firstPage.drawText(`${Adresse}`, {
                x: 70,
                y: (height / 2) + 116,
                size: 8,
                font: helveticaFont,
                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (SéjourUSA && (SéjourUSA == 'oui' || SéjourUSA == 'non')) {

            if (SéjourUSA == 'oui') {
                firstPage.drawText(`/`, {
                    x: 217,
                    y: (height / 2) + 46,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })
            } else if (SéjourUSA == 'non') {

                firstPage.drawText(`/`, {
                    x: 262,
                    y: (height / 2) + 46,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })

            }


        }


        if (GreenCard && (GreenCard == 'oui' || GreenCard == 'non')) {

            if (GreenCard == 'oui') {
                firstPage.drawText(`/`, {
                    x: 221,
                    y: (height / 2) + 34,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })
            } else {

                firstPage.drawText(`/`, {
                    x: 265,
                    y: (height / 2) + 34,
                    size: 12,
                    font: helveticaFont,

                    // color: rgb(0.95, 0.1, 0.1),
                })

            }

        }

        if (Mobile && onlyNumbers(Mobile)) {

            firstPage.drawText(`${Mobile}`, {
                x: 81,
                y: (height / 2) + -22,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        }

        if (Mail) {

            firstPage.drawText(`${Mail}`, {
                x: 81,
                y: (height / 2) + -42,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        if (Salaire) {

            firstPage.drawText(`${Salaire} DA`, {
                x: 110,
                y: (height / 2) + -52,
                size: 8,
                font: helveticaFont,

                // color: rgb(0.95, 0.1, 0.1),
            })
        }


        // if (sourcesderevenus && (sourcesderevenus == 'oui' || sourcesderevenus == 'non')) {

        //     firstPage.drawText(`/`, {
        //         x: 221,
        //         y: (height / 2) + 36,
        //         size: 12,
        //         font: helveticaFont,

        //         // color: rgb(0.95, 0.1, 0.1),
        //     })
        // }





        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save()

        // Trigger the browser to download the PDF document

        downloadjs(pdfBytes, `Demande d’Ouverture de Compte ${Nom} ${Prenom}.pdf`, "application/pdf");

        // const blob = new Blob([pdfBytes], { type: "application/pdf;charset=utf-8" });
        // const url = URL.createObjectURL(blob);
        // url.title = 'hh'
        // window.open(url);
        // download(pdfBytes, "pdf-lib_creation_example.pdf", "application/pdf");
    }

    const [ProjectsList, setProjectsList] = useState([])


    useEffect(() => {
        // setLoadingProjectsList(true);

        const GetProjectsList = async () => {

            try {
                const { data: response } = await axios.get(`${process.env.REACT_APP_LOCAL_URL}/projects/projects_admin/projects_all/admin`,{
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${Auth?.token}`
                    },
                  });
                console.log(response);
                setProjectsList(response['data']);
                // console.log(DarTaksitCat)

            } catch (error) {
                console.error(error.message);
            }
            // setLoadingProjectsList(false);
        }

        GetProjectsList();

    }, []);



    const { Global, dartaksitsim, Account, adresse, situationprofessionnelle, chargesetpatrimoine, RecapitulatifSimTaksit, dari3marsim, Panier, infoperssonnelle } = useContext(LangContext);
    const Lang = 'ar';
    const ComuneMountdenaissance = useRef(true);

    const [DemandeType, setDemandeType] = useState("0")
    const [Civilite, setCivilite] = useState('M')
    const [Nom, setNom] = useState('')
    const [Prenom, setPrenom] = useState('')
    const [PrenomPere, setPrenomPere] = useState('')
    const [NomMere, setNomMere] = useState('')
    const [PrenomMere, setPrenomMere] = useState('')
    const [Datedenaissance, setDatedenaissance] = useState('')
    const [Wilayadenaissance, setWilayadenaissance] = useState('')
    const [Communedenaissance, setCommunedenaissance] = useState('')
    const [CommunedenaissanceList, setCommunedenaissanceList] = useState([])
    const [Actedenaissance, setActedenaissance] = useState('')
    const [Typeactnaissnce, setTypeactnaissnce] = useState('')
    const [Situationfamiliale, setSituationfamiliale] = useState('')
    const [NiveauDinstructions, setNiveauDinstructions] = useState('')
    const [Children, setChildren] = useState(0)
    const [Personnes, setPersonnes] = useState(0)



    const DairaMount = useRef(true);
    const ComuneMount = useRef(true);
    const PostalCodeMount = useRef(true);
    const CommunededélivrenceMount = useRef(true);

    const [Wilaya, setWilaya] = useState('')
    const [DairaList, setDairaList] = useState([])
    const [Daira, setDaira] = useState('')
    const [CommuneList, setCommuneList] = useState([])
    const [Commune, setCommune] = useState('')
    const [CodePostalList, setCodePostalList] = useState([])
    const [CodePostal, setCodePostal] = useState('')
    const [Adresse, setAdresse] = useState('')
    const [Mobile, setMobile] = useState('')
    const [Mobile2, setMobile2] = useState('')
    const [Mail, setMail] = useState('')
    const [ReMail, setReMail] = useState('')
    const [NIN, setNIN] = useState('')
    const [Numerodecartenational, setNumerodecartenational] = useState('')
    const [DatededElivrence, setDatededElivrence] = useState('')
    const [Wilayadedélivrence, setWilayadedélivrence] = useState('')
    const [CommunededélivrenceList, setCommunededélivrenceList] = useState('')
    const [Communededélivrence, setCommunededélivrence] = useState('')
    const [Habitation, setHabitation] = useState('')




    const [activité, setactivité] = useState('')
    const [Certificat, setCertificat] = useState('non')
    const [TypeCertificat, setTypeCertificat] = useState('')
    const [Experience, setExperience] = useState('non')


    const [Compte, setCompte] = useState('Non')
    const [CompteCCP, setCompteCCP] = useState('')
    const [CCPClé, setCCPClé] = useState('')
    const [Banque, setBanque] = useState('')
    const [SalamBank, setSalamBank] = useState('non')
    const [sourcesderevenus, setsourcesderevenus] = useState('non')
    const [Time, setTime] = useState('60')


    const [TypeOfPerson, setTypeOfPerson] = useState("0")
    const [Datedébutdactivité, setDatedébutdactivité] = useState('')
    const [ImmatriculationauregistreCommerce, setImmatriculationauregistreCommerce] = useState('')
    const [DateImmatriculationauregistreCommerce, setDateImmatriculationauregistreCommerce] = useState('')
    const [LieuImmatriculationauregistreCommerce, setLieuImmatriculationauregistreCommerce] = useState('')
    const [Adressedusiège, setAdressedusiège] = useState('')
    const [Situationdulocal, setSituationdulocal] = useState(2)









    const [créditempruntimmobilier, setcréditempruntimmobilier] = useState('non')
    const [Mensualitéducréditimmobilier, setMensualitéducréditimmobilier] = useState('')
    const [Organismeprêteurimmobilier, setOrganismeprêteurimmobilier] = useState('')
    const [Datedefinducréditimmobilier, setDatedefinducréditimmobilier] = useState('')

    const [créditvoiture, setcréditvoiture] = useState('non')
    const [Mensualitéducréditvoiture, setMensualitéducréditvoiture] = useState('')
    const [Organismeprêteurdecréditvoiture, setOrganismeprêteurdecréditvoiture] = useState('')
    const [Datedefinducréditvoiture, setDatedefinducréditvoiture] = useState('')

    const [Autrecrédit, setAutrecrédit] = useState('non')
    const [Mensualitéduautrecrédit, setMensualitéduautrecrédit] = useState('')
    const [Organismeprêteurautrecrédit, setOrganismeprêteurautrecrédit] = useState('')
    const [Datedefinduautrecrédit, setDatedefinduautrecrédit] = useState('')

    const [Loyerpayer, setLoyerpayer] = useState('non')
    const [Loyer, setLoyer] = useState('')


    const [SéjourUSA, setSéjourUSA] = useState('non')
    const [GreenCard, setGreenCard] = useState('non')
    const [Compteépargne, setCompteépargne] = useState('non')
    const [CompteépargneText, setCompteépargneText] = useState('')
    const [immeublesoumeubles, setimmeublesoumeubles] = useState('')



    const [Secteurdactivité, setSecteurdactivité] = useState('')
    const [Typedecontrat, setTypedecontrat] = useState('')
    const [Périodedessai, setPériodedessai] = useState('oui')
    const [Ancienneté, setAncienneté] = useState('')
    const [Nomdelemployeur, setNomdelemployeur] = useState('')
    const [Wilayadelemployeur, setWilayadelemployeur] = useState('')

    const [Profession, setProfession] = useState('')
    const [Adressedelemployeur, setAdressedelemployeur] = useState('')
    const [Salaire, setSalaire] = useState('')






    const [FormValidate, setFormValidate] = useState(true)
    const [Showerr, setShowerr] = useState(false)
    const [FormChecked, setFormChecked] = useState(false)

    useEffect(() => {

        Validation();

    }, [Secteurdactivité, Wilayadelemployeur, Nomdelemployeur, Ancienneté, Périodedessai, Typedecontrat, DemandeType, Civilite, Nom, Prenom, PrenomPere, NomMere, PrenomMere, Wilayadenaissance, Commune, Children, Datedenaissance, Actedenaissance, Typeactnaissnce, Situationfamiliale, NiveauDinstructions, Personnes, Wilaya, Daira, Commune, CodePostal, Adresse, Mobile, Mobile2, Mail, ReMail, NIN, Numerodecartenational, DatededElivrence, Wilayadedélivrence, Communededélivrence, Habitation, activité, Certificat, TypeCertificat, Experience, créditempruntimmobilier, Mensualitéducréditvoiture, Mensualitéducréditimmobilier, Organismeprêteurimmobilier, Datedefinducréditimmobilier, créditvoiture, Loyer, Organismeprêteurdecréditvoiture, Datedefinducréditvoiture, Autrecrédit, Mensualitéduautrecrédit, Organismeprêteurautrecrédit, Datedefinduautrecrédit, Loyerpayer, Profession, Adressedelemployeur, Salaire, Compte, CompteCCP, CCPClé, Banque, SalamBank, sourcesderevenus, Time, SéjourUSA, GreenCard, Compteépargne, CompteépargneText, immeublesoumeubles, TypeOfPerson, Datedébutdactivité, ImmatriculationauregistreCommerce, DateImmatriculationauregistreCommerce, LieuImmatriculationauregistreCommerce, Adressedusiège, Situationdulocal])

    useEffect(() => {

        if (Showerr) {
            const matches = document.querySelectorAll(".alert-form");

            for (let index = 0; index < matches.length; index++) {

                if (matches[index].textContent.trim() !== '') {

                    let position = matches[index].getBoundingClientRect();


                    window.scrollTo(position.left, position.top + window.scrollY - 120);
                    return
                }
                // if (matches[index].textContent.trim() !== '') {

                //     matches[index].scrollIntoView({behavior: "smooth"});
                //     return
                // }              
            }
        }


    }, [Showerr])


    function Validation() {

        setFormValidate(true)



        if (DemandeType != "0" && DemandeType != "1") {
            setFormValidate(false)
        }

        if (Civilite !== "Mme" && Civilite !== "Mle" && Civilite !== "M") {
            setFormValidate(false)
        }
        if (Nom.trim().length < 2) {
            setFormValidate(false)
        }
        if (Prenom.trim().length < 2) {
            setFormValidate(false)
        }
        if (PrenomPere.trim().length < 2) {
            setFormValidate(false)
        }
        if (NomMere.trim().length < 2) {
            setFormValidate(false)
        }
        if (PrenomMere.trim().length < 2) {
            setFormValidate(false)
        }
        if (!dateIsValid(new Date(Datedenaissance))) {
            setFormValidate(false)
        }
        if (Wilayadenaissance === "") {
            setFormValidate(false)
        }
        if (Communedenaissance === "") {
            setFormValidate(false)
        }
        if (!onlyNumbers(Actedenaissance) || Actedenaissance.trim().length > 5) {
            setFormValidate(false)
        }
        if (Typeactnaissnce !== "biss" && Typeactnaissnce !== "ter" && Typeactnaissnce !== "autre") {
            setFormValidate(false)
        }
        if (Situationfamiliale == "") {
            setFormValidate(false)
        }
        if (NiveauDinstructions == "") {
            setFormValidate(false)
        }
        if (!onlyNumbers(Children)) {
            setFormValidate(false)
        }
        if (!onlyNumbers(Personnes)) {
            setFormValidate(false)
        }


        if (Wilaya === "") {
            setFormValidate(false)
        }
        if (Daira === "") {
            setFormValidate(false)
        }
        if (Commune === "") {
            setFormValidate(false)
        }
        if (CodePostal === "") {
            setFormValidate(false)
        }
        if (Adresse.trim() === "") {
            setFormValidate(false)
        }

        if (!onlyNumbers(Mobile) || Mobile.length !== 10 || (Mobile.slice(0, 2) !== "07" && Mobile.slice(0, 2) !== "05" && Mobile.slice(0, 2) !== "06")) {
            setFormValidate(false)
        }
        // if (!onlyNumbers(Mobile2) || Mobile2.length !== 10 || (Mobile2.slice(0, 2) !== "07" && Mobile2.slice(0, 2) !== "05" && Mobile2.slice(0, 2) !== "06") || Mobile == Mobile2) {
        //   setFormValidate(false)
        // }
        if (!isValidEmail(Mail.trim())) {
            setFormValidate(false)
        }
        if (!isValidEmail(ReMail.trim())) {
            setFormValidate(false)
        }
        if (Mail.trim() !== ReMail.trim()) {
            setFormValidate(false)
        }
        if (!onlyNumbers(NIN) || NIN.length !== 18) {
            setFormValidate(false)
        }
        if (!onlyNumbers(Numerodecartenational) || Numerodecartenational.length !== 9) {
            setFormValidate(false)
        }
        if (DatededElivrence === "") {
            setFormValidate(false)
        }
        if (Wilayadedélivrence === "") {
            setFormValidate(false)
        }
        if (Communededélivrence === "") {
            setFormValidate(false)
        }

        if (!activité || !onlyNumbers(activité)) {
            setFormValidate(false)
            // console.log('err');
        }
        if (Certificat == 'oui') {

            if (TypeCertificat?.toString().trim() == "") {
                setFormValidate(false)
            }

        }

        if ((créditempruntimmobilier !== 'non' && créditempruntimmobilier !== 'oui') || (créditvoiture !== 'non' && créditvoiture !== 'oui') || (Autrecrédit !== 'non' && Autrecrédit !== 'oui') || (Loyerpayer !== 'non' && Loyerpayer !== 'oui')) {
            setFormValidate(false)
        }

        if (créditempruntimmobilier == 'oui') {

            if (!onlyNumbers(Mensualitéducréditimmobilier)) {
                setFormValidate(false)
            }
            if (Organismeprêteurimmobilier == '') {
                setFormValidate(false)
            }
            if (Datedefinducréditimmobilier == '') {
                setFormValidate(false)

            }

        }

        if (créditvoiture == 'oui') {

            if (!onlyNumbers(Mensualitéducréditvoiture)) {
                setFormValidate(false)
            }
            if (Organismeprêteurdecréditvoiture == '') {
                setFormValidate(false)
            }
            if (Datedefinducréditvoiture == '') {
                setFormValidate(false)

            }

        }

        if (Autrecrédit == 'oui') {

            if (!onlyNumbers(Mensualitéduautrecrédit)) {
                setFormValidate(false)
            }
            if (Organismeprêteurautrecrédit == '') {
                setFormValidate(false)
            }
            if (Datedefinduautrecrédit == '') {
                setFormValidate(false)
            }

        }

        if (Loyerpayer == 'oui') {

            if (!onlyNumbers(Loyer)) {
                setFormValidate(false)
            }

        }



        if (Profession?.toString().trim().length > 300) {
            setFormValidate(false)
            // console.log('err');
        }

        if (Salaire !== '') {

            if (!onlyNumbers(Salaire)) {
                setFormValidate(false)
            }
        }


        if (Secteurdactivité !== "p" && Secteurdactivité !== "r" && Secteurdactivité !== "i" && Secteurdactivité !== "v" && Secteurdactivité !== "f" && Secteurdactivité !== "c") {
            setFormValidate(false)
            // console.log(Secteurdactivité);
            // console.log('err');
        }



        if (Secteurdactivité == "p" || Secteurdactivité == "v") {



            if (!dateIsValid(new Date(Ancienneté))) {
                setFormValidate(false)
            }

            if (Typedecontrat !== "CDD" && Typedecontrat !== "CDI" && Typedecontrat !== "INTERIM" && Typedecontrat !== "Autre") {
                setFormValidate(false)
                // console.log('err');
            }
            if (Nomdelemployeur?.toString().trim() == '') {
                setFormValidate(false)
                // console.log('err');
            }
            if (Wilayadelemployeur.trim() === '') {
                setFormValidate(false)
                // console.log('err');
            }
            if (Adressedelemployeur?.toString().trim() === '' || Adressedelemployeur?.toString().trim().length > 300) {
                setFormValidate(false)
                // console.log('err');
            }
            // if (!onlyNumbers(Tel) || Tel.length > 13 || Tel.length < 9) {
            //   setFormValidate(false)
            //   console.log('err');
            // }

        }




        if (Compte == 'CCP') {

            if (!onlyNumbers(CompteCCP)) {
                setFormValidate(false)
                // console.log('err');
            }
            if (!onlyNumbers(CCPClé) || CCPClé?.toString().length !== 2) {
                setFormValidate(false)
                console.log('ccp');
                // console.log('err');
            }
        } else if (Compte == 'Banque') {

            if (Banque.trim() === '') {
                setFormValidate(false)
                // console.log('err');
            }

        }


        if (Time != '12' && Time != '24' && Time != '36' && Time != '48' && Time != '60') {
            setFormValidate(false)
        }


        if (Compteépargne == 'oui') {

            if (CompteépargneText.trim() == '') {
                setFormValidate(false)
            }

        }

        if (TypeOfPerson != "0" && TypeOfPerson != "1" && TypeOfPerson != "2" && TypeOfPerson != "3" && TypeOfPerson != "4") {
            setFormValidate(false)
        }

        // if (Datedébutdactivité != '') {
        // if (!dateIsValid(new Date(Datedébutdactivité))) {
        //     setFormValidate(false)
        // }
        // }


        // if (ImmatriculationauregistreCommerce != "") {
        //     if (!onlyNumbers(ImmatriculationauregistreCommerce)) {
        //         setFormValidate(false)
        //     }
        // }

        // if (DateImmatriculationauregistreCommerce != "") {

        //     if (!dateIsValid(new Date(DateImmatriculationauregistreCommerce))) {
        //         setFormValidate(false)
        //     }
        // }


        if (LieuImmatriculationauregistreCommerce?.toString().trim().length > 300) {
            setFormValidate(false)
        }


        if (Adressedusiège?.toString().trim().length > 300) {
            setFormValidate(false)
        }



        if (Situationdulocal != "0" && Situationdulocal != "1" && Situationdulocal != "2") {
            setFormValidate(false)
        }





    }

    // const CommuneDeNaissanceMount = useRef(true);
    // const DairaMount = useRef(true);
    // const CommuneMount = useRef(true);
    // const PostalCodeMount = useRef(true);




    const { id } = useParams();
    // const [ProductData, setProductData] = useState('')





    const { Auth, setAuth, AuthFournisseur, setAuthFournisseur } = useContext(AuthContext);

    let navigate = useNavigate();


    const [MenuShow, setMenuShow] = useState(true)

    const [windowSize, setWindowSize] = useState(getWindowSize());

    function getWindowSize() {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    console.log(windowSize);

    // const [MobileScreen, setMobileScreen] = useState(windowSize.innerWidth > 992 ? false : true)




    const [AllData, setAllData] = useState(new FormData())

    const [NoInfo, setNoInfo] = useState(true)
    const [LoadDataWait, setLoadDataWait] = useState(false)

    const [CreatedAt, setCreatedAt] = useState('')
    const [IdDemande, setIdDemande] = useState('')





    useEffect(() => {

        const fetchData = async () => {
            setLoadDataWait(true);
            try {
                const { data: response } = await axios.get(`${process.env.REACT_APP_LOCAL_URL}/vendeur/getuserinfo/admin/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${Auth?.token}`
                    }
                });
                console.log(response);
                if (response['message'] == 'Token invalid') {
                    setAuth(false);
                    return navigate('/account')

                }

                if (response['data'] == 'empty') {
                    setLoadDataWait(false);
                    return setNoInfo(true)

                } else {
                    setNoInfo(false)
                }
                console.log(response['data']);
                // setProductData(response['data'])


                console.log(response?.data[0]?.type_vendeur);

                setCreatedAt(response?.data[0]?.created_at || '')
                setIdDemande(response?.data[0]?.id || '')


                setCivilite(response?.data[0]?.civilite || '');
                setNom(response?.data[0]?.nom || '');
                setPrenom(response?.data[0]?.prenom || '');
                setPrenomPere(response?.data[0]?.prenom_pere || '');
                setPrenomMere(response?.data[0]?.prenom_mere || '');
                setNomMere(response?.data[0]?.nom_mere || '');
                setDatedenaissance(response?.data[0]?.date_naissance || '');
                setWilayadenaissance(response?.data[0]?.wilaya_naissance || '');
                setCommunedenaissance(response?.data[0]?.communen_naissance || '');
                // setTel(response?.data[0]?.tel || '');
                // setEmail(response?.data[0]?.email_admin || '');
                setActedenaissance(response?.data[0]?.num_act_naissance || '');
                setTypeactnaissnce(response?.data[0]?.type_act_naissance || '');
                setSituationfamiliale(response?.data[0]?.situation_familiale || '');
                setNiveauDinstructions(response?.data[0]?.niveau_dinstructions || '');
                setChildren(Number(response?.data[0]?.numbre_enfants) || 0);
                setPersonnes(Number(response?.data[0]?.numbre_personnes) || 0);



                setWilaya(response?.data[0]?.wilaya || '');
                setDaira(response?.data[0]?.daira || '');
                setCommune(response?.data[0]?.commune || '');
                setCodePostal(response?.data[0]?.codepostal || '');
                setAdresse(response?.data[0]?.adresse || "");
                setMobile(response?.data[0]?.mobile || '');
                setMobile2(response?.data[0]?.mobile2 || '');
                setMail(response?.data[0]?.email || '');
                setReMail(response?.data[0]?.email || '');
                setNIN(response?.data[0]?.nin || '');
                setNumerodecartenational(response?.data[0]?.piece_identite_num || "");
                setDatededElivrence(response?.data[0]?.piece_identite_date || "");
                setWilayadedélivrence(response?.data[0]?.piece_identite_wilaya || "");
                setCommunededélivrence(response?.data[0]?.piece_identite_commune || "");
                setHabitation(response?.data[0]?.habitation || "");


                setactivité(response?.data[0]?.activite || '');
                setExperience(response?.data[0]?.experience || '');
                setCertificat(response?.data[0]?.certificat || '');
                setTypeCertificat(response?.data[0]?.certificat_type || '');



                setProfession(response?.data[0]?.profession || '')
                setAdressedelemployeur(response?.data[0]?.adresse_de_lemployeur || '')
                setSalaire(response?.data[0]?.salaire || '')
                setCompte(response?.data[0]?.compte_type || '')
                setCompteCCP(response?.data[0]?.compte_ccp_number || '')
                setCCPClé(response?.data[0]?.compte_ccp_cle || '')
                setBanque(response?.data[0]?.compte_bank || '')
                setSalamBank(response?.data[0]?.compte_al_salam || '')
                setsourcesderevenus(response?.data[0]?.autre_sources_de_revenus || '')
                setTime(response?.data[0]?.duree || '')





                setcréditempruntimmobilier(response?.data[0]?.credit_immobilier || '');
                setMensualitéducréditimmobilier(response?.data[0]?.mensualite_credit_immobilier || '');
                setOrganismeprêteurimmobilier(response?.data[0]?.organisme_credit_immobilier || '');
                setDatedefinducréditimmobilier(response?.data[0]?.date_fin_credit_immobilier || '');



                setcréditvoiture(response?.data[0]?.credit_voiture || '');
                setMensualitéducréditvoiture(response?.data[0]?.mensualite_credit_voiture || '');
                setOrganismeprêteurdecréditvoiture(response?.data[0]?.organisme_credit_voiture || '');
                setDatedefinducréditvoiture(response?.data[0]?.date_fin_credit_voiture || '');


                setAutrecrédit(response?.data[0]?.autre_credit || '');
                setMensualitéduautrecrédit(response?.data[0]?.mensualite_autre_credit || '');
                setOrganismeprêteurautrecrédit(response?.data[0]?.organisme_autre_credit || '');
                setDatedefinduautrecrédit(response?.data[0]?.date_fin_autre_credit || '');

                setLoyerpayer(response?.data[0]?.loyer || '');
                setLoyer(response?.data[0]?.mensualite_loyer || '');


                setSéjourUSA(response?.data[0]?.temporary_residence || '');
                setGreenCard(response?.data[0]?.green_card || '');
                setCompteépargne(response?.data[0]?.compte_epargne || '');
                setCompteépargneText(response?.data[0]?.compte_epargne_price || '');
                setimmeublesoumeubles(response?.data[0]?.immeubles_ou_meubles_price || '');


                setDemandeType(Number(response?.data[0]?.demande_type) || 0);
                setTypeOfPerson(Number(response?.data[0]?.type_of_person) || 0);
                setImmatriculationauregistreCommerce(response?.data[0]?.ImmatriculationauregistreCommerce || '');
                setDateImmatriculationauregistreCommerce(response?.data[0]?.DateImmatriculationauregistreCommerce || '');
                setDatedébutdactivité(response?.data[0]?.Datedebutdactivite || '');

                setLieuImmatriculationauregistreCommerce(response?.data[0]?.LieuImmatriculationauregistreCommerce || '');
                setAdressedusiège(response?.data[0]?.Adressedusiege || '');
                setSituationdulocal(Number(response?.data[0]?.Situationdulocal) || 0);



                setSecteurdactivité(response?.data[0]?.Secteurdactivite || '');
                setTypedecontrat(response?.data[0]?.Typedecontrat || '');
                setPériodedessai(response?.data[0]?.Periodedessai || '');
                setAncienneté(response?.data[0]?.Anciennete || '');
                setNomdelemployeur(response?.data[0]?.Nomdelemployeur || '');
                setWilayadelemployeur(response?.data[0]?.Wilayadelemployeur || '');




            } catch (error) {
                setLoadDataWait(false);

                console.error(error.message);
            }
            setLoadDataWait(false);
        }

        fetchData();

    }, []);

    function isValidEmail(string) {
        // The regular expression used by [type="email"]
        var regex = /^([A-Za-z0-9\.])+\@([A-Za-z0-9])+\.([A-Za-z]{2,4})$/;
        // Test the string against the regular expression
        return regex.test(string)
    }


    const [errors, seterrors] = useState({})
    const [err, seterr] = useState([])

    const [Showerrors, setShowerrors] = useState(false)


    useEffect(() => {

        if (Showerrors) {
            const matches = document.querySelectorAll(".err-cart-sum");

            for (let index = 0; index < matches.length; index++) {

                if (matches[index].textContent.trim() !== '') {

                    let position = matches[index].getBoundingClientRect();


                    window.scrollTo(position.left, position.top + window.scrollY - 120);
                    return
                }
                // if (matches[index].textContent.trim() !== '') {

                //     matches[index].scrollIntoView({behavior: "smooth"});
                //     return
                // }              
            }
        }


    }, [Showerrors])


    useEffect(() => {

        const GetCommunedenaissance = async () => {
            try {
                const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/wilayatocommune?valeur=${Wilayadenaissance}`);
                // console.log(response);
                setCommunedenaissanceList(response['communes']);
                // setCommune('')

                if (!ComuneMountdenaissance.current) {
                    setCommunedenaissance('')
                } else {
                    //   setCommune(Local?.communen_naissance || '')
                    ComuneMountdenaissance.current = false
                }
            } catch (error) {
                // console.error(error.message);
            }
        }

        if (Wilayadenaissance !== '') {
            GetCommunedenaissance();
        }



    }, [Wilayadenaissance])



    useEffect(() => {

        const GetCommune = async () => {
            try {
                const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/dairas?valeur=${Wilaya}`);
                // console.log(response);
                setDairaList(response['codepostals'])

                if (!DairaMount.current) {
                    setDaira([])
                    setCommune('')
                    setCodePostal('')
                    setCommuneList([])
                    setCodePostalList([])
                } else {
                    DairaMount.current = false;
                }
            } catch (error) {
                // console.error(error.message);
            }
        }

        if (Wilaya !== '') {
            GetCommune();
        }


    }, [Wilaya])

    useEffect(() => {

        const GetDaira = async () => {
            try {
                const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/commune?valeur=${Daira}`);
                // console.log(response);
                setCommuneList(response['codepostals'])
                if (!ComuneMount.current) {
                    setCommune('')
                    setCodePostal('')
                    setCodePostalList([])
                } else {
                    ComuneMount.current = false
                }

            } catch (error) {
                console.error(error.message);
            }
        }

        if (Daira !== '') {
            GetDaira();
        }


    }, [Daira])

    useEffect(() => {

        const GetCodePostal = async () => {
            try {
                const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/codepostal?valeur=${Commune}`);
                // console.log(response);
                setCodePostalList(response['codepostals'])
                if (!PostalCodeMount.current) {
                    setCodePostal('')
                } else {
                    PostalCodeMount.current = false

                }
            } catch (error) {
                // console.error(error.message);
            }
        }

        if (Commune !== '') {
            GetCodePostal();
        }


    }, [Commune])


    useEffect(() => {

        const Communededélivrence = async () => {
            try {
                const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/wilayatocommune?valeur=${Wilayadedélivrence}`);
                // console.log(response);
                setCommunededélivrenceList(response['communes'])

                if (!CommunededélivrenceMount.current) {
                    setCommunededélivrence('')

                } else {
                    CommunededélivrenceMount.current = false
                }
            } catch (error) {
                // console.error(error.message);
            }
        }

        if (Wilayadedélivrence !== '') {
            Communededélivrence();
        }


    }, [Wilayadedélivrence])


    // useEffect(() => {

    //     const GetCommunedenaissence = async () => {
    //         try {
    //             const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/wilayatocommune?valeur=${Wilayadenaissence}`);


    //             setCommuneList(response['communes'])
    //             // setCommunedenaissence('')

    //             if (!CommuneDeNaissanceMount.current) {
    //                 setCommune('')
    //             } else {
    //                 // setCommune(Local?.communen || '')
    //                 CommuneDeNaissanceMount.current = false
    //             }

    //         } catch (error) {
    //             // console.error(error.message);
    //         }
    //     }

    //     if (Wilayadenaissence !== '') {
    //         GetCommunedenaissence();
    //     }


    // }, [Wilayadenaissence])


    // useEffect(() => {

    //     const GetDaira = async () => {
    //         try {

    //             const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/dairas?valeur=${Wilaya}`);

    //             // setCommunes([])
    //             // setCommune('')
    //             // setCodePostals([])
    //             // setCodePostal('')

    //             setDairas(response['codepostals'])
    //             if (!DairaMount.current) {
    //                 setDaira('')
    //                 setCommunes([])
    //                 setCommune('')
    //                 setCodePostals([])
    //                 setCodePostal('')
    //             } else {
    //                 // setCommune(Local?.communen || '')
    //                 DairaMount.current = false
    //             }

    //         } catch (error) {
    //             // console.error(error.message);
    //         }
    //     }

    //     if (Wilaya !== '') {
    //         GetDaira();
    //     }


    // }, [Wilaya])


    // useEffect(() => {

    //     const GetCommunes = async () => {
    //         try {
    //             const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/commune?valeur=${Daira}`);


    //             // setCodePostals([])
    //             // setCodePostal('')


    //             setCommunes(response['codepostals'])

    //             if (!CommuneMount.current) {

    //                 setCommune('')
    //                 setCodePostals([])
    //                 setCodePostal('')
    //             } else {
    //                 // setCommune(Local?.communen || '')
    //                 CommuneMount.current = false
    //             }

    //         } catch (error) {
    //             // console.error(error.message);
    //         }
    //     }

    //     if (Daira !== '') {
    //         GetCommunes();
    //     }


    // }, [Daira])

    // useEffect(() => {

    //     const GetCodePostal = async () => {
    //         try {
    //             const { data: response } = await axios.get(`https://opr.diardzair.com.dz/ws/region/codepostal?valeur=${Commune}`);
    //             // console.log(response);
    //             // setCodePostal('')
    //             setCodePostals(response['codepostals'])

    //             if (!PostalCodeMount.current) {
    //                 setCodePostal('')
    //             } else {

    //                 // setCodePostal(Local?.codepostal || '')
    //                 PostalCodeMount.current = false

    //             }





    //         } catch (error) {
    //             // console.error(error.message);
    //         }
    //     }

    //     if (Commune !== '') {
    //         GetCodePostal();
    //     }


    // }, [Commune])

    function hasNumber(myString) {
        return /\d/.test(myString);
    }

    function onlyNumbers(str) {
        return /^[0-9]+$/.test(str);
    }






    function GoNext() {
        setShowerr(true)

        // console.log(FormValidate);

        if (!FormValidate) {

            const matches = document.querySelectorAll(".alert-form");

            for (let index = 0; index < matches.length; index++) {

                if (matches[index].textContent.trim() !== '') {

                    let position = matches[index].getBoundingClientRect();


                    window.scrollTo(position.left, position.top + window.scrollY - 120);
                    return
                }
                // if (matches[index].textContent.trim() !== '') {

                //     matches[index].scrollIntoView({behavior: "smooth"});
                //     return
                // }              
            }

            return
        }



        // for (var pair of AllData.entries()) {
        //     console.log(pair[0] + ' - ' + pair[1]);
        // }

        let Data = {
            "demande_type": DemandeType,
            "civilite": Civilite,
            "nom": Nom,
            "prenom": Prenom,
            "prenom_pere": PrenomPere,
            "nom_mere": NomMere,
            "prenom_mere": PrenomMere,
            "date_naissance": Datedenaissance,
            "wilaya_naissance": Wilayadenaissance,
            "communen_naissance": Communedenaissance,
            "num_act_naissance": Actedenaissance,
            "type_act_naissance": Typeactnaissnce,
            "situation_familiale": Situationfamiliale,
            "niveau_dinstructions": NiveauDinstructions,
            "numbre_enfants": Children.toString(),
            "numbre_personnes": Personnes.toString(),
            "wilaya": Wilaya,
            "daira": Daira,
            "commune": Commune,
            "codepostal": CodePostal,
            "adresse": Adresse.trim(),
            "mobile": Mobile,
            "mobile2": Mobile2,
            "email": Mail.trim(),
            "nin": NIN,
            "piece_identite_num": Numerodecartenational,
            "piece_identite_date": DatededElivrence,
            "piece_identite_wilaya": Wilayadedélivrence,
            "piece_identite_commune": Communededélivrence,
            "habitation": Habitation,
            "activite": activité,
            "duree": Time,
            "certificat": Certificat,
            "certificat_type": TypeCertificat,
            "experience": Experience,
            "credit_immobilier": créditempruntimmobilier,
            "mensualite_credit_immobilier": Mensualitéducréditimmobilier,
            "organisme_credit_immobilier": Organismeprêteurimmobilier,
            "date_fin_credit_immobilier": Datedefinducréditimmobilier,
            "credit_voiture": créditvoiture,
            "mensualite_credit_voiture": Mensualitéducréditvoiture,
            "organisme_credit_voiture": Organismeprêteurdecréditvoiture,
            "date_fin_credit_voiture": Datedefinducréditvoiture,
            "autre_credit": Autrecrédit,
            "mensualite_autre_credit": Mensualitéduautrecrédit,
            "organisme_autre_credit": Organismeprêteurautrecrédit,
            "date_fin_autre_credit": Datedefinduautrecrédit,
            "loyer": Loyerpayer,
            "mensualite_loyer": Loyer,



            "profession": Profession.trim(),
            "adresse_de_lemployeur": Adressedelemployeur.trim(),
            "salaire": Salaire,
            "compte_type": Compte,
            "compte_ccp_number": CompteCCP,
            "compte_ccp_cle": CCPClé,
            "compte_bank": Banque,
            "compte_al_salam": SalamBank,
            "autre_sources_de_revenus": sourcesderevenus,


            "temporary_residence": SéjourUSA,
            "green_card": GreenCard,
            "compte_epargne": Compteépargne,
            "compte_epargne_price": CompteépargneText,
            "immeubles_ou_meubles_price": immeublesoumeubles.trim(),


            "type_of_person": TypeOfPerson,
            "ImmatriculationauregistreCommerce": ImmatriculationauregistreCommerce,
            "DateImmatriculationauregistreCommerce": DateImmatriculationauregistreCommerce,
            "LieuImmatriculationauregistreCommerce": LieuImmatriculationauregistreCommerce,
            "Adressedusiege": Adressedusiège,
            "Situationdulocal": Situationdulocal,
            "Datedebutdactivite": Datedébutdactivité,


            "Secteurdactivite": Secteurdactivité,
            "Typedecontrat": Typedecontrat,
            "Periodedessai": Périodedessai,
            "Anciennete": Ancienneté,
            "Nomdelemployeur": Nomdelemployeur,
            "Wilayadelemployeur": Wilayadelemployeur,
        };

        setLoading(true)

        console.log(Data);

        axios.put(`${process.env.REACT_APP_LOCAL_URL}/vendeur/update_vendeur/${id}`, Data, {
            headers: {
                // 'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${Auth?.token}`
            }
        })
            .then(function (response) {

                if (response.data['message'] == 'Token invalid') {
                    setAuth(false);
                    return navigate('/account')

                }

                // if (response.data['email'] && response.data['username'] && response.data['token']) {
                //     console.log(response.data['email'] , response.data['username'] , response.data['token']);
                //     setAuth({email : response.data['email'] , username : response.data['username'] , token :response.data['token']})
                //     setloading(false)
                //     return navigate('/')
                // }

                // console.log(response.data['creditDemandes'][0]);
                // console.log(response.data['creditDemandes'][0]['hash']);

                console.log(response.data);
                setLoading(false)

                if (response.data['error'] == false) {
                    console.log(response.data['err']);
                    Swal.fire({
                        title: 'تم التحديث بنجاح',
                        type: 'success',
                        text: 'تم تحديث معلوماتك بنجاح',
                        timer: 2000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        icon: 'success',

                    }).then(function () {
                        window.location.reload();
                    });
                }


                else {


                    if (response.data['errorList'].constructor == Array) {
                        seterr(response.data['errorList'])
                    }



                    Swal.fire({
                        title: 'هناك مشكل',
                        type: 'error',
                        text: "هناك مشكل في تحديث بياناتك",
                        timer: 2000,
                        showConfirmButton: false,
                        icon: 'error',
                        didClose: () => window.scrollTo(0, 0)



                    });
                }


                // if (response.data['creditDemandes'][0]['hash']) {
                //   return navigate('/validation/' + Formdata[0]['hash'])

                // } else {
                //   setWrong('Il y a un problème avec les données que vous avez saisies, veuillez réessayer')
                //   console.log(response.data);
                // }

                // setloading(false)
                // console.log(response.data);

            }).catch(function (error) {
                // setLoading(false)
                setLoading(false)
                Swal.fire({
                    title: 'هناك مشكل',
                    type: 'error',
                    text: "هناك مشكل في تحديث بياناتك",
                    timer: 2000,
                    showConfirmButton: false,
                    icon: 'error',
                    didClose: () => window.scrollTo(0, 0)



                });

                console.log(error);
            });







        // console.log('test', FormValidate);
    }






    function onlyNumbers(str) {
        return /^[0-9]+$/.test(str);
    }

    function dateIsValid(date) {
        return date instanceof Date && !isNaN(date);
    }

    function afterToday(date, checkdate) {
        if (date <= checkdate) {
            return true;
        } else {
            return false;
        }
    }


    const [Loading, setLoading] = useState(false)

    const WilayaList = [{ "value": "ADRAR", 'text': "(01) ADRAR" },
    { "value": "CHLEF", 'text': "(02) CHLEF" },
    { "value": "LAGHOUAT", 'text': "(03) LAGHOUAT" },
    { "value": "OUM EL BOUAGHI", 'text': "(04) OUM-EL-BOUAGHI" },
    { "value": "BATNA", 'text': "(05) BATNA" },
    { "value": "BEJAIA", 'text': "(06) BEJAIA" },
    { "value": "BISKRA", 'text': "(07) BISKRA" },
    { "value": "BECHAR", 'text': "(08) BECHAR" },
    { "value": "BLIDA", 'text': "(09) BLIDA" },
    { "value": "BOUIRA", 'text': "(10) BOUIRA" },
    { "value": "TAMANRASSET", 'text': "(11) TAMANRASSET" },
    { "value": "TEBESSA", 'text': "(12) TEBESSA" },
    { "value": "TLEMCEN", 'text': "(13) TLEMCEN" },
    { "value": "TIARET", 'text': "(14) TIARET" },
    { "value": "TIZI OUZOU", 'text': "(15) TIZI-OUZOU" },
    { "value": "ALGER", 'text': "(16) ALGER" },
    { "value": "DJELFA", 'text': "(17) DJELFA" },
    { "value": "JIJEL", 'text': "(18) JIJEL" },
    { "value": "SETIF", 'text': "(19) SETIF" },
    { "value": "SAIDA", 'text': "(20) SAIDA" },
    { "value": "SKIKDA", 'text': "(21) SKIKDA" },
    { "value": "SIDI BEL ABBES", 'text': "(22) SIDI-BEL-ABBES" },
    { "value": "ANNABA", 'text': "(23) ANNABA" },
    { "value": "GUELMA", 'text': "(24) GUELMA" },
    { "value": "CONSTANTINE", 'text': "(25) CONSTANTINE" },
    { "value": "MEDEA", 'text': "(26) MEDEA" },
    { "value": "MOSTAGANEM", 'text': "(27) MOSTAGANEM" },
    { "value": "M SILA", 'text': "(28) M-SILA" },
    { "value": "MASCARA", 'text': "(29) MASCARA" },
    { "value": "OUARGLA", 'text': "(30) OUARGLA" },
    { "value": "ORAN", 'text': "(31) ORAN" },
    { "value": "EL BAYADH", 'text': "(32) EL-BAYADH" },
    { "value": "ILLIZI", 'text': "(33) ILLIZI" },
    { "value": "BORDJ BOU ARRERIDJ", 'text': "(34) BORDJ-BOU-ARRERIDJ" },
    { "value": "BOUMERDES", 'text': "(35) BOUMERDES" },
    { "value": "EL TARF", 'text': "(36) EL-TARF" },
    { "value": "TINDOUF", 'text': "(37) TINDOUF" },
    { "value": "TISSEMSILT", 'text': "(38) TISSEMSILT" },
    { "value": "EL OUED", 'text': "(39) EL-OUED" },
    { "value": "KHENCHELA", 'text': "(40) KHENCHELA" },
    { "value": "SOUK AHRAS", 'text': "(41) SOUK-AHRAS" },
    { "value": "TIPAZA", 'text': "(42) TIPAZA" },
    { "value": "MILA", 'text': "(43) MILA" },
    { "value": "AIN DEFLA", 'text': "(44) AIN-DEFLA" },
    { "value": "NAAMA", 'text': "(45) NAAMA" },
    { "value": "AIN TEMOUCHENT", 'text': "(46) AIN-TEMOUCHENT" },
    { "value": "GHARDAIA", 'text': "(47) GHARDAIA" },
    { "value": "RELIZANE", 'text': "(48) RELIZANE" },];



    const ActiviteList = [
        "تاجر", "ماكثة في البيت", "حرفي", "مؤسسة ناشئة", "مصمم", "مطور برامج", "مؤسسة مصغرة", "أخرى"
    ]

    // function GoNext() {
    //     setShowerr(true)

    //     // console.log(FormValidate);

    //     if (!FormValidate) {

    //         const matches = document.querySelectorAll(".alert-form");

    //         for (let index = 0; index < matches.length; index++) {

    //             if (matches[index].textContent.trim() !== '') {

    //                 let position = matches[index].getBoundingClientRect();


    //                 window.scrollTo(position.left, position.top + window.scrollY - 120);
    //                 return
    //             }
    //             // if (matches[index].textContent.trim() !== '') {

    //             //     matches[index].scrollIntoView({behavior: "smooth"});
    //             //     return
    //             // }              
    //         }

    //         return
    //     }

    //     setFormdata((prev) => [
    //         {
    //             ...prev[0], ...{
    //                 "civilite": Civilite,
    //                 "nom": Nom,
    //                 "prenom": Prenom,
    //                 "prenom_pere": PrenomPere,
    //                 "nom_mere": NomMere,
    //                 "prenom_mere": PrenomMere,
    //                 "date_naissance": Datedenaissance,
    //                 "wilaya_naissance": Wilaya,
    //                 "communen_naissance": Commune,
    //                 "num_act_naissance": Actedenaissance,
    //                 "type_act_naissance": Typeactnaissnce,
    //                 "situation_familiale": Situationfamiliale,
    //                 "niveau_dinstructions": NiveauDinstructions,
    //                 "numbre_enfants": Children.toString(),
    //                 "numbre_personnes": Personnes.toString(),
    //             }
    //         }
    //     ])

    //     const FormUserInfo = {
    //         "civilite": Civilite,
    //         "nom": Nom,
    //         "prenom": Prenom,
    //         "prenom_pere": PrenomPere,
    //         "nom_mere": NomMere,
    //         "prenom_mere": PrenomMere,
    //         "date_naissance": Datedenaissance,
    //         "wilaya_naissance": Wilaya,
    //         "communen_naissance": Commune,
    //         "num_act_naissance": Actedenaissance,
    //         "type_act_naissance": Typeactnaissnce,
    //         "situation_familiale": Situationfamiliale,
    //         "niveau_dinstructions": NiveauDinstructions,
    //         "numbre_enfants": Children.toString(),
    //         "numbre_personnes": Personnes.toString(),
    //     }

    //     // localStorage.setItem('FormUserInfoStep1', JSON.stringify(FormUserInfo))

    //     // setStep(2)
    //     // window.scrollTo(0, 0);


    //     // console.log('test', FormValidate);
    // }
    const projects = [
        { id: 1, name: "إستوديو متنقل" },
        { id: 2, name: "مطور برامج" },
        { id: 3, name: "توزيع المياه والسوائل" },
        { id: 4, name: "حلاق" },
        { id: 5, name: "حلاقة" },
        { id: 6, name: "حلويات ومرطبات" },
        { id: 7, name: "صحفي" },
        { id: 8, name: "فاست فود" },
        { id: 9, name: "مسمكة متنقلة" },
        { id: 10, name: "مصمم" },
        { id: 11, name: "مطعم متنقل" },
        { id: 12, name: "مغسلة متنقلة" },
        { id: 13, name: "مقهى" },
        { id: 14, name: "مؤسسة ناشئة" },
        { id: 15, name: "ورشة أليمينيوم" },
        { id: 16, name: "ورشة تدفئة" },
        { id: 17, name: "ورشة خياطة" },
        { id: 18, name: "ورشة ميكانيك" },
        { id: 19, name: "ورشة نجارة" },
        { id: 20, name: "وكالة سياحية" },
    ]

    function GetProjectUrl(id) {

        console.log('hhhhh');

        let urlProject = ProjectsList?.find(o => o.id == id);


        if (urlProject && urlProject?.slug && urlProject?.valid == 1) {

            return urlProject?.slug;
        } else {
            return false
        }
    }



    function onlyLetters(str) {
        return /^[a-zA-Z\s]+$/.test(str);
    }

    const LEFT_TO_RIGHT_MARK = "\u202d"; 

    function onInputChange(event) {
        const newCardNumber = event.target.value.replace(LEFT_TO_RIGHT_MARK, "");
        setImmatriculationauregistreCommerce(newCardNumber);
      }


    return (
        <div className='dashboard'>

            {Loading &&
                <Loader />
            }


            <div className=''>
                <div className=''>

                    <Menu MenuShow={MenuShow} setMenuShow={setMenuShow} />

                </div>
                <div className='page-client pt-lg-5' style={{ marginLeft: windowSize.innerWidth > 992 ? (MenuShow == true ? '328px' : '89px') : '0px' }}>
                    <div className='menu-mobile-section'>
                        <svg onClick={() => setMenuShow((p) => !p)} xmlns="http://www.w3.org/2000/svg" width="22.575" height="22.453" viewBox="0 0 22.575 22.453">
                            <g id="Groupe_429" data-name="Groupe 429" transform="translate(-177.5 120.5)">
                                <line id="Ligne_82" data-name="Ligne 82" x2="22.575" transform="translate(177.5 -119.5)" fill="none" stroke="#fff" stroke-width="2" />
                                <line id="Ligne_83" data-name="Ligne 83" x2="22.575" transform="translate(177.5 -109.273)" fill="none" stroke="#fff" stroke-width="2" />
                                <line id="Ligne_84" data-name="Ligne 84" x2="22.575" transform="translate(177.5 -99.047)" fill="none" stroke="#fff" stroke-width="2" />
                            </g>
                        </svg>
                    </div>
                    <div className='page-title'>Client Informations<span> Iamal </span></div>
                    <div dir='rtl' className='page-content'>
                        {/* {err.length > 0 && err.map((item, i) => (

                            <div className="alert alert-danger" role="alert">
                                {item}
                            </div>

                        ))
                        } */}
                        {/* <div className='form-store'> */}
                        {
                            LoadDataWait ? <LoadData /> : ''
                        }
                        {/* {
                            !LoadDataWait && NoInfo === true ? 
                            <>
                            <h5 className='text-center'>
                                يرجى إختيار المشروع الذي تود الإستفادة منه وقم بملئ معلوماتك
                                </h5>
                               
                                <div className="new-admin-btn" onClick={() => navigate('/projects')} style={{ cursor: "pointer" }}>
                                    مشاريعنا
                                </div></>
                             : ""
                        } */}

                        {!LoadDataWait ?
                            <div style={{ background: 'none' }} className='info-account saidaty'>



                                <div className="d-flex btn-doc mb-5">
                                    <div className="donwload-document-btn me-4" onClick={() => createPdf()}>Ouverture de compte</div>
                                    <div className="donwload-document-btn me-4" onClick={() => createPdf2()}>CENTRALE DES RISQUES</div>
                                    <div className="donwload-document-btn me-4" onClick={() => createPdf3()}>Fiche FATCA</div>
                                    <div className="donwload-document-btn me-4" onClick={() => createPdf4()}>Demande de Financement</div>
                                    <div className="donwload-document-btn me-4" onClick={() => BMCFastFood()}>BMC FAST FOOD</div>
                                    <div className="donwload-document-btn me-4" onClick={() => BMCVegetablesandfruits()}>BMC خضر وفواكه</div>
                                    <div className="donwload-document-btn me-4" onClick={() => BMCCafeteria()}>BMC Cafeteria</div>
                                    <div className="donwload-document-btn me-4" onClick={() => BMCFemme()}>BMC Femme au foyer couturière</div>
                                    <div className="donwload-document-btn me-4" onClick={() => BMCFemmeaufoyergateaux()}>BMC Femme au foyer gateaux et plats traditionnels</div>


                                    <div className="donwload-document-btn me-4" onClick={() => Rapport()}>Rapport d'entretien</div>
                                    <div className="donwload-document-btn me-4" onClick={() => ANNEXE03()}>ANNEXE 03 تصريح بالالتزام</div>
                                    <div className="donwload-document-btn me-4" onClick={() => PrintPDF()}>Bordereau d'envoi Ramassage</div>
                                    <div className="donwload-document-btn me-4" onClick={() => PrintPDFLivraison()}>Bordereau d'envoi Garanties</div>

                                    <a target='blank' href='/ANNEXE 02 طلب تمويل المصغر (مؤسسات صغيرة وحرفيين).docx'><div className="donwload-document-btn me-4"> Demande de Financement TPE /ARTISAN </div></a>


                                </div>

                                <div className="row g-5 client-ar-info  form-info">
                                    {err?.length > 0 ?
                                        <div className='container py-3 '>
                                            {err?.length > 0 && err?.map((item, i) => (

                                                item.constructor == String ?
                                                    <div className="alert-store" role="alert">
                                                        - {item}
                                                    </div>
                                                    : ''

                                            ))
                                            }

                                        </div> : ''}


                                    <div className="col-md-12" dir='rtl'>
                                        <div className='mb-2'>نوع الطلبية</div>

                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions199" id="inlineRadio199" checked={DemandeType == 0} onChange={(e) => setDemandeType(e.target.value)} defaultChecked={true} defaultValue="0" />
                                            <label className="form-check-label" htmlFor="inlineRadio199">طلب تمويل</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions299" id="inlineRadio299" checked={DemandeType == 1} onChange={(e) => setDemandeType(e.target.value)} defaultValue="1" />
                                            <label className="form-check-label" htmlFor="inlineRadio299">
                                                تجديد التمويل
                                            </label>
                                        </div>
                                    </div>



                                    <div className="col-md-12" dir='rtl'>
                                        <div className='mb-2'>{(infoperssonnelle['civilité'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" checked={Civilite == 'M'} onChange={(e) => setCivilite(e.target.value)} defaultChecked={true} defaultValue="M" />
                                            <label className="form-check-label" htmlFor="inlineRadio1">{(infoperssonnelle['civ1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" checked={Civilite == 'Mme'} onChange={(e) => setCivilite(e.target.value)} defaultValue="Mme" />
                                            <label className="form-check-label" htmlFor="inlineRadio2">{(infoperssonnelle['civ2'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" checked={Civilite == 'Mle'} onChange={(e) => setCivilite(e.target.value)} defaultValue="Mle" />
                                            <label className="form-check-label" htmlFor="inlineRadio3">{(infoperssonnelle['civ3'][Lang])}</label>
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-5 mt-5">
                                        <label className="form-label">{(infoperssonnelle['Nom'][Lang])}</label>
                                        <input maxLength={250} type="text" placeholder={(infoperssonnelle['Nom'][Lang])} onChange={(e) => setNom(e.target.value.replace(/[^a-zA-Z\s]+/g, ''))} value={Nom} className="form-control" id="inputEmail4" />
                                        <span className='note-form'>الكتابة بالأحرف الاتينية</span>

                                        <div className='alert-form'>{Showerr && (Nom.trim().length < 2 ? (infoperssonnelle['msgerr1'][Lang]) : '')}</div>



                                    </div>
                                    <div className="col-md-6 mb-5 mt-md-5">
                                        <label className="form-label">{(infoperssonnelle['Prénom'][Lang])}</label>
                                        <input maxLength={250} type="text" placeholder={(infoperssonnelle['Prénom'][Lang])} onChange={(e) => setPrenom(e.target.value.replace(/[^a-zA-Z\s]+/g, ''))} value={Prenom} className="form-control" id="inputEmail4" />
                                        <span className='note-form'>الكتابة بالأحرف الاتينية</span>

                                        <div className='alert-form'>{Showerr && (Prenom.trim().length < 2 ? (infoperssonnelle['msgerr3'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        <label className="form-label">{(infoperssonnelle['Prénompère'][Lang])}</label>
                                        <input maxLength={250} type="text" placeholder={(infoperssonnelle['Prénompère'][Lang])} onChange={(e) => setPrenomPere(e.target.value.replace(/[^a-zA-Z\s]+/g, ''))} value={PrenomPere} className="form-control" id="inputEmail4" />
                                        <span className='note-form'>الكتابة بالأحرف الاتينية</span>

                                        <div className='alert-form'>{Showerr && (PrenomPere.trim().length < 2 ? (infoperssonnelle['msgerr5'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        <label className="form-label">{(infoperssonnelle['Nommère'][Lang])}</label>
                                        <input maxLength={250} type="text" placeholder={(infoperssonnelle['Nommère'][Lang])} onChange={(e) => setNomMere(e.target.value.replace(/[^a-zA-Z\s]+/g, ''))} value={NomMere} className="form-control" id="inputEmail4" />
                                        <span className='note-form'>الكتابة بالأحرف الاتينية</span>

                                        <div className='alert-form'>{Showerr && (NomMere.trim().length < 2 ? (infoperssonnelle['msgerr7'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        <label className="form-label">{(infoperssonnelle['Prenommère'][Lang])}</label>
                                        <input maxLength={250} type="text" placeholder={(infoperssonnelle['Prenommère'][Lang])} onChange={(e) => setPrenomMere(e.target.value.replace(/[^a-zA-Z\s]+/g, ''))} value={PrenomMere} className="form-control" id="inputEmail4" />
                                        <span className='note-form'>الكتابة بالأحرف الاتينية</span>

                                        <div className='alert-form'>{Showerr && (PrenomMere.trim().length < 2 ? (infoperssonnelle['msgerr9'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        <label className="form-label">{(infoperssonnelle['Date_naissance'][Lang])}</label>
                                        <input type="date" onChange={(e) => setDatedenaissance(e.target.value)} defaultValue={Datedenaissance} className="form-control" id="inputEmail4" />
                                        <div className='alert-form'>{Showerr && (Datedenaissance == "" || !dateIsValid(new Date(Datedenaissance)) ? (infoperssonnelle['msgerr11'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        <label className="form-label">{(infoperssonnelle['Wilaya_naissance'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setWilayadenaissance(e.target.value)}>
                                            <option disabled selected="selected">{(Global['wilaya'][Lang])}</option>
                                            <option selected={Wilayadenaissance === "ADRAR"} value="ADRAR">(01) ADRAR</option>
                                            <option selected={Wilayadenaissance === "CHLEF"} value="CHLEF">(02) CHLEF</option>
                                            <option selected={Wilayadenaissance === "LAGHOUAT"} value="LAGHOUAT">(03) LAGHOUAT</option>
                                            <option selected={Wilayadenaissance === "OUM EL BOUAGHI"} value="OUM EL BOUAGHI">(04) OUM-EL-BOUAGHI</option>
                                            <option selected={Wilayadenaissance === "BATNA"} value="BATNA">(05) BATNA</option>
                                            <option selected={Wilayadenaissance === "BEJAIA"} value="BEJAIA">(06) BEJAIA</option>
                                            <option selected={Wilayadenaissance === "BISKRA"} value="BISKRA">(07) BISKRA</option>
                                            <option selected={Wilayadenaissance === "BECHAR"} value="BECHAR">(08) BECHAR</option>
                                            <option selected={Wilayadenaissance === "BLIDA"} value="BLIDA">(09) BLIDA</option>
                                            <option selected={Wilayadenaissance === "BOUIRA"} value="BOUIRA">(10) BOUIRA</option>
                                            <option selected={Wilayadenaissance === "TAMANRASSET"} value="TAMANRASSET">(11) TAMANRASSET</option>
                                            <option selected={Wilayadenaissance === "TEBESSA"} value="TEBESSA">(12) TEBESSA</option>
                                            <option selected={Wilayadenaissance === "TLEMCEN"} value="TLEMCEN">(13) TLEMCEN</option>
                                            <option selected={Wilayadenaissance === "TIARET"} value="TIARET">(14) TIARET</option>
                                            <option selected={Wilayadenaissance === "TIZI OUZOU"} value="TIZI OUZOU">(15) TIZI-OUZOU</option>
                                            <option selected={Wilayadenaissance === "ALGER"} value="ALGER">(16) ALGER</option>
                                            <option selected={Wilayadenaissance === "DJELFA"} value="DJELFA">(17) DJELFA</option>
                                            <option selected={Wilayadenaissance === "JIJEL"} value="JIJEL">(18) JIJEL</option>
                                            <option selected={Wilayadenaissance === "SETIF"} value="SETIF">(19) SETIF</option>
                                            <option selected={Wilayadenaissance === "SAIDA"} value="SAIDA">(20) SAIDA</option>
                                            <option selected={Wilayadenaissance === "SKIKDA"} value="SKIKDA">(21) SKIKDA</option>
                                            <option selected={Wilayadenaissance === "SIDI BEL ABBES"} value="SIDI BEL ABBES">(22) SIDI-BEL-ABBES</option>
                                            <option selected={Wilayadenaissance === "ANNABA"} value="ANNABA">(23) ANNABA</option>
                                            <option selected={Wilayadenaissance === "GUELMA"} value="GUELMA">(24) GUELMA</option>
                                            <option selected={Wilayadenaissance === "CONSTANTINE"} value="CONSTANTINE">(25) CONSTANTINE</option>
                                            <option selected={Wilayadenaissance === "MEDEA"} value="MEDEA">(26) MEDEA</option>
                                            <option selected={Wilayadenaissance === "MOSTAGANEM"} value="MOSTAGANEM">(27) MOSTAGANEM</option>
                                            <option selected={Wilayadenaissance === "M SILA"} value="M SILA">(28) M-SILA</option>
                                            <option selected={Wilayadenaissance === "MASCARA"} value="MASCARA">(29) MASCARA</option>
                                            <option selected={Wilayadenaissance === "OUARGLA"} value="OUARGLA">(30) OUARGLA</option>
                                            <option selected={Wilayadenaissance === "ORAN"} value="ORAN">(31) ORAN</option>
                                            <option selected={Wilayadenaissance === "EL BAYADH"} value="EL BAYADH">(32) EL-BAYADH</option>
                                            <option selected={Wilayadenaissance === "ILLIZI"} value="ILLIZI">(33) ILLIZI</option>
                                            <option selected={Wilayadenaissance === "BORDJ BOU ARRERIDJ"} value="BORDJ BOU ARRERIDJ">(34) BORDJ-BOU-ARRERIDJ</option>
                                            <option selected={Wilayadenaissance === "BOUMERDES"} value="BOUMERDES">(35) BOUMERDES</option>
                                            <option selected={Wilayadenaissance === "EL TARF"} value="EL TARF">(36) EL-TARF</option>
                                            <option selected={Wilayadenaissance === "TINDOUF"} value="TINDOUF">(37) TINDOUF</option>
                                            <option selected={Wilayadenaissance === "TISSEMSILT"} value="TISSEMSILT">(38) TISSEMSILT</option>
                                            <option selected={Wilayadenaissance === "EL OUED"} value="EL OUED">(39) EL-OUED</option>
                                            <option selected={Wilayadenaissance === "KHENCHELA"} value="KHENCHELA">(40) KHENCHELA</option>
                                            <option selected={Wilayadenaissance === "SOUK AHRAS"} value="SOUK AHRAS">(41) SOUK-AHRAS</option>
                                            <option selected={Wilayadenaissance === "TIPAZA"} value="TIPAZA">(42) TIPAZA</option>
                                            <option selected={Wilayadenaissance === "MILA"} value="MILA">(43) MILA</option>
                                            <option selected={Wilayadenaissance === "AIN DEFLA"} value="AIN DEFLA">(44) AIN-DEFLA</option>
                                            <option selected={Wilayadenaissance === "NAAMA"} value="NAAMA">(45) NAAMA</option>
                                            <option selected={Wilayadenaissance === "AIN TEMOUCHENT"} value="AIN TEMOUCHENT">(46) AIN-TEMOUCHENT</option>
                                            <option selected={Wilayadenaissance === "GHARDAIA"} value="GHARDAIA">(47) GHARDAIA</option>
                                            <option selected={Wilayadenaissance === "RELIZANE"} value="RELIZANE">(48) RELIZANE</option>
                                            {/* <option selected={Wilaya === "Timimoun"} value="Timimoun">(49) Timimoun</option>
      <option selected={Wilaya === "Bordj Badji Mokhtar"} value="Bordj Badji Mokhtar">(50) Bordj Badji Mokhtar</option>
      <option selected={Wilaya === "Ouled Djellal"} value="Ouled Djellal">(51) Ouled Djellal</option>
      <option selected={Wilaya === "Béni Abbès"} value="Béni Abbès">(52) Béni Abbès</option>
      <option selected={Wilaya === "In Salah"} value="In Salah">(53) In Salah</option>
      <option selected={Wilaya === "In Guezzam"} value="In Guezzam">(54) In Guezzam</option>
      <option selected={Wilaya === "Touggourt"} value="Touggourt">(55) Touggourt</option>
      <option selected={Wilaya === "Djanet"} value="Djanet">(56) Djanet</option>
      <option selected={Wilaya === "El M'Ghair"} value="El M'Ghair">(57) El M'Ghair</option>
      <option selected={Wilaya === "El Meniaa"} value="El Meniaa">(58) El Meniaa</option> */}
                                        </select>
                                        <div className='alert-form'>{Showerr && (Wilayadenaissance == "" ? (infoperssonnelle['msgerr12'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        <label htmlFor="inputPassword4" className="form-label">{(infoperssonnelle['Commune_naissance'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setCommunedenaissance(e.target.value)}>

                                            {/* {
        CommuneList.length == 0 && <option disabled selected="selected">{(infoperssonnelle['Commune_naissance'][Lang])}</option>
      }

      {
        CommuneList.length > 0 && <option disabled selected="selected">{(infoperssonnelle['Commune_naissance'][Lang])}</option>
      } */}

                                            <option disabled selected={Communedenaissance == "" ? "selected" : ''}>{(infoperssonnelle['Commune_naissance'][Lang])}</option>

                                            {CommunedenaissanceList.length > 0 && CommunedenaissanceList.map((item, i) => (

                                                <option selected={Communedenaissance === item?.commune} value={item?.commune}>{item?.commune}</option>

                                            ))
                                            }
                                        </select>
                                        <div className='alert-form'>{Showerr && (Communedenaissance == "" ? (infoperssonnelle['msgerr13'][Lang]) : '')}</div>
                                    </div>
                                    {/* <label htmlFor="inputPassword4" className="form-label">Numéro d'acte de naissance</label> */}
                                    <div className="col-md-6 mb-5">
                                        <label className="form-label">{(infoperssonnelle['Num_act_naissance'][Lang])}</label>
                                        <input type="tel" maxlength="5" placeholder={(infoperssonnelle['Num_act_naissance'][Lang])} onChange={(e) => setActedenaissance(e.target.value.replace(/[^0-9]+/g, ''))} value={Actedenaissance} className="form-control me-2" id="inputPassword4" />
                                        <span className='note-form'>الكتابة بالأرقام</span>
                                        <div className='alert-form'>{Showerr && (Actedenaissance == "" || Actedenaissance.trim().length !== 5 ? (infoperssonnelle['msgerr14'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        {/* <input type="text" onChange={(e) => setActedenaissance(e.target.value.replace(/[^0-9]+/g , ''))} value={Actedenaissance} className="form-control me-2" id="inputPassword4" /> */}
                                        <label className="form-label">{(infoperssonnelle['type_acte'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setTypeactnaissnce(e.target.value)}>
                                            <option disabled selected="selected">{(infoperssonnelle['type_acte'][Lang])}</option>
                                            <option selected={"biss" === Typeactnaissnce} value="biss">BISS </option>
                                            <option selected={"ter" === Typeactnaissnce} value="ter">TER</option>
                                            <option selected={"autre" === Typeactnaissnce} value="autre">Autre</option>
                                        </select>
                                        <div className='alert-form'>{Showerr && (Typeactnaissnce == "" ? (infoperssonnelle['msgerr15'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        <label htmlFor="inputPassword4" className="form-label" >{(infoperssonnelle['situation_familiale'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setSituationfamiliale(e.target.value)}>
                                            <option disabled selected="selected">{(infoperssonnelle['situation_familiale'][Lang])}</option>

                                            {infoperssonnelle['situation_familiale_list']?.length > 0 && infoperssonnelle['situation_familiale_list']?.map((item, i) => (
                                                <option selected={Situationfamiliale === item['fr']} value={item['fr']}>{item[Lang]}</option>
                                            ))
                                            }
                                            {/* <option selected={Situationfamiliale === "c"} value="c">Célibataire</option>
      <option selected={Situationfamiliale === "m"} value="m">Marié </option>
      <option selected={Situationfamiliale === "d"} value="d">Divorcé</option>
      <option selected={Situationfamiliale === "v"} value="v">veuf</option> */}
                                        </select>
                                        <div className='alert-form'>{Showerr && (Situationfamiliale == "" ? (infoperssonnelle['msgerr16'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-5">
                                        <label htmlFor="inputPassword4" className="form-label" >{(infoperssonnelle['Niveau'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setNiveauDinstructions(e.target.value)}>
                                            <option disabled selected="selected">{(infoperssonnelle['Niveau'][Lang])}</option>

                                            {infoperssonnelle['Niveau_list']?.length > 0 && infoperssonnelle['Niveau_list']?.map((item, i) => (
                                                <option selected={NiveauDinstructions == item['fr']} value={item['fr']}>{item[Lang]}</option>
                                            ))
                                            }
                                            {/* <option selected={NiveauDinstructions == 1} value={1}>Moins que le niveau secondaire</option>
      <option selected={NiveauDinstructions == 2} value={2}>Niveau secondaire</option>
      <option selected={NiveauDinstructions == 3} value={3}>Bachelier</option>
      <option selected={NiveauDinstructions == 4} value={4}>Universitaire</option> */}
                                        </select>
                                        <div className='alert-form'>{Showerr && (NiveauDinstructions == "" ? (infoperssonnelle['msgerr17'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-12 mb-2 mt-3">
                                        <label htmlFor="inputPassword4" className="form-label">{(infoperssonnelle['nbrEnfants'][Lang])}</label>
                                        <div className='product-quantity'>{(infoperssonnelle['1'][Lang])} :
                                            <div className='quantity-btn'>
                                                <button className="qtyminus" onClick={() => Children !== 0 ? setChildren(Children - 1) : ''} aria-hidden="true">−</button>
                                                <input className='qtyinput' onKeyPress="event.preventDefault();" type="number" name="qty" id="qty" min={1} step={1} value={Children} />
                                                <button className="qtyplus" onClick={() => Children < 10 ? setChildren(Children + 1) : ''} aria-hidden="true">+</button>
                                            </div>
                                        </div>
                                        {/* <input type="number" max={2} min={0} className="form-control" id="inputPassword4" /> */}
                                    </div>
                                    <div className="col-md-12 mb-5 mt-3">
                                        <label htmlFor="inputPassword4" className="form-label">{(infoperssonnelle['nbrpersonnes'][Lang])}</label>
                                        <div className='product-quantity'>{(infoperssonnelle['2'][Lang])} :
                                            <div className='quantity-btn'>
                                                <button className="qtyminus" onClick={() => Personnes !== 0 ? setPersonnes(Personnes - 1) : ''} aria-hidden="true">−</button>
                                                <input className='qtyinput' onKeyPress="event.preventDefault();" type="number" name="qty" id="qty" min={1} step={1} value={Personnes} />
                                                <button className="qtyplus" onClick={() => Personnes < 10 ? setPersonnes(Personnes + 1) : ''} aria-hidden="true">+</button>
                                            </div>
                                        </div>
                                        {/* <input type="number" max={2} min={0} className="form-control" id="inputPassword4" /> */}
                                    </div>





                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">{(adresse['Wilaya'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setWilaya(e.target.value)}>
                                            <option disabled selected="selected">{(adresse['Wilaya'][Lang])}</option>
                                            <option selected={Wilaya === "ADRAR"} value="ADRAR">(01) ADRAR</option>
                                            <option selected={Wilaya === "CHLEF"} value="CHLEF">(02) CHLEF</option>
                                            <option selected={Wilaya === "LAGHOUAT"} value="LAGHOUAT">(03) LAGHOUAT</option>
                                            <option selected={Wilaya === "OUM EL BOUAGHI"} value="OUM EL BOUAGHI">(04) OUM-EL-BOUAGHI</option>
                                            <option selected={Wilaya === "BATNA"} value="BATNA">(05) BATNA</option>
                                            <option selected={Wilaya === "BEJAIA"} value="BEJAIA">(06) BEJAIA</option>
                                            <option selected={Wilaya === "BISKRA"} value="BISKRA">(07) BISKRA</option>
                                            <option selected={Wilaya === "BECHAR"} value="BECHAR">(08) BECHAR</option>
                                            <option selected={Wilaya === "BLIDA"} value="BLIDA">(09) BLIDA</option>
                                            <option selected={Wilaya === "BOUIRA"} value="BOUIRA">(10) BOUIRA</option>
                                            <option selected={Wilaya === "TAMANRASSET"} value="TAMANRASSET">(11) TAMANRASSET</option>
                                            <option selected={Wilaya === "TEBESSA"} value="TEBESSA">(12) TEBESSA</option>
                                            <option selected={Wilaya === "TLEMCEN"} value="TLEMCEN">(13) TLEMCEN</option>
                                            <option selected={Wilaya === "TIARET"} value="TIARET">(14) TIARET</option>
                                            <option selected={Wilaya === "TIZI OUZOU"} value="TIZI OUZOU">(15) TIZI-OUZOU</option>
                                            <option selected={Wilaya === "ALGER"} value="ALGER">(16) ALGER</option>
                                            <option selected={Wilaya === "DJELFA"} value="DJELFA">(17) DJELFA</option>
                                            <option selected={Wilaya === "JIJEL"} value="JIJEL">(18) JIJEL</option>
                                            <option selected={Wilaya === "SETIF"} value="SETIF">(19) SETIF</option>
                                            <option selected={Wilaya === "SAIDA"} value="SAIDA">(20) SAIDA</option>
                                            <option selected={Wilaya === "SKIKDA"} value="SKIKDA">(21) SKIKDA</option>
                                            <option selected={Wilaya === "SIDI BEL ABBES"} value="SIDI BEL ABBES">(22) SIDI-BEL-ABBES</option>
                                            <option selected={Wilaya === "ANNABA"} value="ANNABA">(23) ANNABA</option>
                                            <option selected={Wilaya === "GUELMA"} value="GUELMA">(24) GUELMA</option>
                                            <option selected={Wilaya === "CONSTANTINE"} value="CONSTANTINE">(25) CONSTANTINE</option>
                                            <option selected={Wilaya === "MEDEA"} value="MEDEA">(26) MEDEA</option>
                                            <option selected={Wilaya === "MOSTAGANEM"} value="MOSTAGANEM">(27) MOSTAGANEM</option>
                                            <option selected={Wilaya === "M SILA"} value="M SILA">(28) M-SILA</option>
                                            <option selected={Wilaya === "MASCARA"} value="MASCARA">(29) MASCARA</option>
                                            <option selected={Wilaya === "OUARGLA"} value="OUARGLA">(30) OUARGLA</option>
                                            <option selected={Wilaya === "ORAN"} value="ORAN">(31) ORAN</option>
                                            <option selected={Wilaya === "EL BAYADH"} value="EL BAYADH">(32) EL-BAYADH</option>
                                            <option selected={Wilaya === "ILLIZI"} value="ILLIZI">(33) ILLIZI</option>
                                            <option selected={Wilaya === "BORDJ BOU ARRERIDJ"} value="BORDJ BOU ARRERIDJ">(34) BORDJ-BOU-ARRERIDJ</option>
                                            <option selected={Wilaya === "BOUMERDES"} value="BOUMERDES">(35) BOUMERDES</option>
                                            <option selected={Wilaya === "EL TARF"} value="EL TARF">(36) EL-TARF</option>
                                            <option selected={Wilaya === "TINDOUF"} value="TINDOUF">(37) TINDOUF</option>
                                            <option selected={Wilaya === "TISSEMSILT"} value="TISSEMSILT">(38) TISSEMSILT</option>
                                            <option selected={Wilaya === "EL OUED"} value="EL OUED">(39) EL-OUED</option>
                                            <option selected={Wilaya === "KHENCHELA"} value="KHENCHELA">(40) KHENCHELA</option>
                                            <option selected={Wilaya === "SOUK AHRAS"} value="SOUK AHRAS">(41) SOUK-AHRAS</option>
                                            <option selected={Wilaya === "TIPAZA"} value="TIPAZA">(42) TIPAZA</option>
                                            <option selected={Wilaya === "MILA"} value="MILA">(43) MILA</option>
                                            <option selected={Wilaya === "AIN DEFLA"} value="AIN DEFLA">(44) AIN-DEFLA</option>
                                            <option selected={Wilaya === "NAAMA"} value="NAAMA">(45) NAAMA</option>
                                            <option selected={Wilaya === "AIN TEMOUCHENT"} value="AIN TEMOUCHENT">(46) AIN-TEMOUCHENT</option>
                                            <option selected={Wilaya === "GHARDAIA"} value="GHARDAIA">(47) GHARDAIA</option>
                                            <option selected={Wilaya === "RELIZANE"} value="RELIZANE">(48) RELIZANE</option>
                                            {/* <option selected={Wilaya === "Timimoun"} value="Timimoun">(49) Timimoun</option>
        <option selected={Wilaya === "Bordj Badji Mokhtar"} value="Bordj Badji Mokhtar">(50) Bordj Badji Mokhtar</option>
        <option selected={Wilaya === "Ouled Djellal"} value="Ouled Djellal">(51) Ouled Djellal</option>
        <option selected={Wilaya === "Béni Abbès"} value="Béni Abbès">(52) Béni Abbès</option>
        <option selected={Wilaya === "In Salah"} value="In Salah">(53) In Salah</option>
        <option selected={Wilaya === "In Guezzam"} value="In Guezzam">(54) In Guezzam</option>
        <option selected={Wilaya === "Touggourt"} value="Touggourt">(55) Touggourt</option>
        <option selected={Wilaya === "Djanet"} value="Djanet">(56) Djanet</option>
        <option selected={Wilaya === "El M'Ghair"} value="El M'Ghair">(57) El M'Ghair</option>
        <option selected={Wilaya === "El Meniaa"} value="El Meniaa">(58) El Meniaa</option> */}
                                        </select>
                                        <div className='alert-form'>{Showerr && (Wilaya == "" ? (adresse['msgerr1'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="inputPassword4" className="form-label">{(adresse['Daïras'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setDaira(e.target.value)}>

                                            {/* {DairaList.length == 0 || DairaList.length > 0 && */}
                                            <option disabled selected={Daira == '' ? "selected" : ''}>{(adresse['Daïras'][Lang])}</option>
                                            {/* } */}


                                            {DairaList.length > 0 && DairaList.map((item, i) => (
                                                <option selected={Daira === item?.dairas} value={item?.dairas}>{item?.dairas}</option>
                                            ))
                                            }
                                        </select>
                                        <div className='alert-form'>{Showerr && (Daira == "" ? (adresse['msgerr2'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="inputPassword4" className="form-label">{(adresse['Commune'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setCommune(e.target.value)}>

                                            {/* {CommuneList.length === 0 || CommuneList.length > 0 && */}
                                            <option disabled selected={Commune == "" ? "selected" : ''}>{(adresse['Commune'][Lang])}</option>
                                            {/* } */}


                                            {CommuneList.length > 0 && CommuneList.map((item, i) => (
                                                <option selected={Commune === item?.commune} value={item?.commune}>{item?.commune}</option>
                                            ))
                                            }
                                        </select>
                                        <div className='alert-form'>{Showerr && (Commune == "" ? (adresse['msgerr3'][Lang]) : '')}</div>

                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="inputPassword4" className="form-label">{(adresse['Codepostal'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setCodePostal(e.target.value)}>

                                            {/* { CodePostalList.length === 0 || CodePostalList.length > 0 && */}

                                            <option disabled selected={CodePostal == '' ? "selected" : ''}>{(adresse['Codepostal'][Lang])}</option>
                                            {/* } */}

                                            {CodePostalList.length > 0 && CodePostalList.map((item, i) => (
                                                <option selected={CodePostal === item?.codePostal} value={item?.codePostal}>{item?.codePostal}</option>
                                            ))
                                            }
                                        </select>
                                        <div className='alert-form'>{Showerr && (CodePostal == "" ? (adresse['msgerr4'][Lang]) : '')}</div>
                                    </div>

                                    

                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">{(adresse['Adresse'][Lang])}</label>
                                        <input maxLength={255} type="text" placeholder={(adresse['Adresse'][Lang])} onChange={(e) => setAdresse(e.target.value.replace(/[^a-zA-Z0-9\-/\°\,\.\'\é\à\è\ù\ç\â\ê\î\ô\û\ë\ï\ü\æ\À\Â\Ä\Ç\È\É\Ê\Î\Ô\Œ\s]+/g, ''))} value={Adresse} className="form-control" id="inputEmail4" />
                                        {/* <span className='note-form'>الكتابة بالأحرف الاتينية</span> */}
                                        <div className='alert-form'>{Showerr && (Adresse.trim() == "" ? (adresse['msgerr5'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">{(adresse['Mobile'][Lang])}</label>
                                        <input maxlength="10" type="tel" placeholder={(adresse['Mobile'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setMobile(e.target.value.replace(/[^0-9]+/g, ''))} value={Mobile} />
                                        <span className='note-form'>{(adresse['msg2'][Lang])}</span>
                                        <div className='alert-form'>{Showerr && (Mobile == "" ? (adresse['msgerr6'][Lang]) : '')}</div>
                                        <div className='alert-form'>{Showerr && (!onlyNumbers(Mobile) || Mobile.length !== 10 || (Mobile.slice(0, 2) !== "07" && Mobile.slice(0, 2) !== "05" && Mobile.slice(0, 2) !== "06")) ? (adresse['msgerr61'][Lang]) : ''}</div>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">{(adresse['Mobile2'][Lang])}</label>
                                        <input maxlength="10" type="tel" placeholder={(adresse['Mobile2'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setMobile2(e.target.value.replace(/[^0-9]+/g, ''))} value={Mobile2} />
                                        <span className='note-form'>{(adresse['msg2'][Lang])}</span>
                                        {/* <div className='alert-form'>{Showerr && (Mobile2 == "" ? (adresse['msgerr6'][Lang]) : '')}</div>
      <div className='alert-form'>{Showerr && (!onlyNumbers(Mobile2) || Mobile2.length !== 10 || (Mobile2.slice(0, 2) !== "07" && Mobile2.slice(0, 2) !== "05" && Mobile2.slice(0, 2) !== "06")) ? (adresse['msgerr61'][Lang]) : ''}</div>
      <div className='alert-form'>{Showerr && (Mobile2 == Mobile ? (adresse['msgerr62'][Lang]) : '')}</div> */}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">{(adresse['email'][Lang])}</label>
                                        <input maxLength={255} type="email" placeholder={(adresse['email'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setMail(e.target.value.trim())} value={Mail.trim()} />
                                        <div className='alert-form'>{Showerr && (Mail.trim() == "" ? (adresse['msgerr7'][Lang]) : '')}</div>
                                        <div className='alert-form'>{Showerr && (!isValidEmail(Mail.trim()) ? (adresse['msgerr71'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">{(adresse['confirmemail'][Lang])}</label>
                                        <input maxLength={255} type="email" placeholder={(adresse['confirmemail'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setReMail(e.target.value.trim())} value={ReMail.trim()} />
                                        <div className='alert-form'>{Showerr && (ReMail.trim() == "" ? (adresse['msgerr7'][Lang]) : '')}</div>
                                        <div className='alert-form'>{Showerr && (!isValidEmail(ReMail.trim()) ? (adresse['msgerr71'][Lang]) : '')}</div>
                                        <div className='alert-form'>{Showerr && (ReMail.trim() !== Mail.trim() ? (adresse['msgerr9'][Lang]) : '')}</div>

                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">{(adresse['NIN'][Lang])} </label>
                                        <input maxlength="18" type="tel" placeholder={(adresse['NIN'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setNIN(e.target.value.replace(/[^0-9]+/g, ''))} value={NIN} />
                                        <span className='note-form'>{(adresse['msg3'][Lang])}</span>
                                        <div className='alert-form'>{Showerr && (NIN == "" ? (adresse['msgerr10'][Lang]) : '')}</div>
                                        <div className='alert-form'>{Showerr && (NIN.length !== 18 ? (adresse['msgerr11'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">{(adresse['numcn'][Lang])}</label>
                                        <input maxlength="9" type="tel" placeholder={(adresse['numcn'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setNumerodecartenational(e.target.value.replace(/[^0-9]+/g, ''))} value={Numerodecartenational} />
                                        <span className='note-form'>الكتابة بالأرقام</span>
                                        <div className='alert-form'>{Showerr && (Numerodecartenational == "" ? (adresse['msgerr12'][Lang]) : '')}</div>
                                        <div className='alert-form'>{Showerr && (Numerodecartenational.length !== 9 ? (adresse['msgerr12-'][Lang]) : '')}</div>

                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">{(adresse['Date_délivrence'][Lang])}</label>
                                        <input type="date" className="form-control" id="inputEmail4" max={new Date().toISOString().slice(0, 10)} onChange={(e) => setDatededElivrence(e.target.value)} value={DatededElivrence} />
                                        {/* <span className='note-form'>Veuillez choisir une date dans le calendrier</span> */}
                                        <div className='alert-form'>{Showerr && (DatededElivrence == "" ? (adresse['msgerr13'][Lang]) : '')}</div>
                                    </div>


                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">{(adresse['Wilaya_délivrence'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setWilayadedélivrence(e.target.value)}>
                                            <option disabled selected="selected">{(adresse['Wilaya'][Lang])}</option>
                                            <option selected={Wilayadedélivrence === "ADRAR"} value="ADRAR">(01) ADRAR</option>
                                            <option selected={Wilayadedélivrence === "CHLEF"} value="CHLEF">(02) CHLEF</option>
                                            <option selected={Wilayadedélivrence === "LAGHOUAT"} value="LAGHOUAT">(03) LAGHOUAT</option>
                                            <option selected={Wilayadedélivrence === "OUM EL BOUAGHI"} value="OUM EL BOUAGHI">(04) OUM-EL-BOUAGHI</option>
                                            <option selected={Wilayadedélivrence === "BATNA"} value="BATNA">(05) BATNA</option>
                                            <option selected={Wilayadedélivrence === "BEJAIA"} value="BEJAIA">(06) BEJAIA</option>
                                            <option selected={Wilayadedélivrence === "BISKRA"} value="BISKRA">(07) BISKRA</option>
                                            <option selected={Wilayadedélivrence === "BECHAR"} value="BECHAR">(08) BECHAR</option>
                                            <option selected={Wilayadedélivrence === "BLIDA"} value="BLIDA">(09) BLIDA</option>
                                            <option selected={Wilayadedélivrence === "BOUIRA"} value="BOUIRA">(10) BOUIRA</option>
                                            <option selected={Wilayadedélivrence === "TAMANRASSET"} value="TAMANRASSET">(11) TAMANRASSET</option>
                                            <option selected={Wilayadedélivrence === "TEBESSA"} value="TEBESSA">(12) TEBESSA</option>
                                            <option selected={Wilayadedélivrence === "TLEMCEN"} value="TLEMCEN">(13) TLEMCEN</option>
                                            <option selected={Wilayadedélivrence === "TIARET"} value="TIARET">(14) TIARET</option>
                                            <option selected={Wilayadedélivrence === "TIZI OUZOU"} value="TIZI OUZOU">(15) TIZI-OUZOU</option>
                                            <option selected={Wilayadedélivrence === "ALGER"} value="ALGER">(16) ALGER</option>
                                            <option selected={Wilayadedélivrence === "DJELFA"} value="DJELFA">(17) DJELFA</option>
                                            <option selected={Wilayadedélivrence === "JIJEL"} value="JIJEL">(18) JIJEL</option>
                                            <option selected={Wilayadedélivrence === "SETIF"} value="SETIF">(19) SETIF</option>
                                            <option selected={Wilayadedélivrence === "SAIDA"} value="SAIDA">(20) SAIDA</option>
                                            <option selected={Wilayadedélivrence === "SKIKDA"} value="SKIKDA">(21) SKIKDA</option>
                                            <option selected={Wilayadedélivrence === "SIDI BEL ABBES"} value="SIDI BEL ABBES">(22) SIDI-BEL-ABBES</option>
                                            <option selected={Wilayadedélivrence === "ANNABA"} value="ANNABA">(23) ANNABA</option>
                                            <option selected={Wilayadedélivrence === "GUELMA"} value="GUELMA">(24) GUELMA</option>
                                            <option selected={Wilayadedélivrence === "CONSTANTINE"} value="CONSTANTINE">(25) CONSTANTINE</option>
                                            <option selected={Wilayadedélivrence === "MEDEA"} value="MEDEA">(26) MEDEA</option>
                                            <option selected={Wilayadedélivrence === "MOSTAGANEM"} value="MOSTAGANEM">(27) MOSTAGANEM</option>
                                            <option selected={Wilayadedélivrence === "M SILA"} value="M SILA">(28) M-SILA</option>
                                            <option selected={Wilayadedélivrence === "MASCARA"} value="MASCARA">(29) MASCARA</option>
                                            <option selected={Wilayadedélivrence === "OUARGLA"} value="OUARGLA">(30) OUARGLA</option>
                                            <option selected={Wilayadedélivrence === "ORAN"} value="ORAN">(31) ORAN</option>
                                            <option selected={Wilayadedélivrence === "EL BAYADH"} value="EL BAYADH">(32) EL-BAYADH</option>
                                            <option selected={Wilayadedélivrence === "ILLIZI"} value="ILLIZI">(33) ILLIZI</option>
                                            <option selected={Wilayadedélivrence === "BORDJ BOU ARRERIDJ"} value="BORDJ BOU ARRERIDJ">(34) BORDJ-BOU-ARRERIDJ</option>
                                            <option selected={Wilayadedélivrence === "BOUMERDES"} value="BOUMERDES">(35) BOUMERDES</option>
                                            <option selected={Wilayadedélivrence === "EL TARF"} value="EL TARF">(36) EL-TARF</option>
                                            <option selected={Wilayadedélivrence === "TINDOUF"} value="TINDOUF">(37) TINDOUF</option>
                                            <option selected={Wilayadedélivrence === "TISSEMSILT"} value="TISSEMSILT">(38) TISSEMSILT</option>
                                            <option selected={Wilayadedélivrence === "EL OUED"} value="EL OUED">(39) EL-OUED</option>
                                            <option selected={Wilayadedélivrence === "KHENCHELA"} value="KHENCHELA">(40) KHENCHELA</option>
                                            <option selected={Wilayadedélivrence === "SOUK AHRAS"} value="SOUK AHRAS">(41) SOUK-AHRAS</option>
                                            <option selected={Wilayadedélivrence === "TIPAZA"} value="TIPAZA">(42) TIPAZA</option>
                                            <option selected={Wilayadedélivrence === "MILA"} value="MILA">(43) MILA</option>
                                            <option selected={Wilayadedélivrence === "AIN DEFLA"} value="AIN DEFLA">(44) AIN-DEFLA</option>
                                            <option selected={Wilayadedélivrence === "NAAMA"} value="NAAMA">(45) NAAMA</option>
                                            <option selected={Wilayadedélivrence === "AIN TEMOUCHENT"} value="AIN TEMOUCHENT">(46) AIN-TEMOUCHENT</option>
                                            <option selected={Wilayadedélivrence === "GHARDAIA"} value="GHARDAIA">(47) GHARDAIA</option>
                                            <option selected={Wilayadedélivrence === "RELIZANE"} value="RELIZANE">(48) RELIZANE</option>
                                            {/* <option selected={Wilayadedélivrence === "Timimoun"} value="Timimoun">(49) Timimoun</option>
        <option selected={Wilayadedélivrence === "Bordj Badji Mokhtar"} value="Bordj Badji Mokhtar">(50) Bordj Badji Mokhtar</option>
        <option selected={Wilayadedélivrence === "Ouled Djellal"} value="Ouled Djellal">(51) Ouled Djellal</option>
        <option selected={Wilayadedélivrence === "Béni Abbès"} value="Béni Abbès">(52) Béni Abbès</option>
        <option selected={Wilayadedélivrence === "In Salah"} value="In Salah">(53) In Salah</option>
        <option selected={Wilayadedélivrence === "In Guezzam"} value="In Guezzam">(54) In Guezzam</option>
        <option selected={Wilayadedélivrence === "Touggourt"} value="Touggourt">(55) Touggourt</option>
        <option selected={Wilayadedélivrence === "Djanet"} value="Djanet">(56) Djanet</option>
        <option selected={Wilayadedélivrence === "El M'Ghair"} value="El M'Ghair">(57) El M'Ghair</option>
        <option selected={Wilayadedélivrence === "El Meniaa"} value="El Meniaa">(58) El Meniaa</option> */}
                                        </select>
                                        <div className='alert-form'>{Showerr && (Wilayadedélivrence == "" ? (adresse['msgerr14'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="inputPassword4" className="form-label">{(adresse['Commune_délivrence'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setCommunededélivrence(e.target.value)}>

                                            <option disabled selected={Communededélivrence == '' ? "selected" : ''}>{(adresse['Commune_délivrence'][Lang])}</option>

                                            {CommunededélivrenceList.length > 0 && CommunededélivrenceList.map((item, i) => (
                                                <option selected={Communededélivrence === item?.commune} value={item?.commune}>{item?.commune}</option>
                                            ))
                                            }
                                        </select>
                                        <div className='alert-form'>{Showerr && (Communededélivrence == "" ? (adresse['msgerr15'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="inputPassword4" className="form-label">{(adresse['Habitation'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setHabitation(e.target.value)}>
                                            <option value={0} disabled selected="selected">{(adresse['Habitation'][Lang])}</option>

                                            {adresse['Habitation_list']?.length > 0 && adresse['Habitation_list']?.map((item, i) => (
                                                <option selected={Habitation == item['fr']} value={item['fr']}>{item[Lang]}</option>
                                            ))
                                            }
                                            {/* <option selected={Habitation == 1} value={1}>Avec les parents</option>
        <option selected={Habitation == 2} value={2}>Locataire</option>
        <option selected={Habitation == 3} value={3}>Propriétaire</option>
        <option selected={Habitation == 4} value={4}>Logt de Fonction</option> */}
                                        </select>
                                        <div className='alert-form'>{Showerr && (Habitation == "" ? (adresse['msgerr16'][Lang]) : '')}</div>

                                    </div>






                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">ما هو النشاط الذي تمارسه ؟</label>
                                        {/* <input maxLength={300} type="text" placeholder="ما هو النشاط الذي تمارسه ؟" className="form-control" id="inputEmail4" onChange={(e) => setactivité(e.target.value)} value={activité} /> */}
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setactivité(e.target.value)}>
                                            <option disabled selected="selected">نوع النشاط</option>

                                            {/* {projects?.length > 0 && projects?.map((item, i) => (
                                                <option selected={activité == item?.name} value={item?.name}>{item?.name}</option>
                                            ))
                                            } */}

                                            {/* {ProjectsList?.length > 0 && ProjectsList?.map((item, i) => (
                                                <option selected={activité == `${item?.title} - (${item?.cat_name})`} value={`${item?.title} - (${item?.cat_name})`}>{item?.title} - ({item?.cat_name})</option>
                                            ))
                                            } */}

                                            {ProjectsList?.length > 0 && ProjectsList?.map((item, i) => (
                                                <option selected={activité == item?.id} value={item?.id}>{item?.title} - ({item?.cat_name}) - ({item?.valid == 1 ? 'Online' : "Offline"})</option>
                                            ))
                                            }
                                        </select>

                                        {
                                            GetProjectUrl(activité) ?

                                                <a className='url-project-plus mt-2' href={`https://www.iamal.com.dz/project/${GetProjectUrl(activité)}`} target='blank'>
                                                    <svg className='ms-3' xmlns="http://www.w3.org/2000/svg" width="25.564" height="15.545" viewBox="0 0 28.564 15.545">
                                                        <g id="eye-svgrepo-com" transform="translate(0 -100.736)">
                                                            <g id="Groupe_430" data-name="Groupe 430" transform="translate(0 100.736)">
                                                                <path id="Tracé_9271" data-name="Tracé 9271" d="M14.282,116.281a17.531,17.531,0,0,1-10-3.633A25.306,25.306,0,0,1,.2,109.037a.808.808,0,0,1,0-1.058,25.31,25.31,0,0,1,4.088-3.611,17.532,17.532,0,0,1,10-3.633,17.531,17.531,0,0,1,10,3.633,25.31,25.31,0,0,1,4.088,3.611.808.808,0,0,1,0,1.058,25.31,25.31,0,0,1-4.088,3.611A17.531,17.531,0,0,1,14.282,116.281ZM1.915,108.509a25.493,25.493,0,0,0,3.34,2.848,16.236,16.236,0,0,0,9.026,3.309,16.235,16.235,0,0,0,9.026-3.309,25.5,25.5,0,0,0,3.34-2.848,25.49,25.49,0,0,0-3.34-2.848,16.235,16.235,0,0,0-9.026-3.309,16.235,16.235,0,0,0-9.026,3.309A25.486,25.486,0,0,0,1.915,108.509Z" transform="translate(0 -100.736)" fill="#fff" />
                                                            </g>
                                                            <g id="Groupe_431" data-name="Groupe 431" transform="translate(9.274 103.501)">
                                                                <path id="Tracé_9272" data-name="Tracé 9272" d="M148.528,153.537a5.008,5.008,0,1,1,3.3-8.776.808.808,0,0,1-1.064,1.215,3.392,3.392,0,1,0,1.158,2.553.808.808,0,1,1,1.615,0A5.013,5.013,0,0,1,148.528,153.537Z" transform="translate(-143.52 -143.521)" fill="#fff" />
                                                            </g>
                                                            <g id="Groupe_432" data-name="Groupe 432" transform="translate(12.666 106.893)">
                                                                <path id="Tracé_9273" data-name="Tracé 9273" d="M197.635,199.252a1.615,1.615,0,1,1,1.615-1.615A1.617,1.617,0,0,1,197.635,199.252Z" transform="translate(-196.02 -196.021)" fill="#fff" />
                                                            </g>
                                                        </g>
                                                    </svg>
                                                    <div>
                                                        التفاصيل والبطاقة التقنية للمشروع
                                                    </div>
                                                </a> : ''}

                                        <div className='alert-form'>{Showerr && (!activité || !onlyNumbers(activité) ? "يرجى تحديد النشاط الذي تمارسه" : '')}</div>
                                    </div>

                                    <div className="col-md-6 mb-2 mt-5 m-auto">
                                        <label className="form-label justify-content-center">ما هي مدة سداد قرض المشروع ؟</label>
                                        <div className='remboursement-box' dir={Lang === 'ar' ? 'rtl' : ''}>
                                            <div onClick={() => setTime('12')} className={`remb-box ${Time == '12' ? `active gradiant-alsalam` : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="265.21" height="246.261" viewBox="0 0 265.21 246.261">
                                                <path id="téléchargement" d="M484.93,276.55H451.778V262.343a4.734,4.734,0,0,0-9.469,0V276.55H404.422V262.343a4.734,4.734,0,1,0-9.469,0V276.55H357.066V262.343a4.734,4.734,0,0,0-9.469,0V276.55H309.711V262.343a4.734,4.734,0,0,0-9.469,0V276.55H267.09a23.448,23.448,0,0,0-23.68,23.68V480.19a23.448,23.448,0,0,0,23.68,23.68H484.94a23.448,23.448,0,0,0,23.68-23.68l-.008-179.96a23.45,23.45,0,0,0-23.68-23.676Zm-217.85,9.469h33.152v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,0,0,9.469,0V286.019H442.3v14.207a4.734,4.734,0,0,0,9.469,0V286.019H484.92a13.953,13.953,0,0,1,14.207,14.207v33.152H252.877V300.226a13.953,13.953,0,0,1,14.207-14.207ZM484.93,494.4H267.08a13.953,13.953,0,0,1-14.207-14.207V342.852h246.26v137.34A13.956,13.956,0,0,1,484.926,494.4Z" transform="translate(-243.41 -257.609)" />
                                            </svg>
                                                12 {(dartaksitsim['duréeMois'][Lang])}</div>
                                            <div onClick={() => setTime('24')} className={`remb-box ${Time == '24' ? `active gradiant-alsalam` : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="265.21" height="246.261" viewBox="0 0 265.21 246.261">
                                                <path id="téléchargement" d="M484.93,276.55H451.778V262.343a4.734,4.734,0,0,0-9.469,0V276.55H404.422V262.343a4.734,4.734,0,1,0-9.469,0V276.55H357.066V262.343a4.734,4.734,0,0,0-9.469,0V276.55H309.711V262.343a4.734,4.734,0,0,0-9.469,0V276.55H267.09a23.448,23.448,0,0,0-23.68,23.68V480.19a23.448,23.448,0,0,0,23.68,23.68H484.94a23.448,23.448,0,0,0,23.68-23.68l-.008-179.96a23.45,23.45,0,0,0-23.68-23.676Zm-217.85,9.469h33.152v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,0,0,9.469,0V286.019H442.3v14.207a4.734,4.734,0,0,0,9.469,0V286.019H484.92a13.953,13.953,0,0,1,14.207,14.207v33.152H252.877V300.226a13.953,13.953,0,0,1,14.207-14.207ZM484.93,494.4H267.08a13.953,13.953,0,0,1-14.207-14.207V342.852h246.26v137.34A13.956,13.956,0,0,1,484.926,494.4Z" transform="translate(-243.41 -257.609)" />
                                            </svg>24 {(dartaksitsim['duréeMois'][Lang])}</div>
                                            <div onClick={() => setTime('36')} className={`remb-box ${Time == '36' ? `active gradiant-alsalam` : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="265.21" height="246.261" viewBox="0 0 265.21 246.261">
                                                <path id="téléchargement" d="M484.93,276.55H451.778V262.343a4.734,4.734,0,0,0-9.469,0V276.55H404.422V262.343a4.734,4.734,0,1,0-9.469,0V276.55H357.066V262.343a4.734,4.734,0,0,0-9.469,0V276.55H309.711V262.343a4.734,4.734,0,0,0-9.469,0V276.55H267.09a23.448,23.448,0,0,0-23.68,23.68V480.19a23.448,23.448,0,0,0,23.68,23.68H484.94a23.448,23.448,0,0,0,23.68-23.68l-.008-179.96a23.45,23.45,0,0,0-23.68-23.676Zm-217.85,9.469h33.152v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,0,0,9.469,0V286.019H442.3v14.207a4.734,4.734,0,0,0,9.469,0V286.019H484.92a13.953,13.953,0,0,1,14.207,14.207v33.152H252.877V300.226a13.953,13.953,0,0,1,14.207-14.207ZM484.93,494.4H267.08a13.953,13.953,0,0,1-14.207-14.207V342.852h246.26v137.34A13.956,13.956,0,0,1,484.926,494.4Z" transform="translate(-243.41 -257.609)" />
                                            </svg>36 {(dartaksitsim['duréeMois'][Lang])}</div>


                                            <div onClick={() => setTime('48')} className={`remb-box ${Time == '48' ? `active gradiant-alsalam` : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="265.21" height="246.261" viewBox="0 0 265.21 246.261">
                                                <path id="téléchargement" d="M484.93,276.55H451.778V262.343a4.734,4.734,0,0,0-9.469,0V276.55H404.422V262.343a4.734,4.734,0,1,0-9.469,0V276.55H357.066V262.343a4.734,4.734,0,0,0-9.469,0V276.55H309.711V262.343a4.734,4.734,0,0,0-9.469,0V276.55H267.09a23.448,23.448,0,0,0-23.68,23.68V480.19a23.448,23.448,0,0,0,23.68,23.68H484.94a23.448,23.448,0,0,0,23.68-23.68l-.008-179.96a23.45,23.45,0,0,0-23.68-23.676Zm-217.85,9.469h33.152v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,0,0,9.469,0V286.019H442.3v14.207a4.734,4.734,0,0,0,9.469,0V286.019H484.92a13.953,13.953,0,0,1,14.207,14.207v33.152H252.877V300.226a13.953,13.953,0,0,1,14.207-14.207ZM484.93,494.4H267.08a13.953,13.953,0,0,1-14.207-14.207V342.852h246.26v137.34A13.956,13.956,0,0,1,484.926,494.4Z" transform="translate(-243.41 -257.609)" />
                                            </svg>48 {(dartaksitsim['duréeMois'][Lang])}</div>
                                            <div onClick={() => setTime('60')} className={`remb-box ${Time == '60' ? `active gradiant-alsalam` : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="265.21" height="246.261" viewBox="0 0 265.21 246.261">
                                                <path id="téléchargement" d="M484.93,276.55H451.778V262.343a4.734,4.734,0,0,0-9.469,0V276.55H404.422V262.343a4.734,4.734,0,1,0-9.469,0V276.55H357.066V262.343a4.734,4.734,0,0,0-9.469,0V276.55H309.711V262.343a4.734,4.734,0,0,0-9.469,0V276.55H267.09a23.448,23.448,0,0,0-23.68,23.68V480.19a23.448,23.448,0,0,0,23.68,23.68H484.94a23.448,23.448,0,0,0,23.68-23.68l-.008-179.96a23.45,23.45,0,0,0-23.68-23.676Zm-217.85,9.469h33.152v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,1,0,9.469,0V286.019h37.887v14.207a4.734,4.734,0,0,0,9.469,0V286.019H442.3v14.207a4.734,4.734,0,0,0,9.469,0V286.019H484.92a13.953,13.953,0,0,1,14.207,14.207v33.152H252.877V300.226a13.953,13.953,0,0,1,14.207-14.207ZM484.93,494.4H267.08a13.953,13.953,0,0,1-14.207-14.207V342.852h246.26v137.34A13.956,13.956,0,0,1,484.926,494.4Z" transform="translate(-243.41 -257.609)" />
                                            </svg>60 {(dartaksitsim['duréeMois'][Lang])}</div>


                                        </div>
                                    </div>




                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="inputEmail4" className="form-label">{(situationprofessionnelle['secteuractiv'][Lang])}</label>
                                        <select class="form-select" aria-label="Default select example" onChange={(e) => setSecteurdactivité(e.target.value)}>
                                            <option value={0} disabled selected="selected">{(situationprofessionnelle['secteuractiv'][Lang])}</option>


                                            {situationprofessionnelle['secteuractiv_list']?.length > 0 && situationprofessionnelle['secteuractiv_list']?.map((item, i) => (
                                                <option selected={Secteurdactivité == item?.value} value={item?.value}>{item[Lang]}</option>
                                            ))
                                            }
                                        </select>
                                        <div className='alert-form'>{Showerr && (Secteurdactivité !== "p" && Secteurdactivité !== "r" && Secteurdactivité !== "i" && Secteurdactivité !== "v" && Secteurdactivité !== "f" && Secteurdactivité !== "c" ? (situationprofessionnelle['secteuractiv_err'][Lang]) : '')}</div>


                                    </div>


                                    <div className={'mt-2'}>

                                        {/* {Secteurdactivité == 'p' || Secteurdactivité == 'v' || Secteurdactivité == 'i' ?
                                            <div className="col-md-12 mb-3">
                                                <label htmlFor="inputEmail4" className="form-label">{(situationprofessionnelle['Profession'][Lang])}</label>
                                                <input type="text" placeholder={(situationprofessionnelle['Profession'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setProfession(e.target.value.replace(/[^a-zA-Z\s]+/g, ''))} value={Profession} />
                                                <span className='note-form'>{Global['latin'][Lang]}</span>
                                                <div className='alert-form'>{Showerr && (Profession.trim().length < 2 ? (situationprofessionnelle['msgerr1'][Lang]) : '')}</div>
                                            </div> 
                                            
                                            : ''} */}

                                        {Secteurdactivité == 'p' || Secteurdactivité == 'v' ?
                                            <>
                                                <div className="col-md-12 mb-4">
                                                    <label htmlFor="inputPassword4" className="form-label">{(situationprofessionnelle['tyoe_contrat'][Lang])}</label>
                                                    <select class="form-select" aria-label="Default select example" onChange={(e) => setTypedecontrat(e.target.value)}>
                                                        <option value="0" selected="selected">{(situationprofessionnelle['tyoe_contrat'][Lang])}</option>
                                                        <option selected={Typedecontrat === "CDI"} value="CDI">CDI</option>
                                                        <option selected={Typedecontrat === "CDD"} value="CDD">CDD </option>
                                                        <option selected={Typedecontrat === "INTERIM"} value="INTERIM">Intérim</option>
                                                        <option selected={Typedecontrat === "Autre"} value="Autre">Autre</option>
                                                    </select>
                                                    <div className='alert-form'>{Showerr && (Typedecontrat !== "CDD" && Typedecontrat !== "CDI" && Typedecontrat !== "INTERIM" && Typedecontrat !== "Autre" ? (situationprofessionnelle['msgerr12'][Lang]) : '')}</div>
                                                </div>
                                                <div className="col-md-12 mb-4">
                                                    <div className='mb-2'>{(situationprofessionnelle['période_essai'][Lang])}</div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions33" id="inlineRadio1999" checked={Périodedessai == 'oui'} onChange={(e) => setPériodedessai(e.target.value)} defaultValue={'oui'} />
                                                        <label className="form-check-label" htmlFor="inlineRadio1999">{(situationprofessionnelle['r3'][Lang])}</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions3399" id="inlineRadio2999" checked={Périodedessai == 'non'} onChange={(e) => setPériodedessai(e.target.value)} defaultValue={'non'} />
                                                        <label className="form-check-label" htmlFor="inlineRadio2999">{(situationprofessionnelle['r4'][Lang])}</label>
                                                    </div>
                                                </div>
                                                <label htmlFor="inputPassword4" className="form-label">{(situationprofessionnelle['Ancienneté'][Lang])}</label>
                                                <div className="col-md-12 d-flex">
                                                    <input type="date" onChange={(e) => setAncienneté(e.target.value)} defaultValue={Ancienneté} className="form-control" id="inputEmail4" />
                                                </div>
                                                <div className='alert-form mb-4'>{Showerr && (!dateIsValid(new Date(Ancienneté)) ? "يرجى تحديد منذ متى وأنت تعمل" : '')}</div>

                                                <div className="col-md-12 mb-4">
                                                    <label htmlFor="inputEmail4" className="form-label">{(situationprofessionnelle['nom_emp'][Lang])}</label>
                                                    <input type="text" placeholder={(situationprofessionnelle['nom_emp'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setNomdelemployeur(e.target.value)} value={Nomdelemployeur} />
                                                    <span className='note-form'>{Global['latin'][Lang]}</span>

                                                    <div className='alert-form'>{Showerr && (Nomdelemployeur?.toString().trim() == '' ? (situationprofessionnelle['msgerr15'][Lang]) : '')}</div>
                                                    {/* <div className='alert-form'>{Showerr && (!onlyLetters(Nomdelemployeur) ? (situationprofessionnelle['msgerr15_'][Lang]) : '')}</div> */}
                                                </div>

                                                <div className="col-md-12 mb-3">
                                                    <label htmlFor="inputPassword4" className="form-label">{(situationprofessionnelle['wilaya_emp'][Lang])}</label>
                                                    <select class="form-select" aria-label="Default select example" onChange={(e) => setWilayadelemployeur(e.target.value)}>
                                                        <option disabled selected="selected">{(adresse['Wilaya'][Lang])}</option>
                                                        <option selected={Wilayadelemployeur == "ADRAR"} value="ADRAR">(01) ADRAR</option>
                                                        <option selected={Wilayadelemployeur == "CHLEF"} value="CHLEF">(02) CHLEF</option>
                                                        <option selected={Wilayadelemployeur == "LAGHOUAT"} value="LAGHOUAT">(03) LAGHOUAT</option>
                                                        <option selected={Wilayadelemployeur == "OUM EL BOUAGHI"} value="OUM EL BOUAGHI">(04) OUM-EL-BOUAGHI</option>
                                                        <option selected={Wilayadelemployeur == "BATNA"} value="BATNA">(05) BATNA</option>
                                                        <option selected={Wilayadelemployeur == "BEJAIA"} value="BEJAIA">(06) BEJAIA</option>
                                                        <option selected={Wilayadelemployeur == "BISKRA"} value="BISKRA">(07) BISKRA</option>
                                                        <option selected={Wilayadelemployeur == "BECHAR"} value="BECHAR">(08) BECHAR</option>
                                                        <option selected={Wilayadelemployeur == "BLIDA"} value="BLIDA">(09) BLIDA</option>
                                                        <option selected={Wilayadelemployeur == "BOUIRA"} value="BOUIRA">(10) BOUIRA</option>
                                                        <option selected={Wilayadelemployeur == "TAMANRASSET"} value="TAMANRASSET">(11) TAMANRASSET</option>
                                                        <option selected={Wilayadelemployeur == "TEBESSA"} value="TEBESSA">(12) TEBESSA</option>
                                                        <option selected={Wilayadelemployeur == "TLEMCEN"} value="TLEMCEN">(13) TLEMCEN</option>
                                                        <option selected={Wilayadelemployeur == "TIARET"} value="TIARET">(14) TIARET</option>
                                                        <option selected={Wilayadelemployeur == "TIZI OUZOU"} value="TIZI OUZOU">(15) TIZI-OUZOU</option>
                                                        <option selected={Wilayadelemployeur == "ALGER"} value="ALGER">(16) ALGER</option>
                                                        <option selected={Wilayadelemployeur == "DJELFA"} value="DJELFA">(17) DJELFA</option>
                                                        <option selected={Wilayadelemployeur == "JIJEL"} value="JIJEL">(18) JIJEL</option>
                                                        <option selected={Wilayadelemployeur == "SETIF"} value="SETIF">(19) SETIF</option>
                                                        <option selected={Wilayadelemployeur == "SAIDA"} value="SAIDA">(20) SAIDA</option>
                                                        <option selected={Wilayadelemployeur == "SKIKDA"} value="SKIKDA">(21) SKIKDA</option>
                                                        <option selected={Wilayadelemployeur == "SIDI BEL ABBES"} value="SIDI BEL ABBES">(22) SIDI-BEL-ABBES</option>
                                                        <option selected={Wilayadelemployeur == "ANNABA"} value="ANNABA">(23) ANNABA</option>
                                                        <option selected={Wilayadelemployeur == "GUELMA"} value="GUELMA">(24) GUELMA</option>
                                                        <option selected={Wilayadelemployeur == "CONSTANTINE"} value="CONSTANTINE">(25) CONSTANTINE</option>
                                                        <option selected={Wilayadelemployeur == "MEDEA"} value="MEDEA">(26) MEDEA</option>
                                                        <option selected={Wilayadelemployeur == "MOSTAGANEM"} value="MOSTAGANEM">(27) MOSTAGANEM</option>
                                                        <option selected={Wilayadelemployeur == "M SILA"} value="M SILA">(28) M-SILA</option>
                                                        <option selected={Wilayadelemployeur == "MASCARA"} value="MASCARA">(29) MASCARA</option>
                                                        <option selected={Wilayadelemployeur == "OUARGLA"} value="OUARGLA">(30) OUARGLA</option>
                                                        <option selected={Wilayadelemployeur == "ORAN"} value="ORAN">(31) ORAN</option>
                                                        <option selected={Wilayadelemployeur == "EL BAYADH"} value="EL BAYADH">(32) EL-BAYADH</option>
                                                        <option selected={Wilayadelemployeur == "ILLIZI"} value="ILLIZI">(33) ILLIZI</option>
                                                        <option selected={Wilayadelemployeur == "BORDJ BOU ARRERIDJ"} value="BORDJ BOU ARRERIDJ">(34) BORDJ-BOU-ARRERIDJ</option>
                                                        <option selected={Wilayadelemployeur == "BOUMERDES"} value="BOUMERDES">(35) BOUMERDES</option>
                                                        <option selected={Wilayadelemployeur == "EL TARF"} value="EL TARF">(36) EL-TARF</option>
                                                        <option selected={Wilayadelemployeur == "TINDOUF"} value="TINDOUF">(37) TINDOUF</option>
                                                        <option selected={Wilayadelemployeur == "TISSEMSILT"} value="TISSEMSILT">(38) TISSEMSILT</option>
                                                        <option selected={Wilayadelemployeur == "EL OUED"} value="EL OUED">(39) EL-OUED</option>
                                                        <option selected={Wilayadelemployeur == "KHENCHELA"} value="KHENCHELA">(40) KHENCHELA</option>
                                                        <option selected={Wilayadelemployeur == "SOUK AHRAS"} value="SOUK AHRAS">(41) SOUK-AHRAS</option>
                                                        <option selected={Wilayadelemployeur == "TIPAZA"} value="TIPAZA">(42) TIPAZA</option>
                                                        <option selected={Wilayadelemployeur == "MILA"} value="MILA">(43) MILA</option>
                                                        <option selected={Wilayadelemployeur == "AIN DEFLA"} value="AIN DEFLA">(44) AIN-DEFLA</option>
                                                        <option selected={Wilayadelemployeur == "NAAMA"} value="NAAMA">(45) NAAMA</option>
                                                        <option selected={Wilayadelemployeur == "AIN TEMOUCHENT"} value="AIN TEMOUCHENT">(46) AIN-TEMOUCHENT</option>
                                                        <option selected={Wilayadelemployeur == "GHARDAIA"} value="GHARDAIA">(47) GHARDAIA</option>
                                                        <option selected={Wilayadelemployeur == "RELIZANE"} value="RELIZANE">(48) RELIZANE</option>
                                                        {/* <option selected={ Wilayadelemployeur == "Timimoun"} value="Timimoun">(49) Timimoun</option>
                  <option selected={ Wilayadelemployeur == "Bordj Badji Mokhtar"} value="Bordj Badji Mokhtar">(50) Bordj Badji Mokhtar</option>
                  <option selected={ Wilayadelemployeur == "Ouled Djellal"} value="Ouled Djellal">(51) Ouled Djellal</option>
                  <option selected={ Wilayadelemployeur == "Béni Abbès"} value="Béni Abbès">(52) Béni Abbès</option>
                  <option selected={ Wilayadelemployeur == "In Salah"} value="In Salah">(53) In Salah</option>
                  <option selected={ Wilayadelemployeur == "In Guezzam"} value="In Guezzam">(54) In Guezzam</option>
                  <option selected={ Wilayadelemployeur == "Touggourt"} value="Touggourt">(55) Touggourt</option>
                  <option selected={ Wilayadelemployeur == "Djanet"} value="Djanet">(56) Djanet</option>
                  <option selected={ Wilayadelemployeur == "El M'Ghair"} value="El M'Ghair">(57) El M'Ghair</option>
                  <option selected={ Wilayadelemployeur == "El Meniaa"} value="El Meniaa">(58) El Meniaa</option> */}
                                                    </select>
                                                    <div className='alert-form'>{Showerr && (Wilayadelemployeur == "" ? (situationprofessionnelle['msgerr16'][Lang]) : '')}</div>
                                                </div>

                                                <div className="col-md-12 mb-3">
                                                    <label htmlFor="inputEmail4" className="form-label">{(situationprofessionnelle['adresse_emp'][Lang])}</label>
                                                    <input type="text" placeholder={(situationprofessionnelle['adresse_emp'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setAdressedelemployeur(e.target.value)} value={Adressedelemployeur} />
                                                    <span className='note-form'>{Global['latin'][Lang]}</span>

                                                    <div className='alert-form'>{Showerr && (Adressedelemployeur?.toString().trim() == "" || Adressedelemployeur?.toString().trim().length > 300 ? (situationprofessionnelle['msgerr17'][Lang]) : '')}</div>
                                                </div>




                                            </> : ''}

                                        {/* {Secteurdactivité == 'p' || Secteurdactivité == 'v' || Secteurdactivité == 'i' ?
            <div className="col-md-12 mb-3">
              <label htmlFor="inputEmail4" className="form-label">{(situationprofessionnelle['tel_prof'][Lang])}</label>
              <input type="text" placeholder="Téléphone professionnel" className="form-control" id="inputEmail4" onChange={(e) => setTel(e.target.value.replace(/[^0-9]+/g, ''))} value={Tel} />
              <div className='alert-form'>{Showerr && (!onlyNumbers(Tel) ? ' Veuillez saisir votre nom sans chiffres ni caractères spéciaux.' : '')}</div>
              <div className='alert-form'>{Showerr && (Tel.length > 13 || Tel.length < 9 ? 'Votre numéro de téléphone ne doit pas être inférieur à 9 chiffres ni supérieur à 13 chiffres' : '')}</div>

            </div> : ''} */}
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">{(situationprofessionnelle['Profession'][Lang])} (إختياري)</label>
                                        <input type="text" placeholder={(situationprofessionnelle['Profession'][Lang])} className="form-control" id="inputEmail4" onChange={(e) => setProfession(e.target.value)} value={Profession} />
                                        <span className='note-form'>الكتابة بالأحرف الاتينية</span>

                                        <div className='alert-form'>{Showerr && (Profession?.toString().trim().length > 300 ? (situationprofessionnelle['msgerr1'][Lang]) : '')}</div>
                                    </div>







                                    <div className="col-md-12 mb-2 mt-5" dir='rtl'>
                                        <div className='mb-2'>هل انت حامل لشهادة؟</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions19" id="inlineRadio19" checked={Certificat == 'oui'} onChange={(e) => setCertificat(e.target.value)} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio19">{(situationprofessionnelle['r3'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions29" id="inlineRadio29" checked={Certificat == 'non'} onChange={(e) => setCertificat(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio29">{(situationprofessionnelle['r4'][Lang])}</label>
                                        </div>
                                        {Certificat === "oui" &&
                                            <>
                                                <div className="col-md-12 mb-1">
                                                    <label htmlFor="inputPassword4" className="form-label">نوع الشهادة</label>
                                                    <input type="text" placeholder='نوع الشهادة' maxLength={250} className="form-control" onChange={(e) => setTypeCertificat(e.target.value)} value={TypeCertificat} id="inputPassword4" />
                                                    <div className='alert-form'>{Showerr && (TypeCertificat == "" ? 'يرجى كتابة نوع الشهادة التي تحصلت عليها' : '')}</div>
                                                </div>
                                            </>}
                                    </div>



                                    <div className="col-md-12 mb-2" dir='rtl'>
                                        <div className='mb-2'>هل لديك خبرة في هذا المجال؟</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions18" id="inlineRadio18" checked={Experience == 'oui'} onChange={(e) => setExperience(e.target.value)} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio18">{(situationprofessionnelle['r3'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions28" id="inlineRadio28" checked={Experience == 'non'} onChange={(e) => setExperience(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio28">{(situationprofessionnelle['r4'][Lang])}</label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">{(situationprofessionnelle['saliare'][Lang])} (إختياري)</label>
                                        <input maxlength="7" type="tel" placeholder={(situationprofessionnelle['saliare'][Lang])} className="form-control" onChange={(e) => setSalaire(e.target.value.replace(/[^0-9]+/g, ''))} value={Salaire} id="inputEmail4" />
                                        <span className='note-form'>الكتابة بالأرقام</span>
                                        {/* <div>{situationprofessionnelle['saliare_info'][Lang]} </div> */}
                                        <div className='alert-form'>{Showerr && (Salaire !== "" && !onlyNumbers(Salaire) ? (situationprofessionnelle['saliare_err'][Lang]) : '')}</div>
                                    </div>
                                    <div className="col-md-12 mb-2" dir='rtl'>
                                        <div className='mb-2'>{(situationprofessionnelle['cmp'][Lang])}</div>
                                        {/* <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" defaultChecked defaultValue="option1" />
                <label className="form-check-label" htmlFor="inlineRadio1">CCP</label>
            </div>
            <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" defaultValue="option2" />
                <label className="form-check-label" htmlFor="inlineRadio2">Banque</label>
            </div> */}

                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions331" id="inlineRadio331" checked={Compte == 'Non'} onChange={(e) => setCompte(e.target.value)} defaultChecked={true} defaultValue="Non" />
                                            <label className="form-check-label" htmlFor="inlineRadio331">لا يوجد</label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions131" id="inlineRadio131" checked={Compte == 'CCP'} onChange={(e) => setCompte(e.target.value)} defaultValue="CCP" />
                                            <label className="form-check-label" htmlFor="inlineRadio131">{(situationprofessionnelle['r1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions231" id="inlineRadio231" checked={Compte == 'Banque'} onChange={(e) => setCompte(e.target.value)} defaultValue="Banque" />
                                            <label className="form-check-label" htmlFor="inlineRadio231">{(situationprofessionnelle['r2'][Lang])}</label>
                                        </div>

                                    </div>

                                    {Compte == 'CCP' ?
                                        <>
                                            {/* <label htmlFor="inputPassword4" className="form-label">Compte CCP</label> */}
                                            <div className="col-md-12 d-flex mt-0" dir='rtl'>
                                                <div className='row'>
                                                    <div className="col-md-6 col-12" dir='rtl'>
                                                        <input maxlength="18" type="tel" placeholder="Compte" onChange={(e) => setCompteCCP(e.target.value.replace(/[^0-9]+/g, ''))} value={CompteCCP} className="form-control ms-2" id="inputPassword4" />
                                                        <span className='note-form'>الكتابة بالأرقام</span>
                                                        <div className='alert-form' dir={Lang === "ar" ? "rtl" : ""}>{Showerr && (CompteCCP == "" ? (situationprofessionnelle['msgerr18'][Lang]) : '')}</div>
                                                    </div>
                                                    <div className='col-md-5 col-12 me-0 me-md-3' dir='rtl'>
                                                        <input maxlength="2" type="tel" placeholder="Clé" onChange={(e) => setCCPClé(e.target.value.replace(/[^0-9]+/g, ''))} value={CCPClé} className="form-control ms-2" id="inputPassword4" />
                                                        <span className='note-form'>الكتابة بالأرقام</span>
                                                        <div className='alert-form' dir={Lang === "ar" ? "rtl" : ""}>{Showerr && (CCPClé == "" ? (situationprofessionnelle['msgerr18_'][Lang]) : '')}</div>
                                                        <div className='alert-form' dir={Lang === "ar" ? "rtl" : ""}>{Showerr && (CCPClé?.toString().length !== 2 ? (situationprofessionnelle['msgerr18__'][Lang]) : '')}</div>
                                                    </div></div>
                                            </div>
                                        </> : ''}

                                    {Compte == 'Banque' ?
                                        <div className="col-md-12 mb-3 mt-1">
                                            {/* <label htmlFor="inputPassword4" className="form-label">Banque</label> */}
                                            <select class="form-select" aria-label="Default select example" onChange={(e) => setBanque(e.target.value)}>
                                                <option disabled selected="selected">Choisissez</option>
                                                <option selected={Banque == "AL-SALAM"} value="AL-SALAM">Al salam Bank Algeria</option>
                                                <option selected={Banque == "BEA"} value="BEA">BEA (Banque Extérieure d’Algérie)</option>
                                                <option selected={Banque == "BNA"} value="BNA">BNA (Banque Nationale d’Algérie) </option>
                                                <option selected={Banque == "CPA"} value="CPA">CPA (Crédit Populaire d’Algérie)</option>
                                                <option selected={Banque == "BDL"} value="BDL">BDL (Banque de Développement Local)</option>
                                                <option selected={Banque == "CNEP"} value="CNEP">CNEP-Banque (Caisse Nationale d’Epargne et de Prévoyance- Banque-)</option>
                                                <option selected={Banque == "BADR"} value="BADR"> BADR (Banque de l’Agriculture et du Développement Rural)</option>
                                                <option selected={Banque == "AL-BARAKA"} value="AL-BARAKA">AL BARAKA (Banque AL Baraka d’Algérie)</option>
                                                <option selected={Banque == "CITIBANK"} value="CITIBANK">CITIBANK</option>
                                                <option selected={Banque == "ABC"} value="ABC">ABC (Arab Banking Corporation Algeria)</option>
                                                <option selected={Banque == "NATIXIS"} value="NATIXIS">Natixis ALGERIE</option>
                                                <option selected={Banque == "SGA"} value="SGA"> Société Générale Algérie</option>
                                                <option selected={Banque == "BNP"} value="BNP"> BNP Paribas Al-djazair</option>
                                                <option selected={Banque == "TRUST-BANK"} value="TRUST-BANK"> TRUST BANK Algeria</option>
                                                <option selected={Banque == "Housing-Bank"} value="Housing-Bank">Housing Bank (The Housing Bank For Trade and Finance – Algeria)</option>
                                                <option selected={Banque == "AGB"} value="AGB"> AGB (Gulf Bank Algérie)</option>
                                                <option selected={Banque == "FRANSABANK"} value="FRANSABANK">Crédit Agricole Corporate Et Investissement Bank Algérie  (Ex CALYON)</option>
                                                <option selected={Banque == "FRANSABANK"} value="FRANSABANK">Fransabank Al-Djazair</option>
                                                <option selected={Banque == "HSBC"} value="HSBC"> HSBC Algeria</option>
                                            </select>
                                            <div className='alert-form'>{Showerr && (Banque == "" ? (situationprofessionnelle['msgerr19'][Lang]) : '')}</div>
                                        </div> : ''
                                    }





                                    <div className="col-md-12 mb-2" dir='rtl'>
                                        <div className='mb-2'>{(situationprofessionnelle['Comptesalam'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions190" id="inlineRadio190" checked={SalamBank == 'oui'} onChange={(e) => setSalamBank(e.target.value)} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio190">{(situationprofessionnelle['r3'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions290" id="inlineRadio290" checked={SalamBank == 'non'} onChange={(e) => setSalamBank(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio290">{(situationprofessionnelle['r4'][Lang])}</label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-2" dir='rtl'>
                                        <div className='mb-2'>{(situationprofessionnelle['revenus'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions180" id="inlineRadio180" checked={sourcesderevenus == 'oui'} onChange={(e) => setsourcesderevenus(e.target.value)} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio180">{(situationprofessionnelle['r3'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions280" id="inlineRadio280" checked={sourcesderevenus == 'non'} onChange={(e) => setsourcesderevenus(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio280">{(situationprofessionnelle['r4'][Lang])}</label>
                                        </div>
                                    </div>




                                    <div className="col-md-12" dir='rtl'>
                                        <div className='mb-2'>
                                            أنت شخص ؟
                                        </div>

                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions1991" id="inlineRadio1991" checked={TypeOfPerson == 0} onChange={(e) => setTypeOfPerson(e.target.value)} defaultChecked={true} defaultValue="0" />
                                            <label className="form-check-label" htmlFor="inlineRadio1991">
                                                شخص طبيعي</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions2992" id="inlineRadio2992" checked={TypeOfPerson == 1} onChange={(e) => setTypeOfPerson(e.target.value)} defaultValue="1" />
                                            <label className="form-check-label" htmlFor="inlineRadio2992">
                                                شخص معنوي
                                            </label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions2993" id="inlineRadio2993" checked={TypeOfPerson == 2} onChange={(e) => setTypeOfPerson(e.target.value)} defaultValue="2" />
                                            <label className="form-check-label" htmlFor="inlineRadio2993">
                                                حرفي
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions2994" id="inlineRadio2994" checked={TypeOfPerson == 3} onChange={(e) => setTypeOfPerson(e.target.value)} defaultValue="3" />
                                            <label className="form-check-label" htmlFor="inlineRadio2994">
                                                تاجر متنقل
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions2995" id="inlineRadio2995" checked={TypeOfPerson == 4} onChange={(e) => setTypeOfPerson(e.target.value)} defaultValue="4" />
                                            <label className="form-check-label" htmlFor="inlineRadio2995">
                                                شركة ناشئة
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">تاريخ بداية النشاط</label>
                                        <input type="date" onChange={(e) => setDatedébutdactivité(e.target.value)} defaultValue={Datedébutdactivité} className="form-control" id="inputEmail4" />
                                        {/* <div className='alert-form'>{Showerr && (Datedébutdactivité !== "" && !dateIsValid(new Date(Datedébutdactivité)) ? 'يرجى تحديد تاريخ بداية النشاط' : '')}</div> */}
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">رقم التسجيل في السجل التجاري </label>

                                        {/* <div dir='ltr'>{"\u202d16/00 - 10054650 ب 545"+ ""}</div> */}

                                        <input type="tel" style={{direction : "ltr"}} dir='ltr' placeholder={'رقم التسجيل في السجل التجاري'} className="form-control text-end" id="inputEmail4" onChange={onInputChange} value={LEFT_TO_RIGHT_MARK + ImmatriculationauregistreCommerce} />
                                        {/* <span className='note-form'>{(adresse['msg3'][Lang])}</span> */}
                                        {/* <div className='alert-form'>{Showerr && (ImmatriculationauregistreCommerce !== "" && !onlyNumbers(ImmatriculationauregistreCommerce) ? "يرجى إدخال رقم التسجيل في السجل التجاري" : '')}</div> */}
                                        {/* <div className='alert-form'>{Showerr && (ImmatriculationauregistreCommerce.length !== 18 ? (adresse['msgerr11'][Lang]) : '')}</div> */}
                                    </div>


                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            تاريخ التسجيل في السجل التجاري
                                        </label>
                                        <input type="date" onChange={(e) => setDateImmatriculationauregistreCommerce(e.target.value)} defaultValue={DateImmatriculationauregistreCommerce} className="form-control" id="inputEmail4" />
                                        {/* <div className='alert-form'>{Showerr && (DateImmatriculationauregistreCommerce !== "" && !dateIsValid(new Date(DateImmatriculationauregistreCommerce)) ? "يرجى تحديد تاريخ التسجيل في السجل التجاري" : '')}</div> */}
                                    </div>


                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">
                                            مكان التسجيل في السجل التجاري
                                        </label>
                                        <input maxLength={255} type="text" placeholder={"مكان التسجيل في السجل التجاري"} onChange={(e) => setLieuImmatriculationauregistreCommerce(e.target.value.replace(/[^a-zA-Z0-9\-/\°\,\.\'\é\à\è\ù\ç\â\ê\î\ô\û\ë\ï\ü\æ\À\Â\Ä\Ç\È\É\Ê\Î\Ô\Œ\s]+/g, ''))} value={LieuImmatriculationauregistreCommerce} className="form-control" id="inputEmail4" />
                                        <span className='note-form'>الكتابة بالأحرف الاتينية</span>
                                        <div className='alert-form'>{Showerr && (LieuImmatriculationauregistreCommerce?.toString().trim().length > 300 ? "يرجى عدم تجاوز عدد الأحرف المقدرة بـ 300 حرف" : '')}</div>
                                    </div>


                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">
                                            عنوان مقر المؤسسة
                                        </label>
                                        <input maxLength={255} type="text" placeholder={"عنوان مقر المؤسسة"} onChange={(e) => setAdressedusiège(e.target.value.replace(/[^a-zA-Z0-9\-/\°\,\.\'\é\à\è\ù\ç\â\ê\î\ô\û\ë\ï\ü\æ\À\Â\Ä\Ç\È\É\Ê\Î\Ô\Œ\s]+/g, ''))} value={Adressedusiège} className="form-control" id="inputEmail4" />
                                        <span className='note-form'>الكتابة بالأحرف الاتينية</span>
                                        <div className='alert-form'>{Showerr && (Adressedusiège?.toString().trim().length > 300 ? "يرجى عدم تجاوز عدد الأحرف المقدرة بـ 300 حرف" : '')}</div>
                                    </div>


                                    <div className="col-md-12" dir='rtl'>
                                        <div className='mb-2'>
                                            وضعية المقر النشاط
                                        </div>

                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions19918" id="inlineRadio19918" checked={Situationdulocal == "0"} onChange={(e) => setSituationdulocal(e.target.value)} defaultChecked={true} defaultValue="0" />
                                            <label className="form-check-label" htmlFor="inlineRadio19918">
                                                إيجار
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions29928" id="inlineRadio29928" checked={Situationdulocal == "1"} onChange={(e) => setSituationdulocal(e.target.value)} defaultValue="1" />
                                            <label className="form-check-label" htmlFor="inlineRadio29928">
                                                ملكية
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions29929" id="inlineRadio29929" checked={Situationdulocal == "2"} onChange={(e) => setSituationdulocal(e.target.value)} defaultValue="2" />
                                            <label className="form-check-label" htmlFor="inlineRadio29929">
                                                لايوجد
                                            </label>
                                        </div>
                                    </div>







                                    <div className="col-md-12 mb-2">
                                        <div className='mb-2'>{(chargesetpatrimoine['Q1'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadio18" id="inlineRadio1899" checked={créditempruntimmobilier == 'oui'} onChange={(e) => setcréditempruntimmobilier(e.target.value)} defaultChecked={true} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio1899">{(chargesetpatrimoine['r1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadio18" id="inlineRadio2999" checked={créditempruntimmobilier == 'non'} onChange={(e) => setcréditempruntimmobilier(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio2999">{(chargesetpatrimoine['r2'][Lang])}</label>
                                        </div>
                                    </div>

                                    {
                                        créditempruntimmobilier === "oui" &&
                                        <>
                                            <div className="col-md-12 mb-1">
                                                <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q1Mensualité'][Lang])}</label>
                                                <input placeholder='DA/دج' maxLength={10} type="text" className="form-control" onChange={(e) => setMensualitéducréditimmobilier(e.target.value.replace(/[^0-9]+/g, ''))} value={Mensualitéducréditimmobilier} id="inputPassword4" />
                                                <div className='alert-form'>{Showerr && (Mensualitéducréditimmobilier == "" ? (chargesetpatrimoine['Q1Mensualitéerr'][Lang]) : '')}</div>
                                            </div>
                                            <div className="col-md-12 mb-1">
                                                <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q1Organisme'][Lang])}</label>
                                                <select class="form-select" aria-label="Default select example" onChange={(e) => setOrganismeprêteurimmobilier(e.target.value)}>
                                                    <option disabled selected="selected">Choisissez</option>
                                                    <option value="AL-SALAM  " selected={Organismeprêteurimmobilier === "AL-SALAM"}>Al salam Bank Algeria</option>
                                                    <option value="BEA" selected={Organismeprêteurimmobilier === "BEA"}>BEA (Banque Extérieure d’Algérie)</option>
                                                    <option value="BNA" selected={Organismeprêteurimmobilier === "BNA"}>BNA (Banque Nationale d’Algérie) </option>
                                                    <option value="CPA" selected={Organismeprêteurimmobilier === "CPA"}>CPA (Crédit Populaire d’Algérie)</option>
                                                    <option value="BDL" selected={Organismeprêteurimmobilier === "BDL"}>BDL (Banque de Développement Local)</option>
                                                    <option value="CNEP" selected={Organismeprêteurimmobilier === "CNEP"}>CNEP-Banque (Caisse Nationale d’Epargne et de Prévoyance- Banque-)</option>
                                                    <option value="BADR" selected={Organismeprêteurimmobilier === "BADR"}> BADR (Banque de l’Agriculture et du Développement Rural)</option>
                                                    <option value="AL-BARAKA" selected={Organismeprêteurimmobilier === "AL-BARAKA"}>AL BARAKA (Banque AL Baraka d’Algérie)</option>
                                                    <option value="CITIBANK" selected={Organismeprêteurimmobilier === "CITIBANK"}>CITIBANK</option>
                                                    <option value="ABC" selected={Organismeprêteurimmobilier === "ABC"}>ABC (Arab Banking Corporation Algeria)</option>
                                                    <option value="NATIXIS" selected={Organismeprêteurimmobilier === "NATIXIS"}>Natixis ALGERIE</option>
                                                    <option value="SGA" selected={Organismeprêteurimmobilier === "SGA"}> Société Générale Algérie</option>
                                                    <option value="BNP" selected={Organismeprêteurimmobilier === "BNP"}> BNP Paribas Al-djazair</option>
                                                    <option value="TRUST-BANK" selected={Organismeprêteurimmobilier === "TRUST-BANK"}> TRUST BANK Algeria</option>
                                                    <option value="Housing-Bank" selected={Organismeprêteurimmobilier === "Housing-Bank"}>Housing Bank (The Housing Bank For Trade and Finance – Algeria)</option>
                                                    <option value="AGB" selected={Organismeprêteurimmobilier === "AGB"}> AGB (Gulf Bank Algérie)</option>
                                                    <option value="FRANSABANK" selected={Organismeprêteurimmobilier === "FRANSABANK"}>Crédit Agricole Corporate Et Investissement Bank Algérie  (Ex CALYON)</option>
                                                    <option value="FRANSABANK" selected={Organismeprêteurimmobilier === "FRANSABANK"}>Fransabank Al-Djazair</option>
                                                    <option value="HSBC " selected={Organismeprêteurimmobilier === "HSBC "}> HSBC Algeria</option>
                                                </select>
                                                <div className='alert-form'>{Showerr && (Organismeprêteurimmobilier == "" ? (chargesetpatrimoine['Q1Organismeerr'][Lang]) : '')}</div>
                                            </div>
                                            <div className="col-md-12 mb-5">
                                                <label className="form-label">{(chargesetpatrimoine['Q1Date'][Lang])}</label>
                                                <input type="date" onChange={(e) => setDatedefinducréditimmobilier(e.target.value)} value={Datedefinducréditimmobilier} className="form-control" id="inputEmail4" />
                                                <div className='alert-form'>{Showerr && (Datedefinducréditimmobilier == "" ? (chargesetpatrimoine['Q1Dateerr'][Lang]) : '')}</div>
                                            </div>
                                        </>
                                    }




                                    <div className="col-md-12 mb-2">
                                        <div className='mb-2'>{(chargesetpatrimoine['Q2'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio33" checked={créditvoiture == 'oui'} onChange={(e) => setcréditvoiture(e.target.value)} defaultChecked={true} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio33">{(chargesetpatrimoine['r1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio43" checked={créditvoiture == 'non'} onChange={(e) => setcréditvoiture(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio43">{(chargesetpatrimoine['r2'][Lang])}</label>
                                        </div>
                                    </div>

                                    {
                                        créditvoiture === "oui" &&
                                        <>
                                            <div className="col-md-12 mb-1">
                                                <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q2Mensualité'][Lang])}</label>
                                                <input placeholder='DA/دج' maxLength={10} type="text" className="form-control" onChange={(e) => setMensualitéducréditvoiture(e.target.value.replace(/[^0-9]+/g, ''))} value={Mensualitéducréditvoiture} id="inputPassword4" />
                                                <div className='alert-form'>{Showerr && (Mensualitéducréditvoiture == "" ? (chargesetpatrimoine['Q2Mensualitéerr'][Lang]) : '')}</div>

                                            </div>
                                            <div className="col-md-12 mb-1">
                                                <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q2Organisme'][Lang])}</label>
                                                <select class="form-select" aria-label="Default select example" onChange={(e) => setOrganismeprêteurdecréditvoiture(e.target.value)}>
                                                    <option disabled selected="selected">Choisissez</option>
                                                    <option value="AL-SALAM  " selected={Organismeprêteurdecréditvoiture === "AL-SALAM"}>Al salam Bank Algeria</option>
                                                    <option value="BEA" selected={Organismeprêteurdecréditvoiture === "BEA"}>BEA (Banque Extérieure d’Algérie)</option>
                                                    <option value="BNA" selected={Organismeprêteurdecréditvoiture === "BNA"}>BNA (Banque Nationale d’Algérie) </option>
                                                    <option value="CPA" selected={Organismeprêteurdecréditvoiture === "CPA"}>CPA (Crédit Populaire d’Algérie)</option>
                                                    <option value="BDL" selected={Organismeprêteurdecréditvoiture === "BDL"}>BDL (Banque de Développement Local)</option>
                                                    <option value="CNEP" selected={Organismeprêteurdecréditvoiture === "CNEP"}>CNEP-Banque (Caisse Nationale d’Epargne et de Prévoyance- Banque-)</option>
                                                    <option value="BADR" selected={Organismeprêteurdecréditvoiture === "BADR"}> BADR (Banque de l’Agriculture et du Développement Rural)</option>
                                                    <option value="AL-BARAKA" selected={Organismeprêteurdecréditvoiture === "AL-BARAKA"}>AL BARAKA (Banque AL Baraka d’Algérie)</option>
                                                    <option value="CITIBANK" selected={Organismeprêteurdecréditvoiture === "CITIBANK"}>CITIBANK</option>
                                                    <option value="ABC" selected={Organismeprêteurdecréditvoiture === "ABC"}>ABC (Arab Banking Corporation Algeria)</option>
                                                    <option value="NATIXIS" selected={Organismeprêteurdecréditvoiture === "NATIXIS"}>Natixis ALGERIE</option>
                                                    <option value="SGA" selected={Organismeprêteurdecréditvoiture === "SGA"}> Société Générale Algérie</option>
                                                    <option value="BNP" selected={Organismeprêteurdecréditvoiture === "BNP"}> BNP Paribas Al-djazair</option>
                                                    <option value="TRUST-BANK" selected={Organismeprêteurdecréditvoiture === "TRUST-BANK"}> TRUST BANK Algeria</option>
                                                    <option value="Housing-Bank" selected={Organismeprêteurdecréditvoiture === "Housing-Bank"}>Housing Bank (The Housing Bank For Trade and Finance – Algeria)</option>
                                                    <option value="AGB" selected={Organismeprêteurdecréditvoiture === "AGB"}> AGB (Gulf Bank Algérie)</option>
                                                    <option value="FRANSABANK" selected={Organismeprêteurdecréditvoiture === "FRANSABANK"}>Crédit Agricole Corporate Et Investissement Bank Algérie  (Ex CALYON)</option>
                                                    <option value="FRANSABANK" selected={Organismeprêteurdecréditvoiture === "FRANSABANK"}>Fransabank Al-Djazair</option>
                                                    <option value="HSBC " selected={Organismeprêteurdecréditvoiture === "HSBC "}> HSBC Algeria</option>
                                                </select>
                                                <div className='alert-form'>{Showerr && (Organismeprêteurdecréditvoiture == "" ? (chargesetpatrimoine['Q2Organismeerr'][Lang]) : '')}</div>
                                            </div>
                                            <div className="col-md-12 mb-5">
                                                <label className="form-label">{(chargesetpatrimoine['Q2Date'][Lang])}</label>
                                                <input type="date" onChange={(e) => setDatedefinducréditvoiture(e.target.value)} value={Datedefinducréditvoiture} className="form-control" id="inputEmail4" />
                                                <div className='alert-form'>{Showerr && (Datedefinducréditvoiture == "" ? (chargesetpatrimoine['Q2Dateerr'][Lang]) : '')}</div>
                                            </div>
                                        </>
                                    }

                                    <div className="col-md-12 mb-2">
                                        <div className='mb-2'>{(chargesetpatrimoine['Q3'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions4" id="inlineRadio53" checked={Autrecrédit == 'oui'} onChange={(e) => setAutrecrédit(e.target.value)} defaultChecked={true} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio53">{(chargesetpatrimoine['r1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions4" id="inlineRadio64" checked={Autrecrédit == 'non'} onChange={(e) => setAutrecrédit(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio64">{(chargesetpatrimoine['r2'][Lang])}</label>
                                        </div>
                                    </div>


                                    {
                                        Autrecrédit === "oui" &&
                                        <>
                                            <div className="col-md-12 mb-1">
                                                <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q3Mensualité'][Lang])}</label>
                                                <input placeholder='DA/دج' maxLength={10} type="text" className="form-control" onChange={(e) => setMensualitéduautrecrédit(e.target.value.replace(/[^0-9]+/g, ''))} value={Mensualitéduautrecrédit} id="inputPassword4" />
                                                <div className='alert-form'>{Showerr && (Mensualitéduautrecrédit == "" ? (chargesetpatrimoine['Q3Mensualitéerr'][Lang]) : '')}</div>
                                            </div>
                                            <div className="col-md-12 mb-1">
                                                <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q3Organisme'][Lang])}</label>
                                                <select class="form-select" aria-label="Default select example" onChange={(e) => setOrganismeprêteurautrecrédit(e.target.value)}>
                                                    <option disabled selected="selected">Choisissez</option>
                                                    <option value="AL-SALAM  " selected={Organismeprêteurautrecrédit === "AL-SALAM"}>Al salam Bank Algeria</option>
                                                    <option value="BEA" selected={Organismeprêteurautrecrédit === "BEA"}>BEA (Banque Extérieure d’Algérie)</option>
                                                    <option value="BNA" selected={Organismeprêteurautrecrédit === "BNA"}>BNA (Banque Nationale d’Algérie) </option>
                                                    <option value="CPA" selected={Organismeprêteurautrecrédit === "CPA"}>CPA (Crédit Populaire d’Algérie)</option>
                                                    <option value="BDL" selected={Organismeprêteurautrecrédit === "BDL"}>BDL (Banque de Développement Local)</option>
                                                    <option value="CNEP" selected={Organismeprêteurautrecrédit === "CNEP"}>CNEP-Banque (Caisse Nationale d’Epargne et de Prévoyance- Banque-)</option>
                                                    <option value="BADR" selected={Organismeprêteurautrecrédit === "BADR"}> BADR (Banque de l’Agriculture et du Développement Rural)</option>
                                                    <option value="AL-BARAKA" selected={Organismeprêteurautrecrédit === "AL-BARAKA"}>AL BARAKA (Banque AL Baraka d’Algérie)</option>
                                                    <option value="CITIBANK" selected={Organismeprêteurautrecrédit === "CITIBANK"}>CITIBANK</option>
                                                    <option value="ABC" selected={Organismeprêteurautrecrédit === "ABC"}>ABC (Arab Banking Corporation Algeria)</option>
                                                    <option value="NATIXIS" selected={Organismeprêteurautrecrédit === "NATIXIS"}>Natixis ALGERIE</option>
                                                    <option value="SGA" selected={Organismeprêteurautrecrédit === "SGA"}> Société Générale Algérie</option>
                                                    <option value="BNP" selected={Organismeprêteurautrecrédit === "BNP"}> BNP Paribas Al-djazair</option>
                                                    <option value="TRUST-BANK" selected={Organismeprêteurautrecrédit === "TRUST-BANK"}> TRUST BANK Algeria</option>
                                                    <option value="Housing-Bank" selected={Organismeprêteurautrecrédit === "Housing-Bank"}>Housing Bank (The Housing Bank For Trade and Finance – Algeria)</option>
                                                    <option value="AGB" selected={Organismeprêteurautrecrédit === "AGB"}> AGB (Gulf Bank Algérie)</option>
                                                    <option value="FRANSABANK" selected={Organismeprêteurautrecrédit === "FRANSABANK"}>Crédit Agricole Corporate Et Investissement Bank Algérie  (Ex CALYON)</option>
                                                    <option value="FRANSABANK" selected={Organismeprêteurautrecrédit === "FRANSABANK"}>Fransabank Al-Djazair</option>
                                                    <option value="HSBC " selected={Organismeprêteurautrecrédit === "HSBC "}> HSBC Algeria</option>
                                                </select>
                                                <div className='alert-form'>{Showerr && (Organismeprêteurautrecrédit == "" ? (chargesetpatrimoine['Q3Organismeerr'][Lang]) : '')}</div>
                                            </div>
                                            <div className="col-md-12 mb-5">
                                                <label className="form-label">{(chargesetpatrimoine['Q3Date'][Lang])}</label>
                                                <input type="date" onChange={(e) => setDatedefinduautrecrédit(e.target.value)} value={Datedefinduautrecrédit} className="form-control" id="inputEmail4" />
                                                <div className='alert-form'>{Showerr && (Datedefinduautrecrédit == "" ? (chargesetpatrimoine['Q3Dateerr'][Lang]) : '')}</div>
                                            </div>
                                        </>
                                    }



                                    <div className="col-md-12 mb-2">
                                        <div className='mb-2'>{(chargesetpatrimoine['Q4'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio76" checked={Loyerpayer == 'oui'} onChange={(e) => setLoyerpayer(e.target.value)} defaultChecked={true} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio76">{(chargesetpatrimoine['r1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio86" checked={Loyerpayer == 'non'} onChange={(e) => setLoyerpayer(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio86">{(chargesetpatrimoine['r2'][Lang])}</label>
                                        </div>
                                    </div>

                                    {Loyerpayer === "oui" &&
                                        <>
                                            <div className="col-md-12 mb-1">
                                                <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q4Loyer'][Lang])}</label>
                                                <input type="text" placeholder='DA/دج' maxLength={10} className="form-control" onChange={(e) => setLoyer(e.target.value.replace(/[^0-9]+/g, ''))} value={Loyer} id="inputPassword4" />
                                                <div className='alert-form'>{Showerr && (Loyer == "" ? (chargesetpatrimoine['Q4Loyererr'][Lang]) : '')}</div>
                                            </div>
                                        </>}




                                    <div className="col-md-12 mb-2">
                                        <div className='mb-2'>{(chargesetpatrimoine['Q5'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions688" id="inlineRadio6887" checked={SéjourUSA == 'oui'} onChange={(e) => setSéjourUSA(e.target.value)} defaultChecked={true} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio6887">{(chargesetpatrimoine['r1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions1017" id="inlineRadio1017" checked={SéjourUSA == 'non'} onChange={(e) => setSéjourUSA(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio1017">{(chargesetpatrimoine['r2'][Lang])}</label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-2">
                                        <div className='mb-2'>{(chargesetpatrimoine['Q6'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions1111" id="inlineRadio1111" checked={GreenCard == 'oui'} onChange={(e) => setGreenCard(e.target.value)} defaultChecked={true} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio1111">{(chargesetpatrimoine['r1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions7300" id="inlineRadio7300" checked={GreenCard == 'non'} onChange={(e) => setGreenCard(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio7300">{(chargesetpatrimoine['r2'][Lang])}</label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-2">
                                        <div className='mb-2'>{(chargesetpatrimoine['Q7'][Lang])}</div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions130" id="inlineRadio130" checked={Compteépargne == 'oui'} onChange={(e) => setCompteépargne(e.target.value)} defaultChecked={true} defaultValue="oui" />
                                            <label className="form-check-label" htmlFor="inlineRadio130">{(chargesetpatrimoine['r1'][Lang])}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="inlineRadioOptions140" id="inlineRadio140" checked={Compteépargne == 'non'} onChange={(e) => setCompteépargne(e.target.value)} defaultValue="non" />
                                            <label className="form-check-label" htmlFor="inlineRadio140">{(chargesetpatrimoine['r2'][Lang])}</label>
                                        </div>
                                    </div>
                                    {Compteépargne === "oui" &&
                                        <>
                                            <div className="col-md-12 mb-1">
                                                <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q7épargne'][Lang])}</label>
                                                <input type="tel" maxLength={10} placeholder='DA/دج' className="form-control" onChange={(e) => setCompteépargneText(e.target.value.replace(/[^0-9]+/g, ''))} value={CompteépargneText} id="inputPassword4" />
                                                <span className='note-form'>{Global['Number'][Lang]}</span>
                                                <div className='alert-form'>{Showerr && (CompteépargneText.trim() == "" ? (chargesetpatrimoine['Q7épargneerr'][Lang]) : '')}</div>

                                            </div>
                                        </>}

                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="inputPassword4" className="form-label">{(chargesetpatrimoine['Q8'][Lang])}</label>
                                        <input maxLength={10} type="tel" placeholder='DA/دج' className="form-control" id="inputPassword4" onChange={(e) => setimmeublesoumeubles(e.target.value.replace(/[^0-9]+/g, ''))} value={immeublesoumeubles} />
                                        <span className='note-form'>{Global['Number'][Lang]}</span>     <br />
                                        <span className='note-form'>{(chargesetpatrimoine['msg'][Lang])}</span>
                                    </div>



                                    <div className="col-12 mt-5">
                                        <div onClick={() => GoNext()} className="store-next-btn">Modifier</div>
                                    </div>
                                </div></div>
                            : ''
                        }


                    </div>
                </div>
            </div>
        </div>

        // </div>
    )
}

export default UpdateVendeur